const ZONES = {
  NCR: [
    {
      region: "BATANES",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "ARNAIZ AVENUE  MAKATI",
              branchcode: "105301021",
            },
            {
              branchname: "AYALA MRT",
              branchcode: "105301558",
            },
            {
              branchname: "DIAN MAKATI",
              branchcode: "105301105",
            },
            {
              branchname: "HEART TOWER",
              branchcode: "105301920",
            },
            {
              branchname: "JP RIZAL",
              branchcode: "105301557",
            },
            {
              branchname: "MAKATI  EVANGELISTA",
              branchcode: "105301404",
            },
            {
              branchname: "MAKATI AVENUE",
              branchcode: "105301030",
            },
            {
              branchname: "RCBC Head Office",
              branchcode: "105301559",
            },
            {
              branchname: "PASAY ROAD",
              branchcode: "105301989",
            },
            {
              branchname: "PASONG TIRAD",
              branchcode: "105301170",
            },
            {
              branchname: "SOUTHGATE MALL MAKATI",
              branchcode: "105301128",
            },
            {
              branchname: "ML VALDEZ MAKATI",
              branchcode: "105301111",
            },
            {
              branchname: "ML Ayala Malls Circuit Makati",
              branchcode: "105301112",
            },
            {
              branchname: "ML One Ayala Makati",
              branchcode: "105301113",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "AYALA MARKET MARKET SHOWROOM",
              branchcode: "105302016",
            },
            {
              branchname: "C5  MAKATI",
              branchcode: "105302193",
            },
            {
              branchname: "COMEMBO",
              branchcode: "105302543",
            },
            {
              branchname: "GUADALUPE MAKATI",
              branchcode: "105302048",
            },
            {
              branchname: "MARKET MARKET MALL TAGUIG",
              branchcode: "105302068",
            },
            {
              branchname: "MERVILLE",
              branchcode: "105302587",
            },
            {
              branchname: "PEMBO  MAKATI",
              branchcode: "105302172",
            },
            {
              branchname: "PITOGO  KALAYAAN",
              branchcode: "105302899",
            },
            {
              branchname: "WESTERN BICUTAN",
              branchcode: "105302589",
            },
            {
              branchname: "PATEROS",
              branchcode: "105303547",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BAGUMBAYAN TAGUIG",
              branchcode: "105303043",
            },
            {
              branchname: "BALLEZER",
              branchcode: "105303978",
            },
            {
              branchname: "BETTER LIVING",
              branchcode: "105303590",
            },
            {
              branchname: "CENTRAL SIGNAL",
              branchcode: "105303307",
            },
            {
              branchname: "DON BOSCO PARANAQUE",
              branchcode: "105303095",
            },
            {
              branchname: "MAHARLIKA",
              branchcode: "105303934",
            },
            {
              branchname: "PINAGSAMA 2",
              branchcode: "105303069",
            },
            {
              branchname: "PINAGSAMA TAGUIG",
              branchcode: "105303022",
            },
            {
              branchname: "SAN MIGUEL TAGUIG",
              branchcode: "105303023",
            },
            {
              branchname: "TAGUIG",
              branchcode: "105303548",
            },
            {
              branchname: "USUSAN",
              branchcode: "105303078",
            },
            {
              branchname: "SM BICUTAN SHOWROOM",
              branchcode: "105303009",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "DON GALO",
              branchcode: "105304579",
            },
            {
              branchname: "F B HARRISON",
              branchcode: "105304556",
            },
            {
              branchname: "LIBERTAD PASAY",
              branchcode: "105304456",
            },
            {
              branchname: "MALIBAY PASAY CITY",
              branchcode: "105304403",
            },
            {
              branchname: "MALL OF ASIA SHOWROOM",
              branchcode: "105304946",
            },
            {
              branchname: "MARICABAN",
              branchcode: "105304586",
            },
            {
              branchname: "MIA ROAD",
              branchcode: "105304019",
            },
            {
              branchname: "NAIA 2",
              branchcode: "105304859",
            },
            {
              branchname: "VILLAMOR PASAY",
              branchcode: "105304020",
            },
            {
              branchname: "ILAYA LAS PINAS",
              branchcode: "105305611",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "BASCO BATANES",
              branchcode: "105305103",
            },
            {
              branchname: "BF PARANAQUE",
              branchcode: "105305183",
            },
            {
              branchname: "J AGUILAR AVENUE",
              branchcode: "105306094",
            },
            {
              branchname: "DR A SANTOS AVENUE",
              branchcode: "105305184",
            },
            {
              branchname: "EVACOM",
              branchcode: "105305033",
            },
            {
              branchname: "FOURTH ESTATE",
              branchcode: "105305093",
            },
            {
              branchname: "LAS PINAS REAL",
              branchcode: "105305582",
            },
            {
              branchname: "LAS PINAS 2",
              branchcode: "105305581",
            },
            {
              branchname: "PAMPLONA TRES STAR MALL LAS PINAS",
              branchcode: "105305176",
            },
            {
              branchname: "PULANGLUPA UNO",
              branchcode: "105305308",
            },
            {
              branchname: "ROBINSONS BF HOMES",
              branchcode: "105305954",
            },
            {
              branchname: "SAN ANTONIO VALLEY 1",
              branchcode: "105305099",
            },
            {
              branchname: "SUCAT ROAD",
              branchcode: "105305106",
            },
            {
              branchname: "SM SUCAT SHOWROOM",
              branchcode: "105305008",
            },
            {
              branchname: "ML LOPEZ PARANAQUE",
              branchcode: "105305116",
            },
          ],
        },
        {
          area: "Area F",
          BRANCHES: [
            {
              branchname: "ALABANG 1",
              branchcode: "105306591",
            },
            {
              branchname: "ALABANG 2",
              branchcode: "105306187",
            },
            {
              branchname: "ALMANZA UNO",
              branchcode: "105306305",
            },
            {
              branchname: "AYALA MALLS SOUTH PARK",
              branchcode: "105306071",
            },
            {
              branchname: "Las Pinas Warehuse",
              branchcode: "105306026",
            },
            {
              branchname: "FESTIVAL SHOWROOM",
              branchcode: "105306015",
            },
            {
              branchname: "MARCOS ALVAREZ AVENUE",
              branchcode: "105306080",
            },
            {
              branchname: "MUNTINLUPA",
              branchcode: "105306620",
            },
            {
              branchname: "PILAR LAS PINAS",
              branchcode: "105306040",
            },
            {
              branchname: "TALON",
              branchcode: "105306588",
            },
            {
              branchname: "TALON 1 SOUTHLAND",
              branchcode: "105306081",
            },
            {
              branchname: "TALON UNO",
              branchcode: "105306053",
            },
            {
              branchname: "TUNASAN MUNTINLUPA",
              branchcode: "105306038",
            },
            {
              branchname: "VERAVILLE",
              branchcode: "105306419",
            },
            {
              branchname: "BF RESORT LAS PINAS",
              branchcode: "105305381",
            },
            {
              branchname: "T.S. CRUZ ALMANZA DOS",
              branchcode: "105306108",
            },
          ],
        },
      ],
    },
    {
      region: "CENTRAL",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BARANGKA",
              branchcode: "105201918",
            },
            {
              branchname: "BONI 2",
              branchcode: "105201162",
            },
            {
              branchname: "BONI AVENUE",
              branchcode: "105201896",
            },
            {
              branchname: "CROSSING EDSA",
              branchcode: "105201444",
            },
            {
              branchname: "FABELLA 1",
              branchcode: "105201553",
            },
            {
              branchname: "FABELLA 2",
              branchcode: "105201554",
            },
            {
              branchname: "GREENHILLS SAN JUAN",
              branchcode: "105201140",
            },
            {
              branchname: "KALENTONG MANDALUYONG",
              branchcode: "105201337",
            },
            {
              branchname: "N DOMINGO",
              branchcode: "105201972",
            },
            {
              branchname: "SAN JUAN 1",
              branchcode: "105201562",
            },
            {
              branchname: "SAN JUAN 2 NCR RIZAL",
              branchcode: "105201563",
            },
            {
              branchname: "SHAW CENTER MALL",
              branchcode: "105201475",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "BAGUMBAYAN SAMPALOC",
              branchcode: "105202096",
            },
            {
              branchname: "CENTRAL MARKET",
              branchcode: "105202504",
            },
            {
              branchname: "DAPITAN MANILA",
              branchcode: "105202443",
            },
            {
              branchname: "LERMA",
              branchcode: "105202507",
            },
            {
              branchname: "QUIAPO",
              branchcode: "105202297",
            },
            {
              branchname: "SAMPALOC",
              branchcode: "105202510",
            },
            {
              branchname: "SH LOYOLA SAMPALOC MLA",
              branchcode: "105202147",
            },
            {
              branchname: "STOP N SHOP",
              branchcode: "105202089",
            },
            {
              branchname: "STA MESA 3",
              branchcode: "105202104",
            },
            {
              branchname: "G. TUAZON SAMPALOC",
              branchcode: "105202109",
            },
            {
              branchname: "DALUPAN GASTAMBIDE",
              branchcode: "105202121",
            }
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "ERMITA MANILA",
              branchcode: "105203182",
            },
            {
              branchname: "GEN LUNA",
              branchcode: "105203897",
            },
            {
              branchname: "GOOD EARTH PLAZA",
              branchcode: "105203987",
            },
            {
              branchname: "PACO MANILA",
              branchcode: "105203188",
            },
            {
              branchname: "PANDACAN MANILA",
              branchcode: "105203034",
            },
            {
              branchname: "PEDRO GIL 2",
              branchcode: "105203027",
            },
            {
              branchname: "PEDRO GIL 3",
              branchcode: "105203070",
            },
            {
              branchname: "SAN ANDRES",
              branchcode: "105203401",
            },
            {
              branchname: "SINGALONG",
              branchcode: "105203201",
            },
            {
              branchname: "TEJERON",
              branchcode: "105203895",
            },
            {
              branchname: "ML Panaderos",
              branchcode: "105203127",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "BALUT TONDO",
              branchcode: "105204452",
            },
            {
              branchname: "BLUMENTRITT",
              branchcode: "105204512",
            },
            {
              branchname: "CM RECTO",
              branchcode: "105204046",
            },
            {
              branchname: "DIVISORIA TONDO 3",
              branchcode: "105204240",
            },
            {
              branchname: "HERMOSA TONDO",
              branchcode: "105204309",
            },
            {
              branchname: "LRT TAYUMAN",
              branchcode: "105204045",
            },
            {
              branchname: "TAYUMAN MANILA",
              branchcode: "105204527",
            },
            {
              branchname: "TONDO 1",
              branchcode: "105204522",
            },
            {
              branchname: "TONDO 2",
              branchcode: "105204523",
            },
            {
              branchname: "TUTUBAN",
              branchcode: "105204416",
            },
            {
              branchname: "ZARAGOSA TONDO",
              branchcode: "105204831",
            },
            {
              branchname: "",
              branchcode: "",
            },
          ],
        },
      ],
    },
    {
      region: "NORTH",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BAGBAGUIN",
              branchcode: "106801413",
            },
            {
              branchname: "BAGONG SILANG",
              branchcode: "106801969",
            },
            {
              branchname: "BAGONG SILANG 2",
              branchcode: "106801115",
            },
            {
              branchname: "BAGONG SILANG 3",
              branchcode: "106801063",
            },
            {
              branchname: "BAGUMBONG",
              branchcode: "106801064",
            },
            {
              branchname: "GULOD NOVALICHES",
              branchcode: "106801129",
            },
            {
              branchname: "LLANO",
              branchcode: "106801061",
            },
            {
              branchname: "NOVALICHES",
              branchcode: "106801980",
            },
            {
              branchname: "NOVALICHES 2",
              branchcode: "106801074",
            },
            {
              branchname: "STA LUCIA NOVALICHES",
              branchcode: "106801301",
            },
            {
              branchname: "SUSANO ROAD",
              branchcode: "106801054",
            },
            {
              branchname: "ZABARTE TOWN CENTER",
              branchcode: "106801267",
            },
            {
              branchname: "ZAPOTE KIKO CAMARIN",
              branchcode: "106801266",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "A MABINI CALOOCAN",
              branchcode: "106802079",
            },
            {
              branchname: "APAHAP NAVOTAS",
              branchcode: "106802898",
            },
            {
              branchname: "CALOOCAN 2",
              branchcode: "106802516",
            },
            {
              branchname: "CALOOCAN 3 LIBIS",
              branchcode: "106802517",
            },
            {
              branchname: "CONCEPCION MALABON",
              branchcode: "106802513",
            },
            {
              branchname: "GEN T VALENZUELA",
              branchcode: "106802672",
            },
            {
              branchname: "HULO MALABON",
              branchcode: "106802514",
            },
            {
              branchname: "KARUHATAN",
              branchcode: "106802518",
            },
            {
              branchname: "LONGOS MALABON",
              branchcode: "106802082",
            },
            {
              branchname: "M NAVAL NAVOTAS",
              branchcode: "106802051",
            },
            {
              branchname: "MALANDAY",
              branchcode: "106802519",
            },
            {
              branchname: "MAYPAJO KALOOCAN",
              branchcode: "106802036",
            },
            {
              branchname: "NAVOTAS",
              branchcode: "106802052",
            },
            {
              branchname: "POLO",
              branchcode: "106802521",
            },
            {
              branchname: "TANGOS NAVOTAS",
              branchcode: "106802238",
            },
            {
              branchname: "TANONG MALABON CITY",
              branchcode: "106802178",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BATASAN HILLS QC",
              branchcode: "106803526",
            },
            {
              branchname: "DAHLIA",
              branchcode: "106803505",
            },
            {
              branchname: "HOLY SPIRIT 2",
              branchcode: "106803332",
            },
            {
              branchname: "HOLY SPIRIT QC",
              branchcode: "106803525",
            },
            {
              branchname: "LAGRO",
              branchcode: "106803506",
            },
            {
              branchname: "LITEX",
              branchcode: "106803073",
            },
            {
              branchname: "LUZON AVENUE",
              branchcode: "106803508",
            },
            {
              branchname: "OLD BALARA QUEZON CITY",
              branchcode: "106803235",
            },
            {
              branchname: "QUIRINO HIGHWAY",
              branchcode: "106803439",
            },
            {
              branchname: "VILLONGCO",
              branchcode: "106803524",
            },
            {
              branchname: "ML AYALA MALL FAIRVIEW TERRACES",
              branchcode: "106803122",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "AMORANTO",
              branchcode: "106804055",
            },
            {
              branchname: "ARANETA AVENUE",
              branchcode: "106804039",
            },
            {
              branchname: "ARAYAT CUBAO QUEZON CITY",
              branchcode: "106804047",
            },
            {
              branchname: "DIAMOND ARCADE",
              branchcode: "106804125",
            },
            {
              branchname: "EASTWOOD CITY",
              branchcode: "106804455",
            },
            {
              branchname: "FARMERS PLAZA",
              branchcode: "106804362",
            },
            {
              branchname: "FRISCO",
              branchcode: "106804960",
            },
            {
              branchname: "GALAS",
              branchcode: "106804555",
            },
            {
              branchname: "KAMUNING QC",
              branchcode: "106804390",
            },
            {
              branchname: "KATIPUNAN QUEZON CITY",
              branchcode: "106804058",
            },
            {
              branchname: "MURPHY",
              branchcode: "106804534",
            },
            {
              branchname: "STA MESA 2",
              branchcode: "106804049",
            },
            {
              branchname: "EASTWOOD CITY",
              branchcode: "106804455",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "BAGO BANTAY PROJ 7",
              branchcode: "106805509",
            },
            {
              branchname: "BAGONG BARRIO",
              branchcode: "106805212",
            },
            {
              branchname: "BANLAT",
              branchcode: "106805072",
            },
            {
              branchname: "CENTRAL DILIMAN",
              branchcode: "106805156",
            },
            {
              branchname: "CULIAT",
              branchcode: "106805025",
            },
            {
              branchname: "MONUMENTO",
              branchcode: "106805959",
            },
            {
              branchname: "PHILCOA QUEZON CITY",
              branchcode: "106805028",
            },
            {
              branchname: "ROOSEVELT",
              branchcode: "106805425",
            },
            {
              branchname: "SHORTHORN",
              branchcode: "106805157",
            },
            {
              branchname: "TANDANG SORA",
              branchcode: "106805511",
            },
            {
              branchname: "TRINOMA SHOWROOM",
              branchcode: "106805369",
            },
          ],
        },
      ],
    },
    {
      region: "RIZAL",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "AMPID RIZAL",
              branchcode: "105101528",
            },
            {
              branchname: "BANABA",
              branchcode: "105101529",
            },
            {
              branchname: "CONCEPCION MARIKINA",
              branchcode: "105101530",
            },
            {
              branchname: "EASTWOOD MONTALBAN",
              branchcode: "105101272",
            },
            {
              branchname: "MONTALBAN 1",
              branchcode: "105101532",
            },
            {
              branchname: "MONTALBAN 2",
              branchcode: "105101533",
            },
            {
              branchname: "MONTALBAN 3",
              branchcode: "105101922",
            },
            {
              branchname: "NANGKA MARIKINA",
              branchcode: "105101091",
            },
            {
              branchname: "SAN ISIDRO RODRIGUEZ RIZAL",
              branchcode: "105101957",
            },
            {
              branchname: "SAN MATEO 1",
              branchcode: "105101535",
            },
            {
              branchname: "SAN MATEO 2",
              branchcode: "105101536",
            },
            {
              branchname: "TAGUMPAY",
              branchcode: "105101270",
            },
            {
              branchname: "TUMANA MARIKINA",
              branchcode: "105101149",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "ANTIPOLO",
              branchcode: "105102540",
            },
            {
              branchname: "ANTIPOLO 2",
              branchcode: "105102255",
            },
            {
              branchname: "ANTIPOLO 3",
              branchcode: "105102341",
            },
            {
              branchname: "CAINTA",
              branchcode: "105102542",
            },
            {
              branchname: "CAINTA 2",
              branchcode: "105102100",
            },
            {
              branchname: "CK MALL CAINTA",
              branchcode: "105102018",
            },
            {
              branchname: "COGEO 2",
              branchcode: "105102340",
            },
            {
              branchname: "COGEO RIZAL",
              branchcode: "105102908",
            },
            {
              branchname: "RIVERSIDE STA LUCIA PASIG",
              branchcode: "105102092",
            },
            {
              branchname: "STA LUCIA PASIG",
              branchcode: "105102306",
            },
            {
              branchname: "TIKLING",
              branchcode: "105102958",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BAGONG ILOG",
              branchcode: "105103060",
            },
            {
              branchname: "KAPASIGAN",
              branchcode: "105103290",
            },
            {
              branchname: "MERCEDES PASIG",
              branchcode: "105103923",
            },
            {
              branchname: "PASIG",
              branchcode: "105103857",
            },
            {
              branchname: "PINAGBUHATAN",
              branchcode: "105103383",
            },
            {
              branchname: "ROSARIO 3 PASIG",
              branchcode: "105103041",
            },
            {
              branchname: "ROSARIO PASIG",
              branchcode: "105103909",
            },
            {
              branchname: "ROSARIO PASIG 2",
              branchcode: "105103117",
            },
            {
              branchname: "SAN JOAQUIN",
              branchcode: "105103221",
            },
            {
              branchname: "SAN MIGUEL PASIG",
              branchcode: "105103437",
            },
            {
              branchname: "SANDOVAL 2 PASIG",
              branchcode: "105103098",
            },
            {
              branchname: "SANDOVAL PASIG",
              branchcode: "105103084",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "ANGONO",
              branchcode: "105104539",
            },
            {
              branchname: "ANGONO 2",
              branchcode: "105104086",
            },
            {
              branchname: "BARAS RIZAL",
              branchcode: "105104256",
            },
            {
              branchname: "BINANGONAN",
              branchcode: "105104541",
            },
            {
              branchname: "BINANGONAN 2",
              branchcode: "105104465",
            },
            {
              branchname: "BINANGONAN 4",
              branchcode: "105104056",
            },
            {
              branchname: "BINANGONAN 5",
              branchcode: "105104083",
            },
            {
              branchname: "BINANGONAN 6",
              branchcode: "105104090",
            },
            {
              branchname: "CARDONA RIZAL",
              branchcode: "105104354",
            },
            {
              branchname: "FLOODWAY",
              branchcode: "105104924",
            },
            {
              branchname: "MORONG",
              branchcode: "105104545",
            },
            {
              branchname: "TANAY",
              branchcode: "105104549",
            },
            {
              branchname: "TERESA",
              branchcode: "105104289",
            },
            {
              branchname: "ML BUHANGIN BINANGONAN",
              branchcode: "105104131",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "HILLSIDE PLAZA MAYAMOT",
              branchcode: "105105085",
            },
            {
              branchname: "MALANDAY MARIKINA",
              branchcode: "105105062",
            },
            {
              branchname: "MARCOS HIWAY",
              branchcode: "105105476",
            },
            {
              branchname: "MARIKINA HEIGHTS",
              branchcode: "105105262",
            },
            {
              branchname: "MASINAG ANTIPOLO",
              branchcode: "105105495",
            },
            {
              branchname: "MAYAMOT",
              branchcode: "105105355",
            },
            {
              branchname: "PANORAMA",
              branchcode: "105105883",
            },
            {
              branchname: "PARANG MARIKINA",
              branchcode: "105105299",
            },
            {
              branchname: "SUMULONG 1",
              branchcode: "105105537",
            },
            {
              branchname: "SUMULONG 2",
              branchcode: "105105538",
            },
            {
              branchname: "SUMULONG 3",
              branchcode: "105105241",
            },
          ],
        },
      ],
    },
  ],
  LUZON: [
    {
      region: "ALMASOR REGION",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BACACAY 2",
              branchcode: "115501553",
            },
            {
              branchname: "BITANO",
              branchcode: "115501900",
            },
            {
              branchname: "ILAWOD",
              branchcode: "115501048",
            },
            {
              branchname: "LEGASPI",
              branchcode: "115501681",
            },
            {
              branchname: "RAWIS",
              branchcode: "115501493",
            },
            {
              branchname: "STO DOMINGO",
              branchcode: "115501548",
            },
            {
              branchname: "TABACO 1",
              branchcode: "115501682",
            },
            {
              branchname: "TABACO 2",
              branchcode: "115501683",
            },
            {
              branchname: "TABACO 3",
              branchcode: "115501076",
            },
            {
              branchname: "TIWI ALBAY",
              branchcode: "115501447",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "CAMALIG ALBAY",
              branchcode: "115502687",
            },
            {
              branchname: "CUMADCAD SORSOGON",
              branchcode: "115502248",
            },
            {
              branchname: "DARAGA 2",
              branchcode: "115502680",
            },
            {
              branchname: "GUINOBATAN",
              branchcode: "115502913",
            },
            {
              branchname: "LIBON ALBAY",
              branchcode: "115502823",
            },
            {
              branchname: "LIGAO ALBAY",
              branchcode: "115502912",
            },
            {
              branchname: "OAS ALBAY",
              branchcode: "115502821",
            },

            {
              branchname: "PILAR",
              branchcode: "115502706",
            },
            {
              branchname: "PIODURAN ALBAY",
              branchcode: "115502845",
            },
            {
              branchname: "POLANGUI",
              branchcode: "115502693",
            },
             {
              branchname: "ML MATACON",
              branchcode: "115502121",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BARCELONA",
              branchcode: "115503049",
            },
            {
              branchname: "BULAN",
              branchcode: "115503697",
            },
            {
              branchname: "BULUSAN",
              branchcode: "115503851",
            },
            {
              branchname: "CASIGURAN SORSOGON",
              branchcode: "115503839",
            },
            {
              branchname: "CITY MALL SORSOGON",
              branchcode: "115503530",
            },
            {
              branchname: "GUBAT",
              branchcode: "115503698",
            },
            {
              branchname: "IROSIN SORSOGON",
              branchcode: "115503126",
            },
            {
              branchname: "JUBAN SORSOGON",
              branchcode: "115503030",
            },
            {
              branchname: "MATNOG",
              branchcode: "115503080",
            },
            {
              branchname: "PRIETO DIAZ",
              branchcode: "115503045",
            },
            {
              branchname: "SORSOGON 1",
              branchcode: "115503701",
            },
            {
              branchname: "SORSOGON 3",
              branchcode: "115503294",
            },
            {
              branchname: "CABID AN",
              branchcode: "115503545",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "AROROY",
              branchcode: "115504696",
            },
            {
              branchname: "AROROY 2",
              branchcode: "115504862",
            },
            {
              branchname: "BALENO MASBATE",
              branchcode: "115504036",
            },
            {
              branchname: "BALUD MASBATE",
              branchcode: "115504458",
            },
            {
              branchname: "GAISANO MASBATE",
              branchcode: "115504417",
            },
            {
              branchname: "MANDAON MASBATE",
              branchcode: "115504236",
            },
            {
              branchname: "MASBATE 2",
              branchcode: "115504700",
            },
            {
              branchname: "MILAGROS MASBATE",
              branchcode: "115504422",
            },
            {
              branchname: "QUEZON MASBATE",
              branchcode: "115504705",
            },
            {
              branchname: "SAN FERNANDO MASBATE",
              branchcode: "115504566",
            },
            {
              branchname: "SAN JACINTO",
              branchcode: "115504265",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "CATAINGAN",
              branchcode: "115505703",
            },
            {
              branchname: "CAWAYAN MASBATE",
              branchcode: "115505108",
            },
            {
              branchname: "DIMASALANG MASBATE",
              branchcode: "115505956",
            },
            {
              branchname: "MAGSAYSAY CATAINGAN",
              branchcode: "115505901",
            },
            {
              branchname: "MOBO MASBATE",
              branchcode: "115505147",
            },
            {
              branchname: "PALANAS MASBATE",
              branchcode: "115505361",
            },
            {
              branchname: "PLACER",
              branchcode: "115505967",
            },
            {
              branchname: "USON MASBATE",
              branchcode: "115505245",
            },
          ],
        },
      ],
    },
    {
      region: "BAZAM REGION",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "ALA ULI",
              branchcode: "116401531",
            },
            {
              branchname: "ALAS ASIN",
              branchcode: "116401375",
            },
            {
              branchname: "BAGAC",
              branchcode: "116401376",
            },
            {
              branchname: "BALAGTAS ORION BATAAN",
              branchcode: "116401985",
            },
            {
              branchname: "LAMAO LIMAY BATAAN",
              branchcode: "116401346",
            },
            {
              branchname: "LIMAY 2 BATAAN",
              branchcode: "116401309",
            },
            {
              branchname: "LIMAY BATAAN",
              branchcode: "116401113",
            },
            {
              branchname: "MARIVELES 2",
              branchcode: "116401402",
            },
            {
              branchname: "ML COLLAT MASINLOC",
              branchcode: "116405165",
            },
            {
              branchname: "MORONG BATAAN",
              branchcode: "116401952",
            },
            {
              branchname: "ORION BATAAN",
              branchcode: "116401114",
            },
            {
              branchname: "PILAR BATAAN",
              branchcode: "116401323",
            },
            {
              branchname: "REFORMISTA",
              branchcode: "116401953",
            },
            {
              branchname: "TOWNSITE MARIVELES BATAAN",
              branchcode: "116401146",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "ABUCAY",
              branchcode: "116402280",
            },
            {
              branchname: "BALANGA 2",
              branchcode: "116402186",
            },
            {
              branchname: "BALANGA BATAAN",
              branchcode: "116402731",
            },
            {
              branchname: "BONIFACIO",
              branchcode: "116402561",
            },
            {
              branchname: "CALAYLAYAN",
              branchcode: "116402252",
            },
            {
              branchname: "DINALUPIHAN",
              branchcode: "116402733",
            },
            {
              branchname: "HERMOSA BATAAN",
              branchcode: "116402344",
            },
            {
              branchname: "MULAWIN",
              branchcode: "1116402335",
            },
            {
              branchname: "ORANI BATAAN",
              branchcode: "116402977",
            },
            {
              branchname: "PALIHAN HERMOSA",
              branchcode: "116402255",
            },
            {
              branchname: "SAMAL BATAAN",
              branchcode: "116402279",
            },
            {
              branchname: "SAN RAMON",
              branchcode: "116402394",
            },
            {
              branchname: "TABING ILOG",
              branchcode: "116402326",
            },
            {
              branchname: "TUGATOG",
              branchcode: "116402473",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BARRETTO",
              branchcode: "116403732",
            },
            {
              branchname: "BARRETTO 2",
              branchcode: "116403212",
            },
            {
              branchname: "NEW ASINAN OLONGAPO",
              branchcode: "116403322",
            },
            {
              branchname: "NEW CABALAN",
              branchcode: "116403536",
            },
            {
              branchname: "NEW KALALAKE",
              branchcode: "116403450",
            },
            {
              branchname: "OLONGAPO 1",
              branchcode: "116403735",
            },
            {
              branchname: "OLONGAPO 2",
              branchcode: "116403736",
            },
            {
              branchname: "OLONGAPO 3",
              branchcode: "116403143",
            },
            {
              branchname: "OLONGAPO 4",
              branchcode: "116403228",
            },
            {
              branchname: "OLONGAPO 6",
              branchcode: "116403478",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "CALAPACUAN SUBIC",
              branchcode: "116404881",
            },
            {
              branchname: "CALAPANDAYAN",
              branchcode: "116404877",
            },
            {
              branchname: "CASTILLEJOS",
              branchcode: "116404968",
            },
            {
              branchname: "CASTILLEJOS 2",
              branchcode: "116404351",
            },
            {
              branchname: "DEL PILAR CASTILLEJOS",
              branchcode: "116404672",
            },
            {
              branchname: "ILWAS SUBIC",
              branchcode: "116404938",
            },
            {
              branchname: "MATAIN SUBIC",
              branchcode: "116404176",
            },
            {
              branchname: "RIZAL SAN ANTONIO 2 ZAMBALES",
              branchcode: "116404124",
            },
            {
              branchname: "SAN AGUSTIN CASTILLEJOS",
              branchcode: "116404266",
            },
            {
              branchname: "SAN ANTONIO ZAMBALES",
              branchcode: "116404740",
            },
            {
              branchname: "SAN MARCELINO ZAMBALES",
              branchcode: "116404907",
            },
            {
              branchname: "SAN NARCISO",
              branchcode: "116404086",
            },
            {
              branchname: "SUBIC",
              branchcode: "116404737",
            },
            {
              branchname: "SUBIC 2",
              branchcode: "116404065",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "BOTOLAN ZAMBALES",
              branchcode: "116405168",
            },
            {
              branchname: "CABANGAN ZAMBALES",
              branchcode: "116405131",
            },
            {
              branchname: "CANDELARIA ZAMBALES",
              branchcode: "116405871",
            },
            {
              branchname: "IBA 2 ZAMBALES",
              branchcode: "116405442",
            },
            {
              branchname: "IBA TOWN CENTER MALL",
              branchcode: "116405373",
            },
            {
              branchname: "IBA ZAMBALES",
              branchcode: "116405778",
            },
            {
              branchname: "MASINLOC 2",
              branchcode: "116405482",
            },
            {
              branchname: "PALANGINAN IBA",
              branchcode: "116405436",
            },
            {
              branchname: "PALAUIG ZAMBALES",
              branchcode: "116405174",
            },
            {
              branchname: "SAN FELIPE 2 ZAMBALES",
              branchcode: "116405856",
            },
            {
              branchname: "SAN FELIPE ZAMBALES",
              branchcode: "116405789",
            },
            {
              branchname: "STA CRUZ 2 ZAMBALES",
              branchcode: "116405273",
            },
            {
              branchname: "STA CRUZ ZAMBALES",
              branchcode: "116405786",
            },
            {
              branchname: "ML Taugtog, Botolan",
              branchcode: "116405628",
            },
            {
              branchname: "ML COLLAT MASINLOC",
              branchcode: "116405165",
            },
          ],
        },
      ],
    },
    {
      region: "BULACAN REGION",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "MUZON BULACAN",
              branchcode: "116501742",
            },
            {
              branchname: "MUZON 2",
              branchcode: "116501187",
            },
            {
              branchname: "SAPANG PALAY",
              branchcode: "116501727",
            },
            {
              branchname: "SAPANG PALAY 2",
              branchcode: "116501911",
            },
            {
              branchname: "TUNGKONG MANGGA",
              branchcode: "116501316",
            },
            {
              branchname: "TUNGKONG MANGGA 2",
              branchcode: "116501388",
            },
            {
              branchname: "TUNGKONG MANGGA 3",
              branchcode: "116501413",
            },
            {
              branchname: "CITRUS",
              branchcode: "116501445",
            },
            {
              branchname: "MINUYAN",
              branchcode: "116501440",
            },
            {
              branchname: "STO CRISTO CSJDM BULACAN",
              branchcode: "116501713",
            },
            {
              branchname: "POBLACION SJDM",
              branchcode: "116501551",
            },
            {
              branchname: "HARMONY HILLS MUZON",
              branchcode: "116501895",
            },
            {
              branchname: "FVR FRIENDSHIP VILLAGE RESOURCES",
              branchcode: "116501866",
            },
            {
              branchname: "ML ASSUMPTION BRANCH",
              branchcode: "116501574",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "MEYCAUAYAN",
              branchcode: "116502723",
            },
            {
              branchname: "MEYCAUAYAN 2",
              branchcode: "116502411",
            },
            {
              branchname: "PACHECO",
              branchcode: "116502906",
            },
            {
              branchname: "MALHACAN",
              branchcode: "116502244",
            },
            {
              branchname: "STO NINO CENTRAL LUZON",
              branchcode: "116502741",
            },
            {
              branchname: "CAMALIG MEYCAUAYAN",
              branchcode: "116502858",
            },
            {
              branchname: "OBANDO BULACAN",
              branchcode: "116502520",
            },
            {
              branchname: "PACO OBANDO",
              branchcode: "116502350",
            },
            {
              branchname: "STA ROSA MARILAO",
              branchcode: "116502349",
            },
            {
              branchname: "MARILAO",
              branchcode: "116502067",
            },
            {
              branchname: "LOMA DE GATO MARILAO",
              branchcode: "116501237",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BULAKAN BULACAN",
              branchcode: "116502190",
            },
            {
              branchname: "BALAGTAS",
              branchcode: "116502720",
            },
            {
              branchname: "BALAGTAS 2",
              branchcode: "116502407",
            },
            {
              branchname: "WAWA BALAGTAS",
              branchcode: "116502271",
            },
            {
              branchname: "BOCAUE",
              branchcode: "116502721",
            },
            {
              branchname: "TAMBUBONG BOCAUE",
              branchcode: "116505611",
            },
            {
              branchname: "LOLOMBOY BOCAUE",
              branchcode: "116502529",
            },
            {
              branchname: "GUIGUINTO",
              branchcode: "116503453",
            },
            {
              branchname: "GUIGUINTO 2",
              branchcode: "116503154",
            },
            {
              branchname: "STA RITA",
              branchcode: "116504081",
            },
            {
              branchname: "PLARIDEL 2",
              branchcode: "116504182",
            },
            {
              branchname: "PLARIDEL BULACAN",
              branchcode: "116504724",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "PULILAN",
              branchcode: "116503274",
            },
            {
              branchname: "PULILAN 2",
              branchcode: "116503183",
            },
            {
              branchname: "MALOLOS BULACAN",
              branchcode: "116503964",
            },
            {
              branchname: "MALOLOS 2",
              branchcode: "116503102",
            },
            {
              branchname: "MALOLOS 3",
              branchcode: "116503490",
            },
            {
              branchname: "MALOLOS 4",
              branchcode: "116503327",
            },
            {
              branchname: "MALOLOS 5",
              branchcode: "116503270",
            },
            {
              branchname: "BAGNA MALOLOS",
              branchcode: "116503534",
            },
            {
              branchname: "HAGONOY 2 BULACAN",
              branchcode: "116503023",
            },
            {
              branchname: "PAOMBONG BULACAN",
              branchcode: "116503324",
            },
            {
              branchname: "CALUMPIT",
              branchcode: "116503277",
            },
            {
              branchname: "CALUMPIT 2",
              branchcode: "116503142",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "PLAZA NANING",
              branchcode: "116504915",
            },
            {
              branchname: "POBLACION BALIUAG",
              branchcode: "116504181",
            },
            {
              branchname: "TANGOS BALIUAG",
              branchcode: "116504832",
            },
            {
              branchname: "SAN JOSE BALIUAG",
              branchcode: "116504070",
            },
            {
              branchname: "SAN MIGUEL",
              branchcode: "116504726",
            },
            {
              branchname: "SAN MIGUEL 2",
              branchcode: "116504005",
            },
            {
              branchname: "SIBUL SAN MIGUEL",
              branchcode: "116504471",
            },
            {
              branchname: "SAN ILDEFONSO",
              branchcode: "116504725",
            },
            {
              branchname: "SAN RAFAEL",
              branchcode: "116504976",
            },
            {
              branchname: "POBLACION SAN RAFAEL",
              branchcode: "116504272",
            },
            {
              branchname: "BUSTOS BULACAN",
              branchcode: "116504275",
            },
            {
              branchname: "SAN JOSE PLARIDEL BULACAN",
              branchcode: "116504537",
            },
             {
              branchname: "LICIADA BUSTOS",
              branchcode: "116505159",
            },
          ],
        },
        {
          area: "Area F",
          BRANCHES: [
            {
              branchname: "STA MARIA 1 BULACAN",
              branchcode: "116505728",
            },
            {
              branchname: "STA MARIA 2 BULACAN",
              branchcode: "116505729",
            },
            {
              branchname: "STA MARIA 3 BULACAN",
              branchcode: "116505155",
            },
            {
              branchname: "CAYPOMBO BULACAN",
              branchcode: "116505055",
            },
            {
              branchname: "PULONG BUHANGIN",
              branchcode: "116505090",
            },
            {
              branchname: "ANGAT BULACAN",
              branchcode: "116505315",
            },
            {
              branchname: "NORZAGARAY",
              branchcode: "116505218",
            },
            {
              branchname: "BIGTE",
              branchcode: "116501406",
            },
            {
              branchname: "PANDI 1 BULACAN",
              branchcode: "116505250",
            },
            {
              branchname: "PANDI 2",
              branchcode: "116505140",
            },
            {
              branchname: "BUNSURAN PANDI",
              branchcode: "116505854",
            },
          ],
        },
      ],
    },
    {
      region: "CAMACAT REGION",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BASUD",
              branchcode: "116601157",
            },
            {
              branchname: "CAPALONGA",
              branchcode: "116601092",
            },
            {
              branchname: "DAET",
              branchcode: "116601688",
            },
            {
              branchname: "DAET 3",
              branchcode: "116601299",
            },
            {
              branchname: "LABO",
              branchcode: "116601695",
            },
            {
              branchname: "LAG ON DAET",
              branchcode: "116601883",
            },
            {
              branchname: "LIBMANAN CAMARINES SUR",
              branchcode: "116601166",
            },
            {
              branchname: "MERCEDES CAM NORTE",
              branchcode: "116601032",
            },
            {
              branchname: "SIPOCOT",
              branchcode: "116601694",
            },
            {
              branchname: "STA ELENA CAM NORTE",
              branchcode: "116601418",
            },
            {
              branchname: "TALISAY",
              branchcode: "116601936",
            },
            {
              branchname: "TALOBATIB",
              branchcode: "116601164",
            },
            {
              branchname: "VINZONS DAET",
              branchcode: "116601931",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "BAGUMBAYAN SUR",
              branchcode: "116602162",
            },
            {
              branchname: "CALABANGA CAMARINES SUR",
              branchcode: "116602196",
            },
            {
              branchname: "DEL ROSARIO NAGA",
              branchcode: "116602562",
            },
            {
              branchname: "GOA CAMARINES SUR",
              branchcode: "116602018",
            },
            {
              branchname: "LAGONOY",
              branchcode: "116602552",
            },
            {
              branchname: "MILAOR",
              branchcode: "116602399",
            },
            {
              branchname: "NAGA 2 BICOL",
              branchcode: "116602063",
            },

            {
              branchname: "NAGA 4",
              branchcode: "116602285",
            },
            {
              branchname: "NAGA 5",
              branchcode: "116602312",
            },

            {
              branchname: "NAGA BICOL",
              branchcode: "116602691",
            },
            {
              branchname: "OCAMPO",
              branchcode: "116602222",
            },

            {
              branchname: "PASACAO",
              branchcode: "116602496",
            },
            {
              branchname: "PILI",
              branchcode: "116602692",
            },

            {
              branchname: "SAGNAY",
              branchcode: "116602509",
            },
            {
              branchname: "SM CITY NAGA",
              branchcode: "116602844",
            },
            {
              branchname: "TIGAON CAMARINES SUR",
              branchcode: "116602197",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "BAAO CAMARINES SUR",
              branchcode: "116603438",
            },
            {
              branchname: "BATO",
              branchcode: "116603855",
            },
            {
              branchname: "BUHI",
              branchcode: "116603835",
            },
            {
              branchname: "BULA CAMARINES SUR",
              branchcode: "116603195",
            },
            {
              branchname: "CARAMOAN",
              branchcode: "1116603297",
            },
            {
              branchname: "CARAMORAN",
              branchcode: "116603437",
            },
            {
              branchname: "IRIGA 1",
              branchcode: "116603689",
            },
            {
              branchname: "IRIGA 2",
              branchcode: "116603690",
            },
            {
              branchname: "IRIGA 3",
              branchcode: "116603077",
            },
            {
              branchname: "NABUA",
              branchcode: "116603522",
            },
            {
              branchname: "SAN ANDRES CATANDUANES",
              branchcode: "116603686",
            },
            {
              branchname: "VIGA",
              branchcode: "116603170",
            },
            {
              branchname: "VIRAC 1",
              branchcode: "116603684",
            },
            {
              branchname: "VIRAC 2",
              branchcode: "116603685",
            },
            {
              branchname: "SAN NICOLAS IRIGA CITY",
              branchcode: "116603521",
            },
            {
              branchname: "BARAS CATANDUANES",
              branchcode: "116603523",
            },
             {
              branchname: "SAN MIGUEL IRIGA",
              branchcode: "116603941",
            },
            {
              branchname: "ML NABUA 2",
              branchcode: "116603699",
            },
          ],
        },
      ],
    },
    {
      region: "LAGUNA REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BINAN LAGUNA",
              branchcode: "116701592",
            },
            {
              branchname: "BONIFACIO LAGUNA",
              branchcode: "116701621",
            },
            {
              branchname: "CALENDOLA",
              branchcode: "116701599",
            },
            {
              branchname: "CENTRAL MALL BINAN",
              branchcode: "116701069",
            },
            {
              branchname: "LANDAYAN",
              branchcode: "116701267",
            },
            {
              branchname: "MABINI LAGUNA",
              branchcode: "116701975",
            },
            {
              branchname: "PACITA LAGUNA",
              branchcode: "116701596",
            },
            {
              branchname: "ROSARIO COMPLEX LAGUNA",
              branchcode: "116701483",
            },
            {
              branchname: "SAN ANTONIO LAGUNA",
              branchcode: "116701317",
            },
            {
              branchname: "STO TOMAS BINAN",
              branchcode: "116701535",
            },
            {
              branchname: "TIMBAO",
              branchcode: "116701506",
            },
            {
              branchname: "UNITED BAYANIHAN",
              branchcode: "116701993",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BANAY BANAY",
              branchcode: "116702310",
            },
            {
              branchname: "BANLIC CABUYAO",
              branchcode: "116702082",
            },
            {
              branchname: "DITA",
              branchcode: "116702942",
            },
            {
              branchname: "F REYES",
              branchcode: "116702149",
            },
            {
              branchname: "GOLDEN CITY",
              branchcode: "116702223",
            },
            {
              branchname: "MAMATID",
              branchcode: "116702173",
            },
            {
              branchname: "PULONG STA CRUZ",
              branchcode: "116702514",
            },
            {
              branchname: "ROBINSON STA ROSA",
              branchcode: "116702200",
            },
            {
              branchname: "SAN ISIDRO CABUYAO",
              branchcode: "116702141",
            },
            {
              branchname: "SAN LORENZO STA ROSA LAGUNA",
              branchcode: "116702922",
            },
            {
              branchname: "STA ROSA COMPLEX 2",
              branchcode: "116702291",
            },
            {
              branchname: "STA ROSA BAYAN",
              branchcode: "116702135",
            },
            {
              branchname: "STA ROSA LAGUNA",
              branchcode: "116702595",
            },
            {
              branchname: "CABUYAO 2 LAGUNA",
              branchcode: "116702981",
            },
            {
              branchname: "SAN ISIDRO 2 CABUYAO",
              branchcode: "116702989",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALAMINOS LAGUNA",
              branchcode: "116703635",
            },
            {
              branchname: "BUCAL",
              branchcode: "116703948",
            },
            {
              branchname: "CALAMBA LAGUNA",
              branchcode: "116703636",
            },
            {
              branchname: "CANLUBANG",
              branchcode: "116703485",
            },
            {
              branchname: "COLAGO AVE SAN PABLO CITY",
              branchcode: "116703072",
            },
            {
              branchname: "DON BOSCO MAYAPA",
              branchcode: "116703153",
            },
            {
              branchname: "JP RIZAL CALAMBA",
              branchcode: "116703896",
            },
            {
              branchname: "LILIW",
              branchcode: "116703480",
            },
            {
              branchname: "M BASA",
              branchcode: "116703648",
            },
            {
              branchname: "MAHARLIKA SAN PABLO CITY",
              branchcode: "116703241",
            },
            {
              branchname: "MAKILING",
              branchcode: "116703507",
            },
            {
              branchname: "MAYAPA",
              branchcode: "116703153",
            },
            {
              branchname: "NAGCARLAN LAGUNA",
              branchcode: "116703043",
            },
            {
              branchname: "PACIANO RIZAL CALAMBA",
              branchcode: "116703954",
            },
            {
              branchname: "PARIAN",
              branchcode: "116703283",
            },
            {
              branchname: "REAL CALAMBA",
              branchcode: "116703099",
            },
            {
              branchname: "SAN PABLO 2",
              branchcode: "116703642",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BATONG MALAKE",
              branchcode: "116704533",
            },
            {
              branchname: "BAY LAGUNA",
              branchcode: "116704167",
            },
            {
              branchname: "CALAUAN LAGUNA",
              branchcode: "116704202",
            },
            {
              branchname: "LOS BANOS",
              branchcode: "116704638",
            },
            {
              branchname: "LUISIANA LAGUNA",
              branchcode: "116704318",
            },
            {
              branchname: "LUMBAN",
              branchcode: "116704639",
            },
            {
              branchname: "MAAHAS LOS BANOS LAGUNA",
              branchcode: "116704179",
            },
            {
              branchname: "MAJAYJAY LAGUNA",
              branchcode: "116704564",
            },
            {
              branchname: "PAETE",
              branchcode: "116704640",
            },
            {
              branchname: "PAGSANJAN",
              branchcode: "116704408",
            },
            {
              branchname: "PAGSAWITAN LAGUNA",
              branchcode: "116704035",
            },
            {
              branchname: "REGIDOR",
              branchcode: "116704641",
            },
            {
              branchname: "RIZAL LAGUNA",
              branchcode: "116704541",
            },
            {
              branchname: "SAN ANTONIO LOS BANOS",
              branchcode: "116704555",
            },
            {
              branchname: "SAN RAFAEL LAGUNA",
              branchcode: "116704544",
            },
            {
              branchname: "SINILOAN",
              branchcode: "116704644",
            },
            {
              branchname: "STA MARIA LAGUNA",
              branchcode: "116704876",
            },
            {
              branchname: "STO ANGEL SUR",
              branchcode: "116704828",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BALITE VICTORIA LAGUNA",
              branchcode: "116705859",
            },
            {
              branchname: "GATID STA CRUZ LAGUNA",
              branchcode: "116705579",
            },
            {
              branchname: "MASAPANG VICTORIA LAGUNA",
              branchcode: "116705517",
            },
            {
              branchname: "PILA",
              branchcode: "116705940",
            },
            {
              branchname: "STA CRUZ LAGUNA",
              branchcode: "116705643",
            },
            {
              branchname: "VICTORIA LAGUNA",
              branchcode: "116705542",
            },
          ],
        },
      ],
    },
    {
      region: "NORTH EASTERN LUZON REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "SAN JOSE CITY",
              branchcode: "115701801",
            },
            {
              branchname: "SAN JOSE CITY 2 NE",
              branchcode: "115701262",
            },
            {
              branchname: "SAN JOSE CITY 3 NE",
              branchcode: "115701390",
            },
            {
              branchname: "MUNOZ NE",
              branchcode: "115701800",
            },
            {
              branchname: "SCIENCE CITY NE",
              branchcode: "115701118",
            },
            {
              branchname: "STO DOMINGO NE",
              branchcode: "115701314",
            },
            {
              branchname: "GUIMBA 2",
              branchcode: "115701094",
            },
            {
              branchname: "CUYAPO NUEVA ECIJA",
              branchcode: "115701137",
            },
            {
              branchname: "LUPAO NE",
              branchcode: "115701451",
            },
            {
              branchname: "QUEZON NE",
              branchcode: "115701894",
            },
            {
              branchname: "BALOC",
              branchcode: "115701889",
            },
            {
              branchname: "LICAB",
              branchcode: "115701528",
            },
            {
              branchname: "CARRANGLAN NE",
              branchcode: "115701532",
            },
            {
              branchname: "ML SARANAY GUIMBA",
              branchcode: "115701004",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
           {
              branchname: "ALIAGA",
              branchcode: "115703916",
            },
            {
              branchname: "CABANATUAN 1",
              branchcode: "115702790",
            },
            {
              branchname: "CABANATUAN 3",
              branchcode: "115702238",
            },
            {
              branchname: "CABANATUAN 4",
              branchcode: "115702416",
            },
            {
              branchname: "CABANATUAN 6",
              branchcode: "115702591",
            },
            {
              branchname: "CABANATUAN 7",
              branchcode: "115702847",
            },
            {
              branchname: "CABANATUAN MARKET",
              branchcode: "115702386",
            },
            {
              branchname: "CROSSING NE",
              branchcode: "115702260",
            },
            {
              branchname: "MAYAPYAP",
              branchcode: "115704439",
            },
            {
              branchname: "SAN ANTONIO",
              branchcode: "115702792",
            },
            {
              branchname: "ML POBLACION",
              branchcode: "115702796",
            },
            {
              branchname: "ZARAGOZA",
              branchcode: "115703798",
            },
            {
              branchname: "ZARAGOSA 2",
              branchcode: "115703220",
            },
             {
              branchname: "SAN ANTONIO NE",
              branchcode: "115703792",
            },
            {
              branchname: "POB SAN ANTONIO NE",
              branchcode: "115703796",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "JAEN",
              branchcode: "115703791",
            },
            {
              branchname: "JAEN 2",
              branchcode: "115703139",
            },
            {
              branchname: "CABIAO",
              branchcode: "115703711",
            },
            {
              branchname: "SAN ISIDRO NE",
              branchcode: "115703716",
            },
            {
              branchname: "SAN ISIDRO 2",
              branchcode: "115703269",
            },
            {
              branchname: "GAPAN 2",
              branchcode: "115703444",
            },
            {
              branchname: "GENERAL TINIO PAPAYA",
              branchcode: "115703348",
            },
            {
              branchname: "PENARANDA",
              branchcode: "115703893",
            },
             {
              branchname: "NE PACIFIC MALL SHOWROOM",
              branchcode: "115702012",
            },
            {
              branchname: "STA ROSA NE",
              branchcode: "115702795",
            },
            {
              branchname: "STA ROSA 2 NE",
              branchcode: "115703459",
            },
            {
              branchname: "SAN LEONARDO",
              branchcode: "115702281",
            },
            {
              branchname: "SAN LEONARDO 2",
              branchcode: "115702994",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "PALAYAN",
              branchcode: "115702101",
            },
            {
              branchname: "LAUR NUEVA ECIJA",
              branchcode: "115702194",
            },
            {
              branchname: "BONGABON NE",
              branchcode: "115702970",
            },
            {
              branchname: "BONGABON 2",
              branchcode: "115702240",
            },
            {
              branchname: "GABALDON",
              branchcode: "115702892",
            },
            {
              branchname: "DINGALAN",
              branchcode: "115702864",
            },
            {
              branchname: "TALAVERA",
              branchcode: "115701797",
            },
            {
              branchname: "TALAVERA 2",
              branchcode: "115704022",
            },
            {
              branchname: "TALAVERA 3",
              branchcode: "115704556",
            },
            {
              branchname: "TALAVERA 4",
              branchcode: "115704982",
            },
             {
              branchname: "CABANATUAN 5",
              branchcode: "115702443",
            },
            {
              branchname: "CABANATUAN 8",
              branchcode: "115702898",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "RIZAL NE",
              branchcode: "115704793",
            },
            {
              branchname: "RIZAL 3 NE",
              branchcode: "115704831",
            },
            {
              branchname: "PANTABANGAN",
              branchcode: "115704059",
            },
            {
              branchname: "MARIA AURORA",
              branchcode: "115704088",
            },
            {
              branchname: "MARIA AURORA 2",
              branchcode: "115704510",
            },
            {
              branchname: "DIPACULAO",
              branchcode: "115704449",
            },
            {
              branchname: "BALER AURORA",
              branchcode: "115704979",
            },
            {
              branchname: "BALER 2 AURORA",
              branchcode: "115704307",
            },
            {
              branchname: "SAN LUIS AURORA",
              branchcode: "115704829",
            },
            {
              branchname: "ALFONSO CASTANEDA",
              branchcode: "115704830",
            },
            {
              branchname: "LLANERA NE",
              branchcode: "115704152",
            },
            {
              branchname: "GEN NATIVIDAD NUEVA ECIJA",
              branchcode: "115704339",
            },
          ],
        },
      ],
    },
    {
      region: "NORTH WESTERN LUZON REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BACARRA",
              branchcode: "115801764",
            },
            {
              branchname: "BANGUI ILOCOS NORTE",
              branchcode: "115801396",
            },
            {
              branchname: "BANNA ILOCOS NORTE",
              branchcode: "115801539",
            },
            {
              branchname: "DINGRAS ILOCOS NORTE",
              branchcode: "115801497",
            },
            {
              branchname: "LAOAG 1",
              branchcode: "115801755",
            },
            {
              branchname: "LAOAG 2",
              branchcode: "115801756",
            },
            {
              branchname: "LAOAG 3",
              branchcode: "115801404",
            },
            {
              branchname: "PAGUDPUD ILOCOS NORTE",
              branchcode: "115801290",
            },
            {
              branchname: "PASUQUIN",
              branchcode: "115801499",
            },
            {
              branchname: "PIDDIG ILOCOS NORTE",
              branchcode: "115801825",
            },
            
            {
              branchname: "SARRAT ILOCOS NORTE",
              branchcode: "115801972",
            },
            {
              branchname: "SOLSONA",
              branchcode: "115801293",
            },
            {
              branchname: "VINTAR ILOCOS NORTE",
              branchcode: "115801115",
            },
            {
              branchname: "SARRAT 2 ILOCOS NORTE",
              branchcode: "115801996",
            },
            {
              branchname: "ML MARCOS ILOCOS NORTE",
              branchcode: "115801909",
            },
            {
              branchname: "ML BURGOS ILOCOS NORTE",
              branchcode: "115801359",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "SAN NICOLAS 1 ILOCOS NORTE",
              branchcode: "115801213",
            },
            {
              branchname: "SAN NICOLAS 2 ILOCOS NORTE",
              branchcode: "115801846",
            },
            {
              branchname: "BADOC",
              branchcode: "115802763",
            },
            {
              branchname: "BATAC 1 ILOCOS NORTE",
              branchcode: "115802754",
            },
            {
              branchname: "BATAC 2 ILOCOS NORTE",
              branchcode: "115802380",
            },
            {
              branchname: "CABUGAO 2 ILOCOS SUR",
              branchcode: "115802052",
            },
            {
              branchname: "CABUGAO 1 ILOCOS SUR",
              branchcode: "115802249",
            },
            {
              branchname: "MAGSINGAL",
              branchcode: "115802392",
            },
            {
              branchname: "PAOAY",
              branchcode: "115802420",
            },
            {
              branchname: "PINILI ILOCOS NORTE",
              branchcode: "115802837",
            },
            {
              branchname: "SAN JUAN ILOCOS SUR",
              branchcode: "115802208",
            },
            {
              branchname: "SINAIT",
              branchcode: "115802758",
            },
            {
              branchname: "STO DOMINGO ILOCOS SUR",
              branchcode: "115802209",
            },
            {
              branchname: "ML SAN ILDEFONSO ILOCOS SUR",
              branchcode: "115802515",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BANTAY ILOCOS SUR",
              branchcode: "115802405",
            },
            {
              branchname: "ML BANGUED 2",
              branchcode: "115803752",
            },
            {
              branchname: "BANGUED 1",
              branchcode: "115803751",
            },
            {
              branchname: "BANGUED 4",
              branchcode: "115803429",
            },
            {
              branchname: "BUCAY ABRA",
              branchcode: "115803103",
            },
            {
              branchname: "NARVACAN 1",
              branchcode: "115803757",
            },
            {
              branchname: "NARVACAN MALL",
              branchcode: "115803853",
            },
            {
              branchname: "SANTA ILOCOS SUR",
              branchcode: "115803986",
            },
            
            {
              branchname: "STA MARIA ILOCOS SUR",
              branchcode: "115803138",
            },
             {
              branchname: "TAMAG VIGAN",
              branchcode: "115802488",
            },
            {
              branchname: "ML TAFT BANGUED 3",
              branchcode: "115803753",
            },
            {
              branchname: "VIGAN 1",
              branchcode: "115802759",
            },
            {
              branchname: "VIGAN 2",
              branchcode: "115802760",
            },
            
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "SANTIAGO ILOCOS SUR",
              branchcode: "115803042",
            },
            {
              branchname: "BACNOTAN LA UNION",
              branchcode: "115804056",
            },
            {
              branchname: "BALAOAN",
              branchcode: "115804489",
            },
            {
              branchname: "BANGAR",
              branchcode: "115804393",
            },
            {
              branchname: "BAUANG LA UNION",
              branchcode: "115804127",
            },
            {
              branchname: "CANDON",
              branchcode: "115803771",
            },
            {
              branchname: "MANNA MALL",
              branchcode: "115804460",
            },
            {
              branchname: "NAGUILIAN",
              branchcode: "115804061",
            },
            {
              branchname: "POBLACION ESTE",
              branchcode: "115803782",
            },
            {
              branchname: "SAN ESTEBAN ILOCOS SUR",
              branchcode: "115803424",
            },
            {
              branchname: "SAN FERNANDO 2",
              branchcode: "115804389",
            },
            {
              branchname: "SAN FERNANDO 1",
              branchcode: "115804770",
            },
            {
              branchname: "SAN JUAN LA UNION",
              branchcode: "115804054",
            },
             {
              branchname: "STA LUCIA ILOCOS SUR",
              branchcode: "115803230",
            },
            {
              branchname: "TAGUDIN ILOCOS SUR",
              branchcode: "115804169",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "ABATAN",
              branchcode: "115805836",
            },
             {
              branchname: "AGOO",
              branchcode: "115804765",
            },
            {
              branchname: "ARINGAY",
              branchcode: "115804888",
            },
            {
              branchname: "BAGUIO 1",
              branchcode: "115805766",
            },
            {
              branchname: "BAGUIO 3",
              branchcode: "115805768",
            },
            {
              branchname: "BAGUIO 4",
              branchcode: "115805918",
            },
            {
              branchname: "BAGUIO 5",
              branchcode: "115805920",
            },
            {
              branchname: "LA TRINIDAD",
              branchcode: "115805224",
            },
            {
              branchname: "LEGARDA BAGUIO",
              branchcode: "115805276",
            },
            {
              branchname: "LEONARD WOOD",
              branchcode: "115805221",
            },
            {
              branchname: "PORTA VAGA",
              branchcode: "115805769",
            },
            {
              branchname: "ROSARIO LA UNION",
              branchcode: "115804234",
            },
            {
              branchname: "SM BAGUIO SHOWROOM",
              branchcode: "115805013",
            },
          ],
        },
      ],
    },
    {
      region: "NORTHERN LUZON REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ALLACAPAN",
              branchcode: "115601744",
            },
            {
              branchname: "APARRI",
              branchcode: "115601743",
            },
            {
              branchname: "BALLESTEROS 2",
              branchcode: "115601513",
            },
            {
              branchname: "CAMALANIUGAN",
              branchcode: "115601746",
            },
            {
              branchname: "CLAVERIA",
              branchcode: "115601747",
            },
            {
              branchname: "FLORA",
              branchcode: "115601891",
            },
            {
              branchname: "JUNCTION LUNA",
              branchcode: "115601966",
            },
            {
              branchname: "LALLO CAGAYAN",
              branchcode: "115601025",
            },
            {
              branchname: "LASAM",
              branchcode: "115601902",
            },
            {
              branchname: "LUNA APAYAO",
              branchcode: "115601472",
            },
            {
              branchname: "PUDTOL",
              branchcode: "115601302",
            },
            {
              branchname: "RIZAL APARRI",
              branchcode: "115601749",
            },
            {
              branchname: "SANCHEZ MIRA",
              branchcode: "115601750",
            },
            {
              branchname: "STA MARCELA",
              branchcode: "115601886",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ALCALA CAGAYAN",
              branchcode: "115602325",
            },
            {
              branchname: "AMULUNG",
              branchcode: "115602338",
            },
            {
              branchname: "BAGGAO",
              branchcode: "115602762",
            },
            {
              branchname: "BAGGAO 2",
              branchcode: "115602824",
            },
            {
              branchname: "GATTARAN",
              branchcode: "115602748",
            },
            {
              branchname: "GONZAGA",
              branchcode: "115602761",
            },
            {
              branchname: "IGUIG CAGAYAN VALLEY",
              branchcode: "115602096",
            },
            {
              branchname: "MAGAPIT",
              branchcode: "115602364",
            },
            {
              branchname: "STA ANA 2 CAGAYAN",
              branchcode: "115602842",
            },
            {
              branchname: "STA ANA CAGAYAN",
              branchcode: "115602319",
            },
            {
              branchname: "STA TERESITA",
              branchcode: "115602929",
            },
            {
              branchname: "TALLANG",
              branchcode: "115602256",
            },
            {
              branchname: "ML BUGUEY",
              branchcode: "115602990",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BULANAO",
              branchcode: "115603079",
            },
            {
              branchname: "CARIG",
              branchcode: "115603368",
            },
            {
              branchname: "KABUGAO",
              branchcode: "115603057",
            },
            {
              branchname: "LIBAG",
              branchcode: "115603908",
            },
            {
              branchname: "PIAT",
              branchcode: "115603370",
            },
            {
              branchname: "RIZAL KALINGA",
              branchcode: "115603289",
            },
            {
              branchname: "SOLANA CAGAYAN",
              branchcode: "115603387",
            },
            {
              branchname: "TABUK KALINGA",
              branchcode: "115603044",
            },
            {
              branchname: "TUGUEGARAO 1",
              branchcode: "115603817",
            },
            {
              branchname: "TUGUEGARAO 2",
              branchcode: "115603818",
            },
            {
              branchname: "TUGUEGARAO 3",
              branchcode: "115603819",
            },
            {
              branchname: "TUGUEGARAO 4 BALZAIN",
              branchcode: "115603812",
            },
            {
              branchname: "TUGUEGARAO 5",
              branchcode: "115603095",
            },
            {
              branchname: "TUGUEGARAO 6",
              branchcode: "115603189",
            },
            {
              branchname: "TUGUEGARAO 7",
              branchcode: "115603519",
            },
            {
              branchname: "TUGUEGARAO 8",
              branchcode: "115603897",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BENITO SOLIVEN",
              branchcode: "115604546",
            },
            {
              branchname: "CABAGAN ISABELA",
              branchcode: "115604965",
            },
            {
              branchname: "CAUAYAN 1",
              branchcode: "115604810",
            },
            {
              branchname: "CAUAYAN 2",
              branchcode: "115604811",
            },
            {
              branchname: "CAUAYAN 3",
              branchcode: "115604104",
            },
            {
              branchname: "DELFIN ALBANO",
              branchcode: "115604395",
            },
            {
              branchname: "GAMU",
              branchcode: "115604178",
            },
            {
              branchname: "ILAGAN 1",
              branchcode: "115604813",
            },
            {
              branchname: "ILAGAN 2",
              branchcode: "115604814",
            },
            {
              branchname: "MARANA",
              branchcode: "115604527",
            },
            {
              branchname: "NORTHSTAR MALL ILAGAN",
              branchcode: "115604046",
            },
            {
              branchname: "SAN MARIANO",
              branchcode: "115604287",
            },
            {
              branchname: "STO TOMAS ISABELA",
              branchcode: "115604505",
            },
            {
              branchname: "TUMAUINI",
              branchcode: "115604816",
            },
          ],
        },
      ],
    },
    {
      region: "PAMPANGA REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ANGELES 1",
              branchcode: "115401707",
            },
            {
              branchname: "ANGELES 2",
              branchcode: "115401708",
            },
            {
              branchname: "ANGELES 3",
              branchcode: "115401709",
            },
            {
              branchname: "BALIBAGO",
              branchcode: "115401185",
            },
            {
              branchname: "BULAON",
              branchcode: "115401476",
            },
            {
              branchname: "HENSON",
              branchcode: "115401719",
            },
            {
              branchname: "SAGUIN",
              branchcode: "115401180",
            },
            {
              branchname: "SAN JOSE ANGELES CITY",
              branchcode: "115401320",
            },
            {
              branchname: "SINDALAN",
              branchcode: "115401739",
            },
            {
              branchname: "SINDALAN 2",
              branchcode: "115401064",
            },
            {
              branchname: "SINDALAN 4",
              branchcode: "115401068",
            },
            {
              branchname: "STO DOMINGO ANGELES CITY",
              branchcode: "115401037",
            },
            {
              branchname: "SINDALAN 3",
              branchcode: "115401148",
            },
            {
              branchname: "STA CRUZ PORAC",
              branchcode: "115401843",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "DEL ROSARIO",
              branchcode: "115402129",
            },
            {
              branchname: "FRIENDSHIP",
              branchcode: "115402955",
            },
            {
              branchname: "FRIENDSHIP 2",
              branchcode: "115402448",
            },
            {
              branchname: "HENSON VILLE",
              branchcode: "115402384",
            },
            {
              branchname: "JENRA GRAND MALL ANGELES",
              branchcode: "115402239",
            },
            {
              branchname: "MALABANIAS",
              branchcode: "115402971",
            },
            {
              branchname: "PULUNG BULU",
              branchcode: "115402372",
            },
            {
              branchname: "ROBINSONS ANGELES",
              branchcode: "115402207",
            },
            {
              branchname: "SALAPUNGAN",
              branchcode: "115402120",
            },
            {
              branchname: "SAN ISIDRO, SAN FERNANDO",
              branchcode: "115402945",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BUNDAGUL MABALACAT",
              branchcode: "115403794",
            },
            {
              branchname: "CUTUD ANGELES CITY",
              branchcode: "115403590",
            },
            {
              branchname: "DAU 2",
              branchcode: "115403714",
            },
            {
              branchname: "DAU 3",
              branchcode: "115403097",
            },
            {
              branchname: "DOLORES MABALACAT",
              branchcode: "115403921",
            },
            {
              branchname: "MABALACAT 2",
              branchcode: "115403383",
            },
            {
              branchname: "MABIGA",
              branchcode: "115403860",
            },
            {
              branchname: "MADAPDAP",
              branchcode: "115403452",
            },
            {
              branchname: "MAGALANG",
              branchcode: "115403717",
            },
            {
              branchname: "MAGALANG 2",
              branchcode: "115403433",
            },
            {
              branchname: "MARQUEE MALL",
              branchcode: "115403382",
            },
            {
              branchname: "MAWAQUE MABALACAT",
              branchcode: "115403589",
            },
            {
              branchname: "MT VIEW",
              branchcode: "115403423",
            },
            {
              branchname: "PANDACAQUI",
              branchcode: "115403477",
            },
            {
              branchname: "PULUNG MARAGUL",
              branchcode: "115403041",
            },
            {
              branchname: "SAPANG MAISAC",
              branchcode: "115403581",
            },
            {
              branchname: "TABUN",
              branchcode: "115403125",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "APALIT 2",
              branchcode: "115404374",
            },
            {
              branchname: "APALIT PAMPANGA",
              branchcode: "115404730",
            },
            {
              branchname: "ARAYAT 1 PAMPANGA",
              branchcode: "115404710",
            },
            {
              branchname: "ARAYAT 2 PAMPANGA",
              branchcode: "115404538",
            },
            {
              branchname: "CADUANG TETE",
              branchcode: "115404947",
            },
            {
              branchname: "CANDABA",
              branchcode: "115404468",
            },
            {
              branchname: "MACABEBE",
              branchcode: "115404722",
            },
            {
              branchname: "MACABEBE 2",
              branchcode: "115404330",
            },
            {
              branchname: "MEXICO",
              branchcode: "115404718",
            },
            {
              branchname: "MINALIN",
              branchcode: "115404880",
            },
            {
              branchname: "PANDACAQUI 2 MEXICO",
              branchcode: "115404861",
            },
            {
              branchname: "SAN LUIS PAMPANGA",
              branchcode: "115404875",
            },
            {
              branchname: "SAN SIMON",
              branchcode: "115404401",
            },
            {
              branchname: "STA ANA PAMPANGA",
              branchcode: "115404910",
            },
            {
              branchname: "MORAS DELA PAZ STO TOMAS",
              branchcode: "115404227",
            },
            {
              branchname: "SM PAMPANGA SHOWROOM",
              branchcode: "115404007",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BACOLOR",
              branchcode: "115405492",
            },
            {
              branchname: "DOLORES 2 PAMPANGA",
              branchcode: "115405863",
            },
            {
              branchname: "DOLORES PAMPANGA",
              branchcode: "115405734",
            },
            {
              branchname: "DOWNTOWN PAMPANGA",
              branchcode: "115405944",
            },
            {
              branchname: "FLORIDA 2 PAMPANGA",
              branchcode: "115405467",
            },
            {
              branchname: "FLORIDA 3",
              branchcode: "115405038",
            },
            {
              branchname: "FLORIDABLANCA",
              branchcode: "115405019",
            },
            {
              branchname: "GUAGUA 2",
              branchcode: "115405457",
            },
            {
              branchname: "GUAGUA PAMPANGA",
              branchcode: "115405409",
            },
            {
              branchname: "LOURDES NORTH WEST",
              branchcode: "115405334",
            },
            {
              branchname: "PLAZA BURGOS GUAGUA",
              branchcode: "115405874",
            },
            {
              branchname: "PORAC PAMPANGA",
              branchcode: "115405144",
            },
            {
              branchname: "STA CRUZ LUBAO",
              branchcode: "115405738",
            },
            {
              branchname: "STA RITA PAMPANGA",
              branchcode: "115405150",
            },
            {
              branchname: "STO TOMAS",
              branchcode: "115405988",
            },
            {
              branchname: "SAN ROQUE DAU 1ST",
              branchcode: "115405128",
            },
            {
              branchname: "STARMILLS ROBINSONS PAMPANGA",
              branchcode: "115405010",
            },
            {
              branchname: "ML PULUNG MASLE",
              branchcode: "115405987",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "SAN ANTONIO MEXICO",
              branchcode: "115406959",
            },
            {
              branchname: "STO DOMINGO MEXICO",
              branchcode: "115406470",
            },
            {
              branchname: "LAGUNDI",
              branchcode: "123456700",
            },
             {
              branchname: "ML STO Nino MASANTOL",
              branchcode: "115406884",
            },
            {
              branchname: "ML LAGUNDI MEXICO",
              branchcode: "115406321",
            },
          ],
        },
      ],
    },
    {
      region: "QUIVISAGAO",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "ALICIA 2 ISABELA",
              branchcode: "116901203",
            },
            {
              branchname: "ALICIA NOL",
              branchcode: "116901802",
            },
            {
              branchname: "ML ALICIA 3 ISABELA",
              branchcode: "116901961",
            },
            {
              branchname: "ANGADANAN",
              branchcode: "116901363",
            },
            {
              branchname: "CORDON ISABELA",
              branchcode: "116901134",
            },
            {
              branchname: "ECHAGUE ISABELA",
              branchcode: "116901226",
            },
            {
              branchname: "ECHAGUE 2",
              branchcode: "116901362",
            },
            {
              branchname: "ECHAGUE 3",
              branchcode: "116901518",
            },
            {
              branchname: "JONES ISABELA",
              branchcode: "116901225",
            },
            {
              branchname: "SAN AGUSTIN",
              branchcode: "116901343",
            },
            {
              branchname: "SAN GUILLERMO",
              branchcode: "116901827",
            },
            {
              branchname: "SANTIAGO 3",
              branchcode: "116901091",
            },
            {
              branchname: "SANTIAGO 5 ISABELA",
              branchcode: "116901296",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "ALFONSO LISTA",
              branchcode: "116902466",
            },
            {
              branchname: "AURORA ISABELA",
              branchcode: "116902087",
            },
            {
              branchname: "CABATUAN",
              branchcode: "116902288",
            },
            {
              branchname: "MALLIG",
              branchcode: "116902885",
            },
            {
              branchname: "PARACELIS MT PROVINCE",
              branchcode: "116902580",
            },
            {
              branchname: "QUEZON ISABELA",
              branchcode: "116902516",
            },
            {
              branchname: "QUIRINO ISABELA",
              branchcode: "116902586",
            },

            {
              branchname: "RAMON",
              branchcode: "116902278",
            },
            {
              branchname: "ROXAS ISABELA",
              branchcode: "116902815",
            },

            {
              branchname: "ROXAS 2 ISABELA",
              branchcode: "116902385",
            },
            {
              branchname: "SAN MATEO ISABELA",
              branchcode: "116902806",
            },
            {
              branchname: "SANTIAGO 1",
              branchcode: "116902807",
            },

            {
              branchname: "SANTIAGO 2",
              branchcode: "116902808",
            },
            {
              branchname: "SANTIAGO 6",
              branchcode: "116902311",
            },

            {
              branchname: "SANTIAGO 7",
              branchcode: "116902414",
            },
            {
              branchname: "SAN MANUEL",
              branchcode: "116902257",
            },
             {
              branchname: "LUNA ISABELA",
              branchcode: "116902214",
            },
             {
              branchname: "ML BURGOS ISABELA",
              branchcode: "116902879",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "ARITAO",
              branchcode: "116903060",
            },
            {
              branchname: "ARITAO 2",
              branchcode: "116903511",
            },
            {
              branchname: "BAMBANG 3",
              branchcode: "116903066",
            },
            {
              branchname: "BAMBANG 4",
              branchcode: "116903300",
            },
            {
              branchname: "BAMBANG NV",
              branchcode: "116903803",
            },
            {
              branchname: "BAYOMBONG 2",
              branchcode: "116903313",
            },
            {
              branchname: "BAYOMBONG NUEVA VIZCAYA",
              branchcode: "116903110",
            },
            {
              branchname: "DUPAX DEL SUR",
              branchcode: "116903074",
            },
            {
              branchname: "DUPAX NV",
              branchcode: "116903904",
            },
            {
              branchname: "GADDANG",
              branchcode: "116903804",
            },
            {
              branchname: "HEROES",
              branchcode: "116903805",
            },
            {
              branchname: "KASIBU",
              branchcode: "116903582",
            },
            {
              branchname: "SOLANO 4",
              branchcode: "116903867",
            },
            {
              branchname: "STA FE",
              branchcode: "116903365",
            },
            {
              branchname: "VILLAVERDE",
              branchcode: "116903106",
            },
            {
              branchname: "KAYAPA NV",
              branchcode: "116903951",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "AGLIPAY",
              branchcode: "116904397",
            },
            {
              branchname: "BAGABAG",
              branchcode: "116904347",
            },
            {
              branchname: "BAGABAG 2",
              branchcode: "116904549",
            },
            {
              branchname: "CABARROGUIS",
              branchcode: "116904342",
            },
            {
              branchname: "CABARROGUIS 2",
              branchcode: "116904558",
            },
            {
              branchname: "DIADI",
              branchcode: "116904329",
            },
            {
              branchname: "DIFFUN",
              branchcode: "116904820",
            },
            {
              branchname: "LAGAWE",
              branchcode: "116904865",
            },
            {
              branchname: "LAMUT IFUGAO",
              branchcode: "116904098",
            },
            {
              branchname: "MADDELA 2",
              branchcode: "116904381",
            },
            {
              branchname: "MADELA",
              branchcode: "116904905",
            },
            {
              branchname: "SAGUDAY",
              branchcode: "116904333",
            },
            {
              branchname: "SOLANO 3",
              branchcode: "116904219",
            },
            {
              branchname: "SOLANO NV",
              branchcode: "116904809",
            },
          ],
        },
      ],
    },
    {
      region: "SOUTH EASTERN LUZON",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BOAC",
              branchcode: "116101624",
            },
            {
              branchname: "DALAHICAN LUCENA",
              branchcode: "116101047",
            },
            {
              branchname: "GASAN MARINDUQUE",
              branchcode: "116101130",
            },
            {
              branchname: "MAHARLIKA LUCENA",
              branchcode: "116101833",
            },
            {
              branchname: "MERCHAN",
              branchcode: "116101645",
            },
            {
              branchname: "MOGPOG",
              branchcode: "116101479",
            },
            {
              branchname: "RED V",
              branchcode: "116101943",
            },
            {
              branchname: "SAN FERNANDO QUEZON",
              branchcode: "116101204",
            },
            {
              branchname: "SARIAYA 2",
              branchcode: "116101254",
            },
            {
              branchname: "SARIAYA QUEZON",
              branchcode: "116101630",
            },
            {
              branchname: "STA CRUZ MARINDUQUE",
              branchcode: "116101631",
            },
            {
              branchname: "TAGARAO",
              branchcode: "116101498",
            },
            {
              branchname: "TORRIJOS MARINDUQUE",
              branchcode: "116101132",
            },
            {
              branchname: "ML Gonzales",
              branchcode: "116101465",
            },
            {
              branchname: "ML TIAONG",
              branchcode: "116101633",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "CANDELARIA 2 QUEZON",
              branchcode: "116102353",
            },
            {
              branchname: "CANDELARIA QUEZON",
              branchcode: "116102625",
            },
            {
              branchname: "DOLORES QUEZON",
              branchcode: "116102172",
            },
            {
              branchname: "INFANTA QUEZON",
              branchcode: "116102637",
            },
             {
              branchname: "ML COMON INFANTA QUEZON",
              branchcode: "116102870",
            },
            {
              branchname: "LUCBAN",
              branchcode: "116102627",
            },
            {
              branchname: "LUCBAN 2",
              branchcode: "116102495",
            },
            {
              branchname: "MAUBAN QUEZON",
              branchcode: "116102161",
            },
            {
              branchname: "REAL QUEZON",
              branchcode: "116102085",
            },
            {
              branchname: "SAMPALOC QUEZON",
              branchcode: "116102995",
            },
            {
              branchname: "SAN ANTONIO QUEZON",
              branchcode: "116102369",
            },
            {
              branchname: "TAYABAS 2 QUEZON",
              branchcode: "116102191",
            },
            {
              branchname: "TAYABAS 3",
              branchcode: "116102969",
            },
            {
              branchname: "TAYABAS QUEZON",
              branchcode: "116102632",
            },
            {
              branchname: "TIAONG",
              branchcode: "116102633",
            },
            {
              branchname: "ML MALIGAYA",
              branchcode: "",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "AGDANGAN QUEZON",
              branchcode: "116103156",
            },
            {
              branchname: "ATIATIHAN PARTNER",
              branchcode: "116103020",
            },
            {
              branchname: "CATANAUAN QUEZON",
              branchcode: "116103253",
            },
            {
              branchname: "GULANG GULANG",
              branchcode: "116103151",
            },
            {
              branchname: "MACALELON QUEZON",
              branchcode: "116103188",
            },
            {
              branchname: "MULANAY",
              branchcode: "116103268",
            },
            {
              branchname: "PAGBILAO QUEZON",
              branchcode: "116103634",
            },
            {
              branchname: "PITOGO QUEZON",
              branchcode: "116103261",
            },
            {
              branchname: "QUEZON AVE LUCENA",
              branchcode: "116103251",
            },
            {
              branchname: "TALIPAN",
              branchcode: "116103525",
            },
            {
              branchname: "ML CATANAUAN 2",
              branchcode: "",
            },
            {
              branchname: "ML PADRE BURGOS",
              branchcode: "",
            },
            {
              branchname: "ML UNISAN",
              branchcode: "",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "ALABAT QUEZON",
              branchcode: "116104872",
            },
            {
              branchname: "ATIMONAN",
              branchcode: "116104623",
            },
            {
              branchname: "CALAUAG",
              branchcode: "116104932",
            },
            {
              branchname: "CALAUAG 2 QUEZON",
              branchcode: "116104868",
            },
            {
              branchname: "GUINAYANGAN QUEZON",
              branchcode: "116104481",
            },
            {
              branchname: "GUMACA",
              branchcode: "116104626",
            },
            {
              branchname: "LOPEZ QUEZON",
              branchcode: "116104917",
            },
            {
              branchname: "QUEZON QUEZON",
              branchcode: "116104588",
            },
            {
              branchname: "SAN NARCISO QUEZON",
              branchcode: "116104425",
            },
            {
              branchname: "TAGKAWAYAN QUEZON",
              branchcode: "116104160",
            },
             {
              branchname: "ML PADRE BURGOS QUEZON",
              branchcode: "116104997",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
             {
              branchname: "ML Atimonan 2",
              branchcode: "116105484",
            },
          ],
        },
      ],
    },
    {
      region: "SOUTH WESTERN LUZON",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BATANGAS 1",
              branchcode: "116001650",
            },
            {
              branchname: "BATANGAS 2",
              branchcode: "116001651",
            },
            {
              branchname: "BATANGAS 3",
              branchcode: "1116001652",
            },
            {
              branchname: "BAUAN 1",
              branchcode: "116001653",
            },
            {
              branchname: "BAUAN 3",
              branchcode: "116001040",
            },
            {
              branchname: "CALICANTO",
              branchcode: "116001654",
            },
            {
              branchname: "K PONSO BAUAN 2",
              branchcode: "116001658",
            },
            {
              branchname: "KUMINTANG",
              branchcode: "116001258",
            },
            {
              branchname: "LOBO BATANGAS",
              branchcode: "116001973",
            },
            {
              branchname: "MABINI BATANGAS",
              branchcode: "116001111",
            },
            {
              branchname: "PALLOCAN",
              branchcode: "116001454",
            },
            {
              branchname: "SAN PASCUAL BATANGAS",
              branchcode: "116001215",
            },
            {
              branchname: "SM BATANGAS SHOWROOM",
              branchcode: "116001014",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "CUENCA BATANGAS",
              branchcode: "116002331",
            },
            {
              branchname: "LIPA 1 RECTO",
              branchcode: "116002660",
            },
            {
              branchname: "LIPA 2 TORRES",
              branchcode: "116002661",
            },
            {
              branchname: "LIPA 3 RIZAL",
              branchcode: "116002662",
            },
            {
              branchname: "LIPA 5",
              branchcode: "116002122",
            },
            {
              branchname: "LIPA 6",
              branchcode: "116002175",
            },
            {
              branchname: "LIPA 7",
              branchcode: "116002211",
            },
            {
              branchname: "LIPA MARKET",
              branchcode: "116002663",
            },
            {
              branchname: "MARAWOY",
              branchcode: "116002852",
            },
            {
              branchname: "MATAAS NA KAHOY",
              branchcode: "116002678",
            },
            {
              branchname: "ROBINSONS LIPA",
              branchcode: "116002928",
            },
            {
              branchname: "SAN JOSE BATANGAS",
              branchcode: "116002666",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "AGONCILLO",
              branchcode: "116003560",
            },
            {
              branchname: "BALAYAN",
              branchcode: "116003649",
            },
            {
              branchname: "BALAYAN 2",
              branchcode: "116003071",
            },
            {
              branchname: "BIHIS",
              branchcode: "116003550",
            },
            {
              branchname: "CALACA BATANGAS",
              branchcode: "116003100",
            },
            {
              branchname: "CALATAGAN",
              branchcode: "116003984",
            },
            {
              branchname: "CNM LEMERY 4",
              branchcode: "116003927",
            },
            {
              branchname: "ILUSTRE LEMERY 3",
              branchcode: "116003919",
            },
            {
              branchname: "JP LAUREL NASUGBU",
              branchcode: "116003926",
            },
            {
              branchname: "LEMERY 1",
              branchcode: "116003655",
            },
            {
              branchname: "LEMERY 2",
              branchcode: "116003656",
            },
            {
              branchname: "LIAN BATANGAS",
              branchcode: "116003242",
            },
            {
              branchname: "NASUGBU",
              branchcode: "116003657",
            },
            {
              branchname: "SAN LUIS BATANGAS",
              branchcode: "116003235",
            },
            {
              branchname: "TAAL BATANGAS",
              branchcode: "116003231",
            },
            {
              branchname: "TUY",
              branchcode: "116003983",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "BONGABONG OR MINDORO",
              branchcode: "116004667",
            },
            {
              branchname: "CALAPAN 1",
              branchcode: "116004668",
            },
            {
              branchname: "CALAPAN 2",
              branchcode: "116004669",
            },
            {
              branchname: "CALAPAN 3",
              branchcode: "116004670",
            },
            {
              branchname: "GLORIA OR MINDORO",
              branchcode: "116004119",
            },
            {
              branchname: "MAR FRANCISCO",
              branchcode: "116004677",
            },
            {
              branchname: "PINAMALAYAN 2",
              branchcode: "116004083",
            },
            {
              branchname: "PUERTO GALERA",
              branchcode: "116004259",
            },
            {
              branchname: "ROXAS MINDORO",
              branchcode: "116004673",
            },
            {
              branchname: "SOCORRO OR MINDORO",
              branchcode: "116004078",
            },
            {
              branchname: "VICTORIA OR MINDORO",
              branchcode: "116004933",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "MALVAR 1 BATANGAS",
              branchcode: "116005398",
            },
            {
              branchname: "MALVAR 2",
              branchcode: "116005367",
            },
            {
              branchname: "STO TOMAS 3 BATANGAS",
              branchcode: "116005508",
            },
            {
              branchname: "STO TOMAS 1 BATANGAS",
              branchcode: "116005123",
            },
            {
              branchname: "STO TOMAS 2 BATANGAS",
              branchcode: "116005878",
            },
            {
              branchname: "TALISAY BATANGAS",
              branchcode: "116005618",
            },
            {
              branchname: "TANAUAN 1",
              branchcode: "116005646",
            },
            {
              branchname: "TANAUAN 2",
              branchcode: "116005647",
            },
            {
              branchname: "TANAUAN 3",
              branchcode: "116005216",
            },
            {
              branchname: "TANAUAN 4",
              branchcode: "116005421",
            },
          ],
        },
        {
          area: "Area F",
          BRANCHES: [
            {
              branchname: "CALINTAAN",
              branchcode: "116006304",
            },
            {
              branchname: "IBAAN",
              branchcode: "116006659",
            },
            {
              branchname: "MAGSAYSAY OCC MINDORO",
              branchcode: "116006303",
            },
            {
              branchname: "MAMBURAO",
              branchcode: "116006671",
            },
            {
              branchname: "PADRE GARCIA",
              branchcode: "116006664",
            },
            {
              branchname: "ROSARIO 1 BATANGAS",
              branchcode: "116006665",
            },
            {
              branchname: "ROSARIO 2 BATANGAS",
              branchcode: "116006107",
            },
            {
              branchname: "ROSARIO 3 BATANGAS",
              branchcode: "116006526",
            },
            {
              branchname: "SABLAYAN",
              branchcode: "116006674",
            },
            {
              branchname: "SAN JOSE 1 OCC MINDORO",
              branchcode: "116006675",
            },
            {
              branchname: "SAN JOSE 2 OCC MINDORO",
              branchcode: "116006676",
            },
            {
              branchname: "SAN JUAN 1 BATANGAS",
              branchcode: "116006629",
            },
            {
              branchname: "SAN JUAN 2 BATANGAS",
              branchcode: "116006563",
            },
            {
              branchname: "STA CRUZ OCCIDENTAL MINDORO",
              branchcode: "116006475",
            },
            {
              branchname: "TAYSAN",
              branchcode: "116006400",
            },
          ],
        },
      ],
    },
    {
      region: "SOUTHERN LUZON",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BAYANAN",
              branchcode: "115901869",
            },
            {
              branchname: "GAWARAN",
              branchcode: "115901840",
            },
            {
              branchname: "GREEN VALLEY",
              branchcode: "115901841",
            },
            {
              branchname: "MOLINO BACOOR",
              branchcode: "115901295",
            },
            {
              branchname: "MOLINO 3",
              branchcode: "115901232",
            },
            {
              branchname: "MOLINO 4 Citihomes",
              branchcode: "115901199",
            },
            {
              branchname: "MOLINO ROAD",
              branchcode: "115901924",
            },
            {
              branchname: "RFC MALL MOLINO",
              branchcode: "115901585",
            },
            {
              branchname: "SAN NICOLAS 3",
              branchcode: "115901949",
            },
            {
              branchname: "SAN NICOLAS",
              branchcode: "115901583",
            },
            {
              branchname: "SPRINGVILLE WEST",
              branchcode: "115901822",
            },
            {
              branchname: "BACOOR",
              branchcode: "115901578",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "BULIHAN 2",
              branchcode: "115902435",
            },
            {
              branchname: "SALAWAG",
              branchcode: "115905198",
            },
            {
              branchname: "MABUHAY",
              branchcode: "115905233",
            },
            {
              branchname: "PALIPARAN",
              branchcode: "115905605",
            },
            {
              branchname: "CARMONA",
              branchcode: "115902614",
            },
            {
              branchname: "CARMONA 2",
              branchcode: "115902434",
            },
            {
              branchname: "GMA 1",
              branchcode: "115902612",
            },
            {
              branchname: "GMA 2",
              branchcode: "115902613",
            },
            {
              branchname: "MADUYA CARMONA",
              branchcode: "115902540",
            },
            {
              branchname: "MAGRA GMA CAVITE",
              branchcode: "115902024",
            },
            {
              branchname: "POBLACION 5",
              branchcode: "115902598",
            },
            {
              branchname: "SAN JOSE CAVITE",
              branchcode: "115902594",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "A SORIANO TANZA",
              branchcode: "115903206",
            },
            {
              branchname: "AMAYA",
              branchcode: "115903456",
            },
            {
              branchname: "CAVITE CITY",
              branchcode: "115903565",
            },
            {
              branchname: "KAWIT LUZON",
              branchcode: "115903570",
            },
            {
              branchname: "LANDMASS",
              branchcode: "115903192",
            },
            {
              branchname: "MABOLO CAVITE",
              branchcode: "115903366",
            },
            {
              branchname: "NOVELETA",
              branchcode: "115903572",
            },
            {
              branchname: "PRINZA",
              branchcode: "115903573",
            },
            {
              branchname: "ROSARIO 2",
              branchcode: "115903575",
            },
            {
              branchname: "TANZA 1",
              branchcode: "115903576",
            },
            {
              branchname: "ML PRINZA",
              branchcode: "115903356",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "ALFONSO",
              branchcode: "115904622",
            },
            {
              branchname: "AMADEO CAVITE",
              branchcode: "115904619",
            },
            {
              branchname: "IBAYO SILANGAN 1",
              branchcode: "115904568",
            },
            {
              branchname: "IBAYO SILANGAN 2",
              branchcode: "115904887",
            },
            {
              branchname: "INDANG CAVITE",
              branchcode: "115904617",
            },
            {
              branchname: "MARAGONDON CAVITE",
              branchcode: "115904264",
            },
            {
              branchname: "MENDEZ",
              branchcode: "115904292",
            },
            {
              branchname: "NAIC CAVITE",
              branchcode: "115904571",
            },
            {
              branchname: "TAGAYTAY",
              branchcode: "115904616",
            },
            {
              branchname: "TRECE MARTIRES 2",
              branchcode: "115904412",
            },
            {
              branchname: "TRECE MARTIREZ",
              branchcode: "115904577",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "AGUINALDO",
              branchcode: "115905610",
            },
            {
              branchname: "DASMARINAS 1",
              branchcode: "115905600",
            },
            {
              branchname: "DASMARINAS 3",
              branchcode: "115905602",
            },
            {
              branchname: "LUZVIMINDA",
              branchcode: "115905603",
            },
            {
              branchname: "ROBINSONS DASMARINAS",
              branchcode: "115902177",
            },
            {
              branchname: "LANGKAAN DASMARINAS CAVITE",
              branchcode: "115902084",
            },
            {
              branchname: "SM DASMARINAS SHOWROOM",
              branchcode: "115902011",
            },
            {
              branchname: "GENERAL TRIAS",
              branchcode: "115904567",
            },
            {
              branchname: "BROOKSIDE LANE CAVITE",
              branchcode: "115904163",
            },
            {
              branchname: "SILANG BAYAN 1",
              branchcode: "115902615",
            },
            {
              branchname: "P CAMPOS",
              branchcode: "115905606",
            },
            {
              branchname: "SAN NICOLAS DASMARINAS",
              branchcode: "115905608",
            },
            {
              branchname: "STA CRISTINA II",
              branchcode: "115905609",
            },
          ],
        },
        {
          area: "Area F",
          BRANCHES: [
            {
              branchname: "SAN DIONISIO",
              branchcode: "115905607",
            },
            {
              branchname: "DASMARINAS 2",
              branchcode: "115905601",
            },
            {
              branchname: "SABANG DASMA",
              branchcode: "115905089",
            },
            {
              branchname: "IMUS JEWELLERS THE DISTRICT MALL",
              branchcode: "115901358",
            },
            {
              branchname: "MAGDALO IMUS",
              branchcode: "115901158",
            },
            {
              branchname: "BUHAY NA TUBIG",
              branchcode: "115901210",
            },
            {
              branchname: "IMUS 2 CAVITE",
              branchcode: "115903116",
            },
            {
              branchname: "IMUS 1 CAVITE",
              branchcode: "115903569",
            },
            {
              branchname: "ANABU IMUS",
              branchcode: "115905205",
            },
            {
              branchname: "MALAGASANG",
              branchcode: "115905950",
            },
            {
              branchname: "PAG ASA",
              branchcode: "115901604",
            },
            {
              branchname: "BACOOR",
              branchcode: "115901578",
            },
          ],
        },
      ],
    },
    {
      region: "TARPAN",
      areaSet: [
        {
          area: "Area A",
          BRANCHES: [
            {
              branchname: "BINMALEY",
              branchcode: "116201133",
            },
            {
              branchname: "CALASIAO",
              branchcode: "116201461",
            },
            {
              branchname: "DAGUPAN 1",
              branchcode: "116201779",
            },
            {
              branchname: "DAGUPAN 2",
              branchcode: "116201780",
            },
            {
              branchname: "DAGUPAN 3",
              branchcode: "116201962",
            },
            {
              branchname: "DAGUPAN 4 BOOTH",
              branchcode: "116201882",
            },
            {
              branchname: "LINGAYEN 2 PANGASINAN",
              branchcode: "116201826",
            },
            {
              branchname: "LINGAYEN PANGASINAN",
              branchcode: "116201787",
            },
            {
              branchname: "SAN CARLOS 2",
              branchcode: "116201850",
            },
            {
              branchname: "SAN CARLOS PANGASINAN",
              branchcode: "116201788",
            },
          ],
        },
        {
          area: "Area B",
          BRANCHES: [
            {
              branchname: "ALCALA PANGASINAN",
              branchcode: "116202431",
            },
            {
              branchname: "BAYAMBANG",
              branchcode: "116202058",
            },
            {
              branchname: "LAOAC",
              branchcode: "116202939",
            },
            {
              branchname: "MALASIQUI",
              branchcode: "116202914",
            },
            {
              branchname: "MALASIQUI 2",
              branchcode: "116202474",
            },
            {
              branchname: "MANAOAG",
              branchcode: "116202105",
            },
            {
              branchname: "MANGALDAN PANGASINAN",
              branchcode: "116202781",
            },
            {
              branchname: "MAPANDAN",
              branchcode: "116202034",
            },
            {
              branchname: "SAN FABIAN",
              branchcode: "116202935",
            },
            {
              branchname: "SAN JACINTO PANGASINAN",
              branchcode: "116202464",
            },
            {
              branchname: "STA BARBARA PANGASINAN",
              branchcode: "116202053",
            },
          ],
        },
        {
          area: "Area C",
          BRANCHES: [
            {
              branchname: "M LHUILLIER JEWELLERS MAGIC MALL",
              branchcode: "116203923",
            },
            {
              branchname: "BALUNGAO PANGASINAN",
              branchcode: "116203524",
            },
            {
              branchname: "CARMEN ROSALES",
              branchcode: "116203775",
            },
            {
              branchname: "NATIVIDAD",
              branchcode: "116203559",
            },
            {
              branchname: "POZORRUBIO",
              branchcode: "116203093",
            },
            {
              branchname: "POZORRUBIO 2 PANGASINAN",
              branchcode: "116203494",
            },
            {
              branchname: "ROSALES",
              branchcode: "116203428",
            },
            {
              branchname: "SAN MANUEL PANGASINAN",
              branchcode: "116203784",
            },
            {
              branchname: "SAN QUINTIN",
              branchcode: "116203201",
            },
            {
              branchname: "SISON PANGASINAN",
              branchcode: "116203504",
            },
            {
              branchname: "TAYUG PANGASINAN",
              branchcode: "116203112",
            },
            {
              branchname: "UMINGAN",
              branchcode: "116203378",
            },
            {
              branchname: "URDANETA 1",
              branchcode: "116203776",
            },
            {
              branchname: "URDANETA 2",
              branchcode: "116203777",
            },
            {
              branchname: "VILLASIS",
              branchcode: "116203783",
            },
             {
              branchname: "ML ASINGAN",
              branchcode: "116203991",
            },
          ],
        },
        {
          area: "Area D",
          BRANCHES: [
            {
              branchname: "AGUILAR PANGASINAN",
              branchcode: "116204427",
            },
            {
              branchname: "ALAMINOS 2 PANGASINAN",
              branchcode: "116204462",
            },
            {
              branchname: "ALAMINOS PANGASINAN",
              branchcode: "116204785",
            },
            {
              branchname: "ANDA PANGASINAN",
              branchcode: "116204463",
            },
            {
              branchname: "BANI PANGASINAN",
              branchcode: "116204073",
            },
            {
              branchname: "BOLINAO PANGASINAN",
              branchcode: "116204263",
            },
            {
              branchname: "BUGALLON",
              branchcode: "116204284",
            },
            {
              branchname: "BURGOS PANGASINAN",
              branchcode: "116204838",
            },
            {
              branchname: "DASOL PANGASINAN",
              branchcode: "116204512",
            },
            {
              branchname: "INFANTA PANGASINAN",
              branchcode: "116204033",
            },
            {
              branchname: "MANGATAREM",
              branchcode: "116204903",
            },
            {
              branchname: "SUAL PANGASINAN",
              branchcode: "116204336",
            },
            {
              branchname: "URBIZTONDO PANGASINAN",
              branchcode: "116204937",
            },
          ],
        },
        {
          area: "Area E",
          BRANCHES: [
            {
              branchname: "ANAO TARLAC",
              branchcode: "116205229",
            },
            {
              branchname: "CAMILING 2 TARLAC",
              branchcode: "116205849",
            },
            {
              branchname: "CAMILING TARLAC",
              branchcode: "116205345",
            },
            {
              branchname: "GERONA TARLAC",
              branchcode: "116205247",
            },
            {
              branchname: "GOMEZ PANIQUI",
              branchcode: "116205774",
            },
            {
              branchname: "MAYANTOC TARLAC",
              branchcode: "116205379",
            },
            {
              branchname: "MONCADA TARLAC",
              branchcode: "116205039",
            },
            {
              branchname: "PANIQUI TARLAC",
              branchcode: "116205773",
            },
            {
              branchname: "PURA TARLAC",
              branchcode: "116205503",
            },
            {
              branchname: "RAMOS TARLAC",
              branchcode: "116205217",
            },
            {
              branchname: "SAN CLEMENTE TARLAC",
              branchcode: "116205298",
            },
            {
              branchname: "SAN MANUEL TARLAC",
              branchcode: "116205704",
            },
            {
              branchname: "STA IGNACIA TARLAC",
              branchcode: "116205075",
            },
          ],
        },
        {
          area: "Area F",
          BRANCHES: [
            {
              branchname: "BAMBAN TARLAC",
              branchcode: "116206426",
            },
            {
              branchname: "CAPAS 2",
              branchcode: "116206415",
            },
            {
              branchname: "CAPAS TARLAC",
              branchcode: "116206050",
            },
            {
              branchname: "CONCEPCION 2 TARLAC",
              branchcode: "116206430",
            },
            {
              branchname: "CONCEPCION TARLAC",
              branchcode: "116206712",
            },
            {
              branchname: "CRISTO REY CAPAS",
              branchcode: "116206403",
            },
            {
              branchname: "LA PAZ TARLAC",
              branchcode: "116206469",
            },
            {
              branchname: "TARLAC",
              branchcode: "116206772",
            },
            {
              branchname: "TARLAC 2",
              branchcode: "116206051",
            },
            {
              branchname: "TARLAC 3",
              branchcode: "116206171",
            },
            {
              branchname: "TARLAC 4",
              branchcode: "116206193",
            },
            {
              branchname: "TARLAC 5",
              branchcode: "116206286",
            },
            {
              branchname: "TIBAG",
              branchcode: "116206557",
            },
            {
              branchname: "VICTORIA TARLAC",
              branchcode: "116206377",
            },
          ],
        },
      ],
    },
  ],
  VISAYAS: [
    {
      region: "CEBU CENTRAL A REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "COLON 1",
              branchcode: "120101029",
            },
            {
              branchname: "COLON 3",
              branchcode: "120101030",
            },
            {
              branchname: "COLON 7",
              branchcode: "120101033",
            },
            {
              branchname: "COLONNADE",
              branchcode: "120101034",
            },
            {
              branchname: "EDEN",
              branchcode: "120101550",
            },
            {
              branchname: "JUAN LUNA 1",
              branchcode: "120101020",
            },
            {
              branchname: "APM MALL",
              branchcode: "120102644",
            },
            {
              branchname: "CARRETA",
              branchcode: "120102108",
            },
            {
              branchname: "MC ARTHUR",
              branchcode: "120102038",
            },
            {
              branchname: "NRA",
              branchcode: "120102053",
            },
            {
              branchname: "ROBINSONS GALLERIA SHOWROOM",
              branchcode: "120102485",
            },
            {
              branchname: "SM CEBU SHOWROOM",
              branchcode: "120102003",
            },
            {
              branchname: "T PADILLA",
              branchcode: "120102105",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BORROMEO",
              branchcode: "120101078",
            },
            {
              branchname: "CARBON, CEBU",
              branchcode: "120101868",
            },
            {
              branchname: "LABUCAY",
              branchcode: "120101750",
            },
            {
              branchname: "PASIL",
              branchcode: "120101040",
            },
            {
              branchname: "MC BRIONES",
              branchcode: "120102846",
            },
            {
              branchname: "EMALL",
              branchcode: "120102526",
            },
            {
              branchname: "MAMBALING 1",
              branchcode: "120104024",
            },
            {
              branchname: "MAMBALING 2",
              branchcode: "120104025",
            },
            {
              branchname: "MAMBALING 3",
              branchcode: "120104026",
            },
            {
              branchname: "DULJO",
              branchcode: "120101018",
            },
            {
              branchname: "URGELLO",
              branchcode: "120103041",
            },
            {
              branchname: "URGELLO 2",
              branchcode: "120103532",
            },
            {
              branchname: "V RAMA",
              branchcode: "120103749",
            },
            {
              branchname: "N. BACALSO SIT",
              branchcode: "120103027",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "F LLAMAS",
              branchcode: "120103019",
            },
            {
              branchname: "FLLAMAS BASAK",
              branchcode: "120103815",
            },
            {
              branchname: "GAISANO TISA",
              branchcode: "120103487",
            },
            {
              branchname: "LABANGON",
              branchcode: "120103023",
            },
            {
              branchname: "SALVADOR",
              branchcode: "120103867",
            },
            {
              branchname: "TISA",
              branchcode: "120103028",
            },
            {
              branchname: "BASAK BONTORES",
              branchcode: "120104512",
            },
            {
              branchname: "BAYANIHAN CEBU",
              branchcode: "120104120",
            },
            {
              branchname: "BULACAO",
              branchcode: "120104121",
            },
            {
              branchname: "COGON",
              branchcode: "120104835",
            },
            {
              branchname: "GABUYA PARDO",
              branchcode: "120104691",
            },
            {
              branchname: "INAYAWAN CEBU",
              branchcode: "120104122",
            },
            {
              branchname: "PARDO",
              branchcode: "120104125",
            },
            {
              branchname: "QUIOT PARDO",
              branchcode: "120104540",
            },
          ],
        },
      ],
    },
    {
      region: "CEBU NORTH A REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "AC CORTES",
              branchcode: "120201780",
            },
            {
              branchname: "BABAG 2",
              branchcode: "120201524",
            },
            {
              branchname: "BASAK LAPULAPU",
              branchcode: "120201538",
            },
            {
              branchname: "CORDOVA",
              branchcode: "120201864",
            },
            {
              branchname: "DAPITAN CEBU",
              branchcode: "120201409",
            },
            {
              branchname: "G.Y. LAPULAPU",
              branchcode: "120201643",
            },
            {
              branchname: "GABI CORDOVA",
              branchcode: "120201785",
            },
            {
              branchname: "GUN OB",
              branchcode: "120201307",
            },
            {
              branchname: "LAPU LAPU 1",
              branchcode: "120201065",
            },
            {
              branchname: "LAPU LAPU 2",
              branchcode: "120201067",
            },
            {
              branchname: "LAPU LAPU 3",
              branchcode: "120201068",
            },
            {
              branchname: "LAPU LAPU 6",
              branchcode: "120201578",
            },
            {
              branchname: "MANDAUE 6",
              branchcode: "120201062",
            },
            {
              branchname: "MANDAUE 7",
              branchcode: "120201945",
            },
            {
              branchname: "ROBINSONS MACTAN",
              branchcode: "120201915",
            },
            {
              branchname: "SANGI",
              branchcode: "120201358",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BANKAL",
              branchcode: "120202425",
            },
            {
              branchname: "BUAYA",
              branchcode: "120202721",
            },
            {
              branchname: "LAPU LAPU 4",
              branchcode: "120202260",
            },
            {
              branchname: "LAPU LAPU 5",
              branchcode: "120202069",
            },
            {
              branchname: "LAPU LAPU 7",
              branchcode: "120202591",
            },
            {
              branchname: "MARIBAGO",
              branchcode: "120202794",
            },
            {
              branchname: "MARIGONDON",
              branchcode: "120202710",
            },
            {
              branchname: "PAJAC",
              branchcode: "120202793",
            },
            {
              branchname: "PAKNAAN",
              branchcode: "120202407",
            },
            {
              branchname: "SITIO TIGCAHON BANKAL",
              branchcode: "120202773",
            },
            {
              branchname: "STA. ROSA, CEBU",
              branchcode: "120202865",
            },
            {
              branchname: "TINGO STA ROSA",
              branchcode: "120202772",
            },
            {
              branchname: "UN AVENUE",
              branchcode: "120202466",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "A.S. FORTUNA",
              branchcode: "120203592",
            },
            {
              branchname: "BAKILID MANDAUE",
              branchcode: "120203404",
            },
            {
              branchname: "BANILAD MANDAUE",
              branchcode: "120203488",
            },
            {
              branchname: "GUIZO",
              branchcode: "120203464",
            },
            {
              branchname: "HERNAN CORTES",
              branchcode: "120203271",
            },
            {
              branchname: "MANDAUE 1",
              branchcode: "120203058",
            },
            {
              branchname: "MANDAUE 2",
              branchcode: "120203059",
            },
            {
              branchname: "MANDAUE 3",
              branchcode: "120203060",
            },
            {
              branchname: "MANDAUE 4",
              branchcode: "120203944",
            },
            {
              branchname: "PARK MALL SHOWROOM",
              branchcode: "120203547",
            },
            {
              branchname: "PARKMALL GROUND LEVEL",
              branchcode: "120203774",
            },
            {
              branchname: "TIPOLO",
              branchcode: "120203414",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BASAK TOWN CENTER",
              branchcode: "120204585",
            },
            {
              branchname: "CABANCALAN",
              branchcode: "120204699",
            },
            {
              branchname: "CANSAGA",
              branchcode: "120204548",
            },
            {
              branchname: "CASILI CONSOLACION",
              branchcode: "120204840",
            },
            {
              branchname: "CONSOLACION 1",
              branchcode: "120204080",
            },
            {
              branchname: "CONSOLACION 2",
              branchcode: "120204081",
            },
            {
              branchname: "CONSOLACION 3",
              branchcode: "120204082",
            },
            {
              branchname: "INNER CANDUMAN",
              branchcode: "120204056",
            },
            {
              branchname: "MANDAUE 5",
              branchcode: "120204061",
            },
            {
              branchname: "MANDAUE 8",
              branchcode: "120204063",
            },
            {
              branchname: "PACIFIC MALL",
              branchcode: "120204326",
            },
            {
              branchname: "PITOGO",
              branchcode: "120204845",
            },
            {
              branchname: "PUROK 1 PITOGO",
              branchcode: "120204611",
            },
            {
              branchname: "TABOK MANDAUE",
              branchcode: "120204502",
            },
            {
              branchname: "TAYUD",
              branchcode: "120204855",
            },
          ],
        },
        
      ],
    },
    {
      region: "CEBU SOUTH REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CANSOJONG",
              branchcode: "120301629",
            },
            {
              branchname: "DUMLOG",
              branchcode: "120301702",
            },
            {
              branchname: "JACLUPAN TALISAY",
              branchcode: "120301850",
            },
            {
              branchname: "KIMBA",
              branchcode: "120301817",
            },
            {
              branchname: "LARAY",
              branchcode: "120301990",
            },
            {
              branchname: "MOHON TALISAY",
              branchcode: "120301393",
            },
            {
              branchname: "POOC TALISAY",
              branchcode: "120301392",
            },
            {
              branchname: "SAN ISIDRO",
              branchcode: "120301200",
            },
            {
              branchname: "SAN ROQUE, TALISAY CEBU",
              branchcode: "120301130",
            },
            {
              branchname: "SM SEASIDE CEBU",
              branchcode: "120301018",
            },
            {
              branchname: "LAWAAN 1 TALISAY",
              branchcode: "120301126",
            },
            {
              branchname: "TABUNOK 2",
              branchcode: "120301128",
            },
            {
              branchname: "TABUNOK 3",
              branchcode: "120301575",
            },
            {
              branchname: "TABUNOK 4",
              branchcode: "120301900",
            },
            {
              branchname: "TALISAY CEBU",
              branchcode: "120301129",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "B. ARANAS",
              branchcode: "120302017",
            },
            {
              branchname: "BELMONT ONE",
              branchcode: "120302640",
            },
            {
              branchname: "CARCAR",
              branchcode: "120302099",
            },
            {
              branchname: "CARCAR 2",
              branchcode: "120302567",
            },
            {
              branchname: "INAYAGAN",
              branchcode: "120302858",
            },
            {
              branchname: "LIPATA",
              branchcode: "120302839",
            },
            {
              branchname: "MINGLANILLA",
              branchcode: "120302123",
            },
            {
              branchname: "MINGLANILLA 2",
              branchcode: "120302666",
            },
            {
              branchname: "MINGLANILLA WARD IV",
              branchcode: "120302187",
            },
            {
              branchname: "NAGA 2",
              branchcode: "120302555",
            },
            {
              branchname: "NAGA CEBU",
              branchcode: "120302124",
            },
            {
              branchname: "SAN FERNANDO",
              branchcode: "120302103",
            },
            {
              branchname: "TUNGKOP",
              branchcode: "120302816",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALCOY",
              branchcode: "120303947",
            },
            {
              branchname: "ARGAO 1",
              branchcode: "120303096",
            },
            {
              branchname: "ARGAO 2",
              branchcode: "120303097",
            },
            {
              branchname: "BOLJOON",
              branchcode: "120303098",
            },
            {
              branchname: "DALAGUETE",
              branchcode: "120303100",
            },
            {
              branchname: "MANTALONGON",
              branchcode: "120303172",
            },
            {
              branchname: "OCANA",
              branchcode: "120303812",
            },
            {
              branchname: "OSLOB",
              branchcode: "120303101",
            },
            {
              branchname: "SANTANDER",
              branchcode: "120303566",
            },
            {
              branchname: "SIBONGA",
              branchcode: "120303104",
            },
            {
              branchname: "SIMALA",
              branchcode: "120303549",
            },
            {
              branchname: "TAN AWAN OSLOB",
              branchcode: "120303649",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ALCANTARA",
              branchcode: "120304837",
            },
            {
              branchname: "ALEGRIA CEBU",
              branchcode: "120304559",
            },
            {
              branchname: "BADIAN",
              branchcode: "120304107",
            },
            {
              branchname: "BARILI",
              branchcode: "120304110",
            },
            {
              branchname: "BARILI MERCADO",
              branchcode: "120304433",
            },
            {
              branchname: "DUMANJUG",
              branchcode: "120304111",
            },
            {
              branchname: "GINATILAN",
              branchcode: "120304836",
            },
            {
              branchname: "HIGHWAY POBLACION BARILI",
              branchcode: "120304302",
            },
            {
              branchname: "MALABUYOC",
              branchcode: "120304113",
            },
            {
              branchname: "MOALBOAL",
              branchcode: "120304114",
            },
            {
              branchname: "POBLACION EAST MOALBOAL",
              branchcode: "120304422",
            },
            {
              branchname: "RONDA, CEBU",
              branchcode: "120304116",
            },
            {
              branchname: "SAMBOAN",
              branchcode: "120304838",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "ALOGUINSAN",
              branchcode: "120305953",
            },
            {
              branchname: "ASTURIAS",
              branchcode: "120305876",
            },
            {
              branchname: "BALAMBAN",
              branchcode: "120305109",
            },
            {
              branchname: "BALAMBAN 2",
              branchcode: "120305852",
            },
            {
              branchname: "BALIRONG",
              branchcode: "120305778",
            },
            {
              branchname: "BUANOY",
              branchcode: "120305784",
            },
            {
              branchname: "JUAN CLIMACO",
              branchcode: "120305746",
            },
            {
              branchname: "LUTOPAN",
              branchcode: "120305112",
            },
            {
              branchname: "DAS LUTOPAN",
              branchcode: "120305886",
            },
            {
              branchname: "PINAMUNGAJAN",
              branchcode: "120305115",
            },
            {
              branchname: "STA. CRUZ BALAMBAN",
              branchcode: "120305630",
            },
            {
              branchname: "TOLEDO 1",
              branchcode: "120305118",
            },
            {
              branchname: "TOLEDO 2",
              branchcode: "120305834",
            },
            {
              branchname: "TOLEDO 3",
              branchcode: "120305670",
            },
          ],
        },
      ],
    },
    {
      region: "NEG.OR. - SIQ. REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "DUMAGUETE 1",
              branchcode: "120401147",
            },
            {
              branchname: "DUMAGUETE 2",
              branchcode: "120401149",
            },
            {
              branchname: "DUMAGUETE 3",
              branchcode: "120401151",
            },
            {
              branchname: "DUMAGUETE 4",
              branchcode: "120401152",
            },
            {
              branchname: "DUMAGUETE 5",
              branchcode: "120401853",
            },
            {
              branchname: "DUMAGUETE 6",
              branchcode: "120401806",
            },
            {
              branchname: "DUMAGUETE 7",
              branchcode: "120401972",
            },
            {
              branchname: "FOUNDATION",
              branchcode: "120401631",
            },
            {
              branchname: "MARKET PLACE",
              branchcode: "120401447",
            },
            {
              branchname: "POBLACION 8 DUMAGUETE",
              branchcode: "120401756",
            },
            {
              branchname: "REAL DUMAGUETE",
              branchcode: "120401330",
            },
            {
              branchname: "ROBINSON DUMAGUETE",
              branchcode: "120403653",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "AMLAN",
              branchcode: "120402758",
            },
            {
              branchname: "BAIS",
              branchcode: "120402144",
            },
            {
              branchname: "BAIS 2",
              branchcode: "120402584",
            },
            {
              branchname: "LINDBERGH DRIVE TANJAY",
              branchcode: "120402740",
            },
            {
              branchname: "LUMBANGAN",
              branchcode: "120402798",
            },
            {
              branchname: "MABINAY",
              branchcode: "120402529",
            },
            {
              branchname: "MABINI BAIS",
              branchcode: "120402418",
            },
            {
              branchname: "PAMPLONA",
              branchcode: "120402716",
            },
            {
              branchname: "SAN JOSE, NEG OR",
              branchcode: "120402899",
            },
            {
              branchname: "TANJAY 1",
              branchcode: "120402160",
            },
            {
              branchname: "TANJAY 2",
              branchcode: "120402161",
            },
            {
              branchname: "SIBULAN",
              branchcode: "120403305",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "DUMAGUETE 8",
              branchcode: "120403974",
            },
            {
              branchname: "DUMAGUETE CAPITOL",
              branchcode: "120403015",
            },
            {
              branchname: "LARENA",
              branchcode: "120403155",
            },
            {
              branchname: "LAZI",
              branchcode: "120403156",
            },
            {
              branchname: "LOOC DUMAGUETE",
              branchcode: "120403329",
            },
            {
              branchname: "MARIA SIQUIJOR",
              branchcode: "120403315",
            },
            {
              branchname: "TACLOBO",
              branchcode: "120401541",
            },
            {
              branchname: "SAN JUAN SIQUIJOR",
              branchcode: "120403813",
            },
            {
              branchname: "SIQUIJOR",
              branchcode: "120403158",
            },
            {
              branchname: "ST. PAUL",
              branchcode: "120403975",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BAGACAY",
              branchcode: "120404148",
            },
            {
              branchname: "BANILAD DUMAGUETE",
              branchcode: "120404689",
            },
            {
              branchname: "BASAY",
              branchcode: "120404678",
            },
            {
              branchname: "BAYAWAN",
              branchcode: "120404145",
            },
            {
              branchname: "BAYAWAN 2",
              branchcode: "120404595",
            },
            {
              branchname: "BONAWON",
              branchcode: "120404324",
            },
            {
              branchname: "DAUIN",
              branchcode: "120404576",
            },
            {
              branchname: "MAGSAYSAY BAYAWAN",
              branchcode: "120404620",
            },
            {
              branchname: "SIATON",
              branchcode: "120404157",
            },
            {
              branchname: "STA. CATALINA, NEG OR",
              branchcode: "120404159",
            },
            {
              branchname: "VALENCIA",
              branchcode: "120404764",
            },
            {
              branchname: "ZAMBOANGITA",
              branchcode: "120404539",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "AYUNGON",
              branchcode: "120405808",
            },
            {
              branchname: "BINDOY",
              branchcode: "120405016",
            },
            {
              branchname: "CANLAON",
              branchcode: "120405146",
            },
            {
              branchname: "CANLAON 2",
              branchcode: "120405588",
            },
            {
              branchname: "GUIHULNGAN",
              branchcode: "120405153",
            },
            {
              branchname: "HILAITAN",
              branchcode: "120405456",
            },
            {
              branchname: "JIMALALUD",
              branchcode: "120405154",
            },
            {
              branchname: "LA LIBERTAD, NEG OR",
              branchcode: "120405744",
            },
            {
              branchname: "MANJUYOD",
              branchcode: "120405530",
            },
            {
              branchname: "TAYASAN",
              branchcode: "120405657",
            },
            {
              branchname: "VALLEHERMOSO",
              branchcode: "120405035",
            },
            {
              branchname: "ZULUETA MANJUYOD",
              branchcode: "120405820",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "ML SIQUIJOR PORT",
              branchcode: "120405906",
            },
          ],
        },
      ],
    },
    {
      region: "BOHOL REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ALBURQUERQUE",
              branchcode: "120501570",
            },
            {
              branchname: "DIMIAO",
              branchcode: "120501717",
            },
            {
              branchname: "GARCIA HERNANDEZ",
              branchcode: "120501454",
            },
            {
              branchname: "JAGNA BOHOL",
              branchcode: "120501133",
            },
            {
              branchname: "JAGNA PAGINA",
              branchcode: "120501369",
            },
            {
              branchname: "LILA",
              branchcode: "120501804",
            },
            {
              branchname: "LOAY BOHOL",
              branchcode: "120501950",
            },
            {
              branchname: "LOBOC",
              branchcode: "120501659",
            },
            {
              branchname: "SEVILLA",
              branchcode: "120501383",
            },
            {
              branchname: "SIKATUNA BOHOL",
              branchcode: "120501849",
            },
            {
              branchname: "TAGBILARAN 2",
              branchcode: "120501138",
            },
            {
              branchname: "TAGBILARAN 2 TEST",
              branchcode: "120501138",
            },
            {
              branchname: "TAGBILARAN 4",
              branchcode: "120501140",
            },
            {
              branchname: "VALENCIA, BOHOL",
              branchcode: "120501021",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ALTURAS SHOWROOM",
              branchcode: "120502380",
            },
            {
              branchname: "ANTEQUERA",
              branchcode: "120502684",
            },
            {
              branchname: "B AQUINO TAGBILARAN",
              branchcode: "120502010",
            },
            {
              branchname: "BALILIHAN",
              branchcode: "120502641",
            },
            {
              branchname: "CALAPE",
              branchcode: "120502714",
            },
            {
              branchname: "CATIGBIAN",
              branchcode: "120502102",
            },
            {
              branchname: "CHATTO DRIVE",
              branchcode: "120502819",
            },
            {
              branchname: "ICM",
              branchcode: "120502769",
            },
            {
              branchname: "LOON BOHOL",
              branchcode: "120502134",
            },
            {
              branchname: "MANGA",
              branchcode: "120502741",
            },
            {
              branchname: "MARIBOJOC",
              branchcode: "120502715",
            },
            {
              branchname: "TAGBILARAN 3",
              branchcode: "120502139",
            },
            {
              branchname: "TAGBILARAN 6",
              branchcode: "120502518",
            },
            {
              branchname: "TUBIGON BOHOL",
              branchcode: "120502142",
            },
            {
              branchname: "ICM LEVEL 2",
              branchcode: "120502863",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALICIA BOHOL",
              branchcode: "120503637",
            },
            {
              branchname: "ANDA",
              branchcode: "120503708",
            },
            {
              branchname: "CANDIJAY",
              branchcode: "120503638",
            },
            {
              branchname: "DUERO",
              branchcode: "120503681",
            },
            {
              branchname: "GUINDULMAN",
              branchcode: "120503871",
            },
            {
              branchname: "MABINI BOHOL",
              branchcode: "120503012",
            },
            {
              branchname: "PRES. C. P. GARCIA",
              branchcode: "120503680",
            },
            {
              branchname: "SAN PASCUAL UBAY",
              branchcode: "120503572",
            },
            {
              branchname: "UBAY BOHOL",
              branchcode: "120503143",
            },
            {
              branchname: "UBAY GARCES",
              branchcode: "120503222",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ALTURAS TALIBON",
              branchcode: "120504552",
            },
            {
              branchname: "BUENAVISTA",
              branchcode: "120504761",
            },
            {
              branchname: "CABULIJAN",
              branchcode: "120504521",
            },
            {
              branchname: "CLARIN NATIONAL HIGHWAY",
              branchcode: "120504482",
            },
            {
              branchname: "DANAO BOHOL",
              branchcode: "120504009",
            },
            {
              branchname: "GETAFE",
              branchcode: "120504642",
            },
            {
              branchname: "INABANGA",
              branchcode: "120504132",
            },
            {
              branchname: "LAPACAN SUR",
              branchcode: "120504483",
            },
            {
              branchname: "SAGBAYAN",
              branchcode: "120504951",
            },
            {
              branchname: "TALIBON",
              branchcode: "120504141",
            },
            {
              branchname: "TALIBON 2",
              branchcode: "120504966",
            },
            {
              branchname: "ML SAN JOSE TALIBON",
              branchcode: "120504887",
            },
            {
              branchname: "ML POOC OCCIDENTAL",
              branchcode: "120504885",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BAGUMBAYAN PILAR",
              branchcode: "120505497",
            },
            {
              branchname: "BATUAN",
              branchcode: "120505682",
            },
            {
              branchname: "BIEN UNIDO",
              branchcode: "120505752",
            },
            {
              branchname: "BILAR",
              branchcode: "120505768",
            },
            {
              branchname: "CARMEN BOHOL",
              branchcode: "120505131",
            },
            {
              branchname: "DAGOHOY",
              branchcode: "120505381",
            },
            {
              branchname: "LA HACIENDA ALICIA",
              branchcode: "120505826",
            },
            {
              branchname: "PILAR, BOHOL",
              branchcode: "120505734",
            },
            {
              branchname: "SAN MIGUEL",
              branchcode: "120505690",
            },
            {
              branchname: "SIERRA BULLONES",
              branchcode: "120505135",
            },
            {
              branchname: "TRINIDAD",
              branchcode: "120505345",
            },
            {
              branchname: "ML POBLACION SUR CARMEN",
              branchcode: "120505031",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "BQ MALL",
              branchcode: "120506032",
            },
            {
              branchname: "CITY SQUARE TAGBILARAN",
              branchcode: "120506406",
            },
            {
              branchname: "COGON TAGBILARAN",
              branchcode: "120506719",
            },
            {
              branchname: "GALLARES",
              branchcode: "120506777",
            },
            {
              branchname: "PANGLAO",
              branchcode: "120506613",
            },
            {
              branchname: "PANGLAO MARKET",
              branchcode: "120506922",
            },
            {
              branchname: "PANGLAO TAWALA",
              branchcode: "120506091",
            },
            {
              branchname: "TAGBILARAN 1",
              branchcode: "120506137",
            },
            {
              branchname: "TAGBILARAN 5",
              branchcode: "120506952",
            },
            {
              branchname: "TOTOLAN DAUIS",
              branchcode: "120506489",
            },
             {
              branchname: "ML MH DEL PILAR",
              branchcode: "120506879",
            },
          ],
        },
      ],
    },
    {
      region: "LEYTE A REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ALBUERA",
              branchcode: "120601949",
            },
            {
              branchname: "ALBUERA HIGHWAY",
              branchcode: "120601372",
            },
            {
              branchname: "AVILES ORMOC",
              branchcode: "120601802",
            },
            {
              branchname: "COGON ORMOC",
              branchcode: "120601322",
            },
            {
              branchname: "DISTRICT 13  ORMOC",
              branchcode: "120601405",
            },
            {
              branchname: "GAISANO CAPITAL CENTRAL MALL ORMOC",
              branchcode: "120601703",
            },
            {
              branchname: "LOPEZ JAENA ORMOC",
              branchcode: "120601733",
            },
            {
              branchname: "ORMOC 1",
              branchcode: "120601212",
            },
            {
              branchname: "ORMOC 2",
              branchcode: "120601214",
            },
            {
              branchname: "ORMOC 3",
              branchcode: "120601645",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "DONA FELIZA MEJIA",
              branchcode: "120608527",
            },
            {
              branchname: "ISABEL",
              branchcode: "120608208",
            },
            {
              branchname: "MABINI ISABEL",
              branchcode: "120608732",
            },
            {
              branchname: "MATAG OB",
              branchcode: "120608650",
            },
            {
              branchname: "MERIDA LEYTE",
              branchcode: "120608782",
            },
            {
              branchname: "PALOMPON",
              branchcode: "120608215",
            },
            {
              branchname: "VALENCIA ORMOC",
              branchcode: "120601460",
            },
            {
              branchname: "SAN PABLO ORMOC",
              branchcode: "120608790",
            },
            {
              branchname: "GAISANO CAPITAL ORMOC RIVERSIDE",
              branchcode: "120601321",
            },
            {
              branchname: "ML LINAO ORMOC",
              branchcode: "120602893",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BAGARES SOGOD",
              branchcode: "120603301",
            },
            {
              branchname: "BONTOC",
              branchcode: "120603807",
            },
            {
              branchname: "CABALIAN SAN JUAN LEYTE",
              branchcode: "120603223",
            },
            {
              branchname: "GAISANO CAPITAL SOGOD",
              branchcode: "120603574",
            },
            {
              branchname: "HINUNANGAN",
              branchcode: "120603754",
            },
            {
              branchname: "HINUNDAYAN",
              branchcode: "120603507",
            },
            {
              branchname: "LILOAN LEYTE",
              branchcode: "120603226",
            },
            {
              branchname: "PINTUYAN",
              branchcode: "120603753",
            },
            {
              branchname: "SOGOD 1 LEYTE",
              branchcode: "120603229",
            },
            {
              branchname: "SOGOD 2 LEYTE",
              branchcode: "120603230",
            },
            {
              branchname: "ST. BERNARD",
              branchcode: "120603755",
            },
             {
              branchname: "LILOAN HIGHWAY",
              branchcode: "120603910",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BAYBAY 1",
              branchcode: "120604221",
            },
            {
              branchname: "BAYBAY 3 LEYTE",
              branchcode: "120604872",
            },
            {
              branchname: "BAYBAY CARIDAD",
              branchcode: "120604520",
            },
            {
              branchname: "HILONGOS",
              branchcode: "120604224",
            },
            {
              branchname: "HILONGOS FULACHE",
              branchcode: "120604494",
            },
            {
              branchname: "HILONGOS VILLAFLORES",
              branchcode: "120604461",
            },
            {
              branchname: "HINDANG",
              branchcode: "120604634",
            },
            {
              branchname: "INOPACAN",
              branchcode: "120604225",
            },
            {
              branchname: "MAHAPLAG",
              branchcode: "120604410",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BATO LEYTE",
              branchcode: "120606219",
            },
            {
              branchname: "JOSE RIZAL BATO",
              branchcode: "120606742",
            },
            {
              branchname: "MAASIN 1",
              branchcode: "120606227",
            },
            {
              branchname: "MAASIN 2",
              branchcode: "120606228",
            },
            {
              branchname: "MAASIN R KANGLEON",
              branchcode: "120606323",
            },
            {
              branchname: "MAASIN RAFOLS",
              branchcode: "120606300",
            },
            {
              branchname: "MALITBOG",
              branchcode: "120606698",
            },
            {
              branchname: "MATALOM",
              branchcode: "120606448",
            },
            {
              branchname: "PADRE BURGOS",
              branchcode: "120606618",
            },
            {
              branchname: "TUNGA TUNGA MAASIN",
              branchcode: "120606791",
            },
          ],
        },
      ],
    },
    {
      region: "SAMAR REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CALBAYOG 1",
              branchcode: "120701232",
            },
            {
              branchname: "CALBAYOG 2",
              branchcode: "120701234",
            },
            {
              branchname: "CALBAYOG 3",
              branchcode: "120701607",
            },
            {
              branchname: "CALBAYOG 4",
              branchcode: "120701824",
            },
            {
              branchname: "GANDARA",
              branchcode: "120701544",
            },
            {
              branchname: "JD AVELINO CALBAYOG",
              branchcode: "120701011",
            },
            {
              branchname: "METRO GAISANO CALBAYOG",
              branchcode: "120701359",
            },
            {
              branchname: "SAN JOAQUIN, SAMAR",
              branchcode: "120701421",
            },
            {
              branchname: "SAN JORGE",
              branchcode: "120701412",
            },
            {
              branchname: "STA. MARGARITA",
              branchcode: "120701647",
            },
            {
              branchname: "TARANGNAN",
              branchcode: "120701423",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ARTECHE",
              branchcode: "120702451",
            },
            {
              branchname: "BORONGAN",
              branchcode: "120702873",
            },
            {
              branchname: "BORONGAN 2",
              branchcode: "120702534",
            },
            {
              branchname: "CAN AVID",
              branchcode: "120702969",
            },
            {
              branchname: "DOLORES, SAMAR",
              branchcode: "120702998",
            },
            {
              branchname: "LLORENTE",
              branchcode: "120702762",
            },
            {
              branchname: "MAYDOLONG",
              branchcode: "120702303",
            },
            {
              branchname: "ORAS",
              branchcode: "120702596",
            },
            {
              branchname: "SAN POLICARPO",
              branchcode: "120702571",
            },
            {
              branchname: "SULAT",
              branchcode: "120702013",
            },
            {
              branchname: "TAFT, SAMAR",
              branchcode: "120702525",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALLEN, SAMAR",
              branchcode: "120703231",
            },
            {
              branchname: "CATARMAN 1",
              branchcode: "120703235",
            },
            {
              branchname: "CATARMAN 2",
              branchcode: "120703503",
            },
            {
              branchname: "DALAKIT",
              branchcode: "120703397",
            },
            {
              branchname: "JACINTO, CATARMAN",
              branchcode: "120703022",
            },
            {
              branchname: "LAOANG",
              branchcode: "120703598",
            },
            {
              branchname: "LAVEZARES",
              branchcode: "120703655",
            },
            {
              branchname: "MONDRAGON",
              branchcode: "120703799",
            },
            {
              branchname: "SAN ISIDRO, SAMAR",
              branchcode: "120703594",
            },
            {
              branchname: "SAN JOSE, SAMAR",
              branchcode: "120703700",
            },
            {
              branchname: "SAN ROQUE, SAMAR",
              branchcode: "120703619",
            },
            {
              branchname: "UEP",
              branchcode: "120703468",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BALANGIGA",
              branchcode: "120704617",
            },
            {
              branchname: "BASEY",
              branchcode: "120704192",
            },
            {
              branchname: "GEN MAC SAMAR",
              branchcode: "120704239",
            },
            {
              branchname: "GIPORLOS",
              branchcode: "120704458",
            },
            {
              branchname: "GUIUAN 2",
              branchcode: "120704646",
            },
            {
              branchname: "GUIUAN SAMAR",
              branchcode: "120704238",
            },
            {
              branchname: "LAWAAN, SAMAR",
              branchcode: "120704452",
            },
            {
              branchname: "QUINAPONDAN",
              branchcode: "120704989",
            },
            {
              branchname: "SALCEDO",
              branchcode: "120704352",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BURAY",
              branchcode: "120705648",
            },
            {
              branchname: "CALBIGA",
              branchcode: "120705704",
            },
            {
              branchname: "CATBALOGAN 1",
              branchcode: "120705236",
            },
            {
              branchname: "CATBALOGAN 2",
              branchcode: "120705237",
            },
            {
              branchname: "CATBALOGAN PUBLIC MARKET",
              branchcode: "120705469",
            },
            {
              branchname: "HINABANGAN",
              branchcode: "120705444",
            },
            {
              branchname: "JIABONG",
              branchcode: "120705743",
            },
            {
              branchname: "MAULONG",
              branchcode: "120705413",
            },
            {
              branchname: "PINABACDAO",
              branchcode: "120705825",
            },
            {
              branchname: "VILLAREAL",
              branchcode: "120705445",
            },
          ],
        },
      ],
    },
    {
      region: "NEGROS OCCIDENTAL A REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "888 MALL",
              branchcode: "120801415",
            },
            {
              branchname: "ARANETA",
              branchcode: "120801163",
            },
            {
              branchname: "GATUSLAO",
              branchcode: "120801176",
            },
            {
              branchname: "LACSON",
              branchcode: "120801925",
            },
            {
              branchname: "LACSON BRGY 5",
              branchcode: "120801417",
            },
            {
              branchname: "LOCSIN",
              branchcode: "120801624",
            },
            {
              branchname: "SHOPPING",
              branchcode: "120801449",
            },
            {
              branchname: "VILLAMONTE",
              branchcode: "120801597",
            },
            {
              branchname: "YULO",
              branchcode: "120801556",
            },
            {
              branchname: "SINGCANG",
              branchcode: "120804179",
            },
            {
              branchname: "SUM AG",
              branchcode: "120804580",
            },
            {
              branchname: "BRGY ALIJIS",
              branchcode: "120804923",
            },
            {
              branchname: "GONZAGA",
              branchcode: "120801857",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "CABAHUG CADIZ",
              branchcode: "120802299",
            },
            {
              branchname: "CADIZ",
              branchcode: "120802183",
            },
            {
              branchname: "CALATRAVA",
              branchcode: "120802184",
            },
            {
              branchname: "ESCALANTE",
              branchcode: "120802185",
            },
            {
              branchname: "FABRICA",
              branchcode: "120802751",
            },
            {
              branchname: "FC LEDESMA",
              branchcode: "120802365",
            },
            {
              branchname: "MAGSAYSAY",
              branchcode: "120802924",
            },
            {
              branchname: "MANAPLA",
              branchcode: "120802636",
            },
            {
              branchname: "POBLACION SAGAY",
              branchcode: "120802763",
            },
            {
              branchname: "SAGAY",
              branchcode: "120802186",
            },
            {
              branchname: "SAN CARLOS 1",
              branchcode: "120802188",
            },
            {
              branchname: "SAN CARLOS 2",
              branchcode: "120802189",
            },
            {
              branchname: "TOBOSO",
              branchcode: "120802190",
            },
            {
              branchname: "ML Maranon Sagay",
              branchcode: "120802883",
            },
            {
              branchname: "ML BALINTAWAK ESCALANTE",
              branchcode: "120802905",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALANGILAN",
              branchcode: "120803194",
            },
            {
              branchname: "BURGOS 1",
              branchcode: "120803174",
            },
            {
              branchname: "BURGOS 2",
              branchcode: "120803994",
            },
            {
              branchname: "FORTUNE TOWNE",
              branchcode: "120803901",
            },
            {
              branchname: "GRANADA",
              branchcode: "120803705",
            },
            {
              branchname: "HOMESITE",
              branchcode: "120803614",
            },
            {
              branchname: "LIBERTAD 2",
              branchcode: "120803173",
            },
            {
              branchname: "MABINI  OCC.",
              branchcode: "120803870",
            },
            {
              branchname: "MANSILINGAN",
              branchcode: "120803987",
            },
            {
              branchname: "MURCIA",
              branchcode: "120803823",
            },
            {
              branchname: "TACULING",
              branchcode: "120803317",
            },
            {
              branchname: "VICTORINA",
              branchcode: "120803434",
            },
            {
              branchname: "HANDUMANAN",
              branchcode: "120804601",
            },
            {
              branchname: "ALIJIS CIRCUMFERENTIAL",
              branchcode: "120804898",
            },
            {
              branchname: "MANSILINGAN ALIJIS",
              branchcode: "120804854",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "AYALA BACOLOD SHOWROOM",
              branchcode: "120806658",
            },
            {
              branchname: "BANAGO",
              branchcode: "120806809",
            },
            {
              branchname: "BATA",
              branchcode: "120806609",
            },
            {
              branchname: "BONIFACIO SILAY",
              branchcode: "120806492",
            },
            {
              branchname: "CAPITAN SABI",
              branchcode: "120806442",
            },
            {
              branchname: "EB MAGALONA",
              branchcode: "120806801",
            },
            {
              branchname: "MANDALAGAN",
              branchcode: "120806177",
            },
            {
              branchname: "ROBINSONS BACOLOD",
              branchcode: "120806632",
            },
            {
              branchname: "SILAY",
              branchcode: "120806178",
            },
            {
              branchname: "TALISAY 2",
              branchcode: "120806738",
            },
            {
              branchname: "TALISAY NEG OCC.",
              branchcode: "120806180",
            },
            {
              branchname: "VICTORIAS 1",
              branchcode: "120806181",
            },
            {
              branchname: "VICTORIAS 2",
              branchcode: "120806182",
            },
            {
              branchname: "ML MAGSAYSAY TALISAY",
              branchcode: "120804894",
            },
          ],
        },
      ],
    },
    {
      region: "PANAY SOUTH REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "AVANCENA",
              branchcode: "120901459",
            },
            {
              branchname: "GUIMBAL",
              branchcode: "120901268",
            },
            {
              branchname: "IGBARAS",
              branchcode: "120901662",
            },
            {
              branchname: "MIAG AO",
              branchcode: "120901044",
            },
            {
              branchname: "MOHON",
              branchcode: "120901918",
            },
            {
              branchname: "MOLO",
              branchcode: "120901262",
            },
            {
              branchname: "OTON",
              branchcode: "120901842",
            },
            {
              branchname: "SAN JOAQUIN ILOILO",
              branchcode: "120901523",
            },
            {
              branchname: "TIGBAUAN",
              branchcode: "120901295",
            },
            {
              branchname: "TUBUNGAN",
              branchcode: "120901788",
            },
            {
              branchname: "VILLA",
              branchcode: "120901729",
            },
            {
              branchname: "ML SAN JOSE SAN MIGUEL",
              branchcode: "120901888",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ALIMODIAN",
              branchcode: "120902510",
            },
            {
              branchname: "DE LEON PANAY/ROMBLON",
              branchcode: "120902293",
            },
            {
              branchname: "GUANCO",
              branchcode: "120902266",
            },
            {
              branchname: "GUZMAN MANDURRIAO",
              branchcode: "120902709",
            },
            {
              branchname: "JIBAO AN PAVIA",
              branchcode: "120902270",
            },
            {
              branchname: "LEDESMA, VALERIA",
              branchcode: "120902259",
            },
            {
              branchname: "LEON PANAY/ROMBLON",
              branchcode: "120902276",
            },
            {
              branchname: "MANDURIAO 2",
              branchcode: "120902783",
            },
            {
              branchname: "MANDURRIAO",
              branchcode: "120902278",
            },
            {
              branchname: "RIZAL, ILOILO",
              branchcode: "120902296",
            },
            {
              branchname: "SAN AGUSTIN ILOILO",
              branchcode: "120902286",
            },
            {
              branchname: "SAN MIGUEL, PANAY/ROMBLON",
              branchcode: "120902509",
            },
            {
              branchname: "SM CITY ILOILO SHOWROOM",
              branchcode: "120902004",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ARROYO  STA. BARBARA",
              branchcode: "120903477",
            },
            {
              branchname: "AYAMAN",
              branchcode: "120903928",
            },
            {
              branchname: "BO OBRERO",
              branchcode: "120903430",
            },
            {
              branchname: "CABATUAN",
              branchcode: "120903265",
            },
            {
              branchname: "ILONGA",
              branchcode: "120903269",
            },
            {
              branchname: "IZNART",
              branchcode: "120903294",
            },
            {
              branchname: "LA PAZ",
              branchcode: "120903258",
            },
            {
              branchname: "LAPAZ 2",
              branchcode: "120903828",
            },
            {
              branchname: "MAASIN ILOILO",
              branchcode: "120903672",
            },
            {
              branchname: "NEW LUCENA",
              branchcode: "120903800",
            },
            {
              branchname: "PAVIA",
              branchcode: "120903514",
            },
            {
              branchname: "STA. BARBARA",
              branchcode: "120903279",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BOLONG OESTE",
              branchcode: "120904765",
            },
            {
              branchname: "BURGOS LAPAZ",
              branchcode: "120904694",
            },
            {
              branchname: "JALAUD",
              branchcode: "120904399",
            },
            {
              branchname: "JARO 1 PANROM",
              branchcode: "120904256",
            },
            {
              branchname: "JARO 2 (PLAZA) PANROM",
              branchcode: "120904257",
            },
            {
              branchname: "JARO 3 (MISSION) PANROM",
              branchcode: "120904261",
            },
            {
              branchname: "JARO 4 [CPU] PANROM",
              branchcode: "120904255",
            },
            {
              branchname: "JARO 5 (TABUC SUBA) PANROM",
              branchcode: "120904263",
            },
            {
              branchname: "JARO 6",
              branchcode: "120904676",
            },
            {
              branchname: "LEGANES",
              branchcode: "120904563",
            },
            {
              branchname: "TAGBAK",
              branchcode: "120904473",
            },
            {
              branchname: "UNGKA",
              branchcode: "120904551",
            },
            {
              branchname: "ZARRAGA",
              branchcode: "120904693",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "CABALAGNAN",
              branchcode: "120905499",
            },
            {
              branchname: "CALINGAO",
              branchcode: "120905543",
            },
            {
              branchname: "GUIMARAS",
              branchcode: "120905267",
            },
            {
              branchname: "J.M. BASA",
              branchcode: "120905273",
            },
            {
              branchname: "JORDAN",
              branchcode: "120905274",
            },
            {
              branchname: "JORDAN PIER",
              branchcode: "120905275",
            },
            {
              branchname: "NUEVA VALENCIA",
              branchcode: "120905745",
            },
            {
              branchname: "ROTONDA",
              branchcode: "120905522",
            },
            {
              branchname: "SAN LORENZO",
              branchcode: "120905373",
            },
            {
              branchname: "SAN MIGUEL JORDAN",
              branchcode: "120905757",
            },
            {
              branchname: "SIBUNAG",
              branchcode: "120905411",
            },
          ],
        },
      ],
    },
    {
      region: "PANAY NORTH REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ALTAVAS",
              branchcode: "121001280",
            },
            {
              branchname: "BALETE",
              branchcode: "121001696",
            },
            {
              branchname: "BANGA, AKLAN",
              branchcode: "121001537",
            },
            {
              branchname: "BATAN",
              branchcode: "121001420",
            },
            {
              branchname: "IBAJAY",
              branchcode: "121001284",
            },
            {
              branchname: "KALIBO",
              branchcode: "121001285",
            },
            {
              branchname: "KALIBO 3",
              branchcode: "121001673",
            },
            {
              branchname: "LIBACAO",
              branchcode: "121001920",
            },
            {
              branchname: "MAKATO",
              branchcode: "121001308",
            },
            {
              branchname: "NEW WASHINGTON",
              branchcode: "121001582",
            },
            {
              branchname: "NUMANCIA",
              branchcode: "121001426",
            },
            {
              branchname: "QUEZON AVENUE KALIBO",
              branchcode: "121001946",
            },
            {
              branchname: "TANGALAN",
              branchcode: "121001720",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BARBAZA",
              branchcode: "121002320",
            },
            {
              branchname: "BORACAY",
              branchcode: "121002281",
            },
            {
              branchname: "BURUANGA",
              branchcode: "121002810",
            },
            {
              branchname: "CATICLAN",
              branchcode: "121002396",
            },
            {
              branchname: "CULASI",
              branchcode: "121002079",
            },
            {
              branchname: "DMALL DBORACAY",
              branchcode: "121002875",
            },
            {
              branchname: "LIBERTAD ANTIQUE",
              branchcode: "121002316",
            },
            {
              branchname: "NABAS",
              branchcode: "121002697",
            },
            {
              branchname: "OYOTORONG",
              branchcode: "121002290",
            },
            {
              branchname: "PANDAN",
              branchcode: "121002057",
            },
            {
              branchname: "TIBIAO",
              branchcode: "121002711",
            },
            {
              branchname: "YAPAK",
              branchcode: "121002590",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ANINI Y",
              branchcode: "121003726",
            },
            {
              branchname: "ANTIQUE",
              branchcode: "121003264",
            },
            {
              branchname: "ATABAY SAN JOSE",
              branchcode: "121003438",
            },
            {
              branchname: "BELISON",
              branchcode: "121003437",
            },
            {
              branchname: "BUGASONG",
              branchcode: "121003036",
            },
            {
              branchname: "HAMTIC",
              branchcode: "121003066",
            },
            {
              branchname: "LAUA AN",
              branchcode: "121003319",
            },
            {
              branchname: "PATNONGON",
              branchcode: "121003677",
            },
            {
              branchname: "SAN JOSE",
              branchcode: "121003712",
            },
            {
              branchname: "SAN REMIGIO ANTIQUE",
              branchcode: "121003627",
            },
            {
              branchname: "SIBALOM",
              branchcode: "121003628",
            },
            {
              branchname: "TOBIAS FORNIER",
              branchcode: "121003593",
            },
            {
              branchname: "VALDERRAMA",
              branchcode: "121003436",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ALCANTARA ROMBLON",
              branchcode: "121004385",
            },
            {
              branchname: "CAJIDIOCAN",
              branchcode: "121004725",
            },
            {
              branchname: "CALATRAVA, CAAR",
              branchcode: "121004727",
            },
            {
              branchname: "LOOC",
              branchcode: "121004287",
            },
            {
              branchname: "MAGDIWANG",
              branchcode: "121004384",
            },
            {
              branchname: "ODIONGAN",
              branchcode: "121004289",
            },
            {
              branchname: "ODIONGAN 2",
              branchcode: "121004583",
            },
            {
              branchname: "ODIONGAN 3",
              branchcode: "121004724",
            },
            {
              branchname: "ROMBLON",
              branchcode: "121004291",
            },
            {
              branchname: "SAN AGUSTIN, CAAR",
              branchcode: "121004731",
            },
            {
              branchname: "SAN ANDRES",
              branchcode: "121004639",
            },
            {
              branchname: "SAN FERNANDO ROMBLON",
              branchcode: "121004386",
            },
            {
              branchname: "STA. FE, CAAR",
              branchcode: "121004730",
            },
          ],
        },
      ],
    },
    {
      region: "PANAY CENTRAL REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BALASAN",
              branchcode: "121101786",
            },
            {
              branchname: "BATAD",
              branchcode: "121101439",
            },
            {
              branchname: "CARLES",
              branchcode: "121101787",
            },
            {
              branchname: "ESTANCIA",
              branchcode: "121101245",
            },
            {
              branchname: "GAISANO CITY ROXAS",
              branchcode: "121101652",
            },
            {
              branchname: "LUTOD LUTOD",
              branchcode: "121101246",
            },
            {
              branchname: "MAAYON",
              branchcode: "121101561",
            },
            {
              branchname: "PANAY",
              branchcode: "121101747",
            },
            {
              branchname: "PANIT AN",
              branchcode: "121101668",
            },
            {
              branchname: "PONTEVEDRA",
              branchcode: "121101248",
            },
            {
              branchname: "ROXAS 2",
              branchcode: "121101252",
            },
            {
              branchname: "SM CITY ROXAS JEWELLERS",
              branchcode: "121101859",
            },
            {
              branchname: "BANICA PANAY CENTRAL",
              branchcode: "121101907",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "DAO",
              branchcode: "121102498",
            },
            {
              branchname: "DUMALAG",
              branchcode: "121102283",
            },
            {
              branchname: "IVISAN",
              branchcode: "121102136",
            },
            {
              branchname: "JAMINDAN",
              branchcode: "121102679",
            },
            {
              branchname: "MAMBUSAO",
              branchcode: "121102288",
            },
            {
              branchname: "ROXAS 1",
              branchcode: "121102251",
            },
            {
              branchname: "ROXAS 3",
              branchcode: "121102250",
            },
            {
              branchname: "ROXAS 4, BAGONG LIPUNAN",
              branchcode: "121102843",
            },
            {
              branchname: "SAPIAN",
              branchcode: "121102453",
            },
            {
              branchname: "SIGMA",
              branchcode: "121102254",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BINGAWAN",
              branchcode: "121103379",
            },
            {
              branchname: "CALINOG",
              branchcode: "121103297",
            },
            {
              branchname: "CALINOG 2",
              branchcode: "121103535",
            },
            {
              branchname: "CUARTERO",
              branchcode: "121103282",
            },
            {
              branchname: "DUENAS",
              branchcode: "121103660",
            },
            {
              branchname: "DUMARAO",
              branchcode: "121103416",
            },
            {
              branchname: "JANIUAY",
              branchcode: "121103272",
            },
            {
              branchname: "LAMBUNAO",
              branchcode: "121103277",
            },
            {
              branchname: "LAMBUNAO 2",
              branchcode: "121103775",
            },
            {
              branchname: "MINA",
              branchcode: "121103623",
            },
            {
              branchname: "PASSI",
              branchcode: "121103247",
            },
            {
              branchname: "SAN RAFAEL",
              branchcode: "121103431",
            },
            {
              branchname: "SIMEON PASSI",
              branchcode: "121103513",
            },
            {
              branchname: "TAPAZ",
              branchcode: "121103292",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "CRISPIN SALAZAR",
              branchcode: "121104528",
            },
            {
              branchname: "DINGLE",
              branchcode: "121104919",
            },
            {
              branchname: "DUMANGAS",
              branchcode: "121104244",
            },
            {
              branchname: "DUMANGAS 2",
              branchcode: "121104779",
            },
            {
              branchname: "PARCON",
              branchcode: "121104429",
            },
            {
              branchname: "POTOTAN",
              branchcode: "121104249",
            },
            {
              branchname: "SAN ENRIQUE",
              branchcode: "121104718",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "AJUY",
              branchcode: "121105827",
            },
            {
              branchname: "ANILAO",
              branchcode: "121105474",
            },
            {
              branchname: "BANATE",
              branchcode: "121105557",
            },
            {
              branchname: "BAROTAC VIEJO",
              branchcode: "121105242",
            },
            {
              branchname: "BTAC. NUEVO",
              branchcode: "121105241",
            },
            {
              branchname: "CONCEPCION, ILOILO",
              branchcode: "121105243",
            },
            {
              branchname: "LEMERY",
              branchcode: "121105220",
            },
            {
              branchname: "RECTO",
              branchcode: "121105927",
            },
            {
              branchname: "RIZAL BAROTAC VIEJO",
              branchcode: "121105880",
            },
            {
              branchname: "SALCEDO SARA",
              branchcode: "121105517",
            },
            {
              branchname: "SAN DIONISIO",
              branchcode: "121105467",
            },
            {
              branchname: "SARA, ILOILO",
              branchcode: "121105253",
            },
            {
              branchname: "ML POBLACION BAROTAC NUEVO",
              branchcode: "121105895",
            }
          ],
        },
      ],
    },
    {
      region: "PALAWAN REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BURGOS PALAWAN",
              branchcode: "122501376",
            },
            {
              branchname: "JUNCTION 1",
              branchcode: "122501350",
            },
            {
              branchname: "NCC MALL, PALAWAN",
              branchcode: "122501348",
            },
            {
              branchname: "PALAWAN 1, RIZAL AVE.",
              branchcode: "122501360",
            },
            {
              branchname: "PALAWAN 12, VALENCIA",
              branchcode: "122501344",
            },
            {
              branchname: "PALAWAN 4, BURGOS",
              branchcode: "122501362",
            },
            {
              branchname: "ROBINSON PALAWAN",
              branchcode: "122501982",
            },
            {
              branchname: "SABANG PALAWAN",
              branchcode: "122501723",
            },
            {
              branchname: "SM JEWELLERS PALAWAN",
              branchcode: "122501545",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ABORLAN",
              branchcode: "122502361",
            },
            {
              branchname: "CUYO",
              branchcode: "122502735",
            },
            {
              branchname: "MANALO EXTENSION",
              branchcode: "122502771",
            },
            {
              branchname: "PALAWAN 6, SAN PEDRO",
              branchcode: "122502339",
            },
            {
              branchname: "PALAWAN 9, BALTAN",
              branchcode: "122502355",
            },
            {
              branchname: "SAN JOSE, PALAWAN",
              branchcode: "122502366",
            },
            {
              branchname: "SAN MANUEL",
              branchcode: "122502486",
            },
            {
              branchname: "SICSICAN",
              branchcode: "122502462",
            },
            {
              branchname: "STA. MONICA",
              branchcode: "122502402",
            },
            {
              branchname: "TINIGUIBAN",
              branchcode: "122502340",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ABO ABO",
              branchcode: "122503370",
            },
            {
              branchname: "BALABAC",
              branchcode: "122503335",
            },
            {
              branchname: "BATARAZA",
              branchcode: "122503367",
            },
            {
              branchname: "BROOKES POINT",
              branchcode: "122503424",
            },
            {
              branchname: "ML PORT MAPUN",
              branchcode: "122503480",
            },
            {
              branchname: "MAHALU MAPUN",
              branchcode: "122503479",
            },
            {
              branchname: "MAPUN",
              branchcode: "122503542",
            },
            {
              branchname: "MARABAHAY",
              branchcode: "122503353",
            },
            {
              branchname: "PALAWAN 3, BROOKES PT.",
              branchcode: "122503356",
            },
            {
              branchname: "PALAWAN 5, NARRA",
              branchcode: "122503336",
            },
            {
              branchname: "PALAWAN 7, QUEZON",
              branchcode: "122503338",
            },
            {
              branchname: "RIO TUBA",
              branchcode: "122503363",
            },
            {
              branchname: "PALAWAN 11, ESPANOLA",
              branchcode: "122503354",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ABONGAN",
              branchcode: "122504481",
            },
            {
              branchname: "ARACELI",
              branchcode: "122504371",
            },
            {
              branchname: "BUSUANGA",
              branchcode: "122504378",
            },
            {
              branchname: "CORON",
              branchcode: "122504342",
            },
            {
              branchname: "EL NIDO",
              branchcode: "122504351",
            },
            {
              branchname: "LIMINANGCONG",
              branchcode: "122504349",
            },
            {
              branchname: "PALAWAN 10, TAYTAY",
              branchcode: "122504346",
            },
            {
              branchname: "PALAWAN 8, ROXAS",
              branchcode: "122504347",
            },
            {
              branchname: "ROXAS, PALAWAN",
              branchcode: "122504484",
            },
            {
              branchname: "STA TERESITA, DUMARAN",
              branchcode: "122504341",
            },
            {
              branchname: "SAN VICENTE",
              branchcode: "122504377",
            },
          ],
        },
      ],
    },
    {
      region: "CEBU NORTH B REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BAJAC",
              branchcode: "122601331",
            },
            {
              branchname: "CATARMAN LILOAN",
              branchcode: "122601516",
            },
            {
              branchname: "CORAZON CATMON",
              branchcode: "122601713",
            },
            {
              branchname: "LILOAN 3",
              branchcode: "122601829",
            },
            {
              branchname: "LILOAN, CEBU",
              branchcode: "122601084",
            },
            {
              branchname: "POBLACION LILOAN",
              branchcode: "122601441",
            },
            {
              branchname: "PRK. SUNFLOWER, LILOAN",
              branchcode: "122601496",
            },
            {
              branchname: "PROPER YATI",
              branchcode: "122601332",
            },
            {
              branchname: "YATI LILOAN, CEBU",
              branchcode: "122601943",
            },
            {
              branchname: "PILAR CAMOTES",
              branchcode: "122605515",
            },
            {
              branchname: "PORO CAMOTES",
              branchcode: "122605087",
            },
            {
              branchname: "SABANG, DANAO ",
              branchcode: "122605310",
            },
            {
              branchname: "SAN FRANCISCO, CAMOTES",
              branchcode: "122605936",
            },
            {
              branchname: "TUDELA, CAMOTES",
              branchcode: "122605856",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ANTIGUA",
              branchcode: "122602501",
            },
            {
              branchname: "CARMEN CEBU",
              branchcode: "122602088",
            },
            {
              branchname: "CATMON",
              branchcode: "122602089",
            },
            {
              branchname: "CATMON DAAN",
              branchcode: "122602233",
            },
            {
              branchname: "CORAZON CATMON",
              branchcode: "122602713",
            },
            {
              branchname: "CEBU SAFARI",
              branchcode: "122602500",
            },
            {
              branchname: "DANAO 1",
              branchcode: "122602092",
            },
            {
              branchname: "SOGOD 2 CEBU",
              branchcode: "122602573",
            },
            {
              branchname: "SOGOD CEBU",
              branchcode: "122602095",
            },
            {
              branchname: "ILIHAN",
              branchcode: "122603388",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BINABAG",
              branchcode: "122603739",
            },
            {
              branchname: "BOGO 1",
              branchcode: "122603075",
            },
            {
              branchname: "BOGO 2",
              branchcode: "122603076",
            },
            {
              branchname: "BORBON",
              branchcode: "122603938",
            },
            {
              branchname: "CANTECSON",
              branchcode: "122603391",
            },
            {
              branchname: "DAAN BANTAYAN",
              branchcode: "122603083",
            },
            {
              branchname: "KAWIT MEDELLIN CEBU",
              branchcode: "122603869",
            },
            {
              branchname: "LOGON",
              branchcode: "122603701",
            },
            {
              branchname: "POBLACION MEDELLIN",
              branchcode: "122603314",
            },
            {
              branchname: "TABOGON",
              branchcode: "122603728",
            },
            {
              branchname: "TAYTAYAN",
              branchcode: "122603671",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BANTAYAN ISLAND",
              branchcode: "122604074",
            },
            {
              branchname: "CTU TUBURAN",
              branchcode: "122604531",
            },
            {
              branchname: "HAGNAYA",
              branchcode: "122604506",
            },
            {
              branchname: "MADRIDEJOS, CEBU",
              branchcode: "122604085",
            },
            {
              branchname: "MARAVILLA TABUELAN",
              branchcode: "122604851",
            },
            {
              branchname: "SAN REMEGIO",
              branchcode: "122604086",
            },
            {
              branchname: "STA. FE, CEBU",
              branchcode: "122604937",
            },
            {
              branchname: "TABUELAN",
              branchcode: "122604117",
            },
            {
              branchname: "TALANGNAN, MADRIDEJOS",
              branchcode: "122604435",
            },
            {
              branchname: "TAMBONGON",
              branchcode: "122604495",
            },
            {
              branchname: "ATOP ATOP BANTAYAN",
              branchcode: "122604861",
            },
            {
              branchname: "TUBURAN",
              branchcode: "",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "CAMPO CAMOTES",
              branchcode: "122605626",
            },
            {
              branchname: "CFI DANAO",
              branchcode: "122605450",
            },
            {
              branchname: "DANAO 3",
              branchcode: "122605094",
            },
            {
              branchname: "GUINSAY DANAO",
              branchcode: "122605789",
            },
            {
              branchname: "MASLOG DANAO",
              branchcode: "122605830",
            },
            {
              branchname: "AGGIES",
              branchcode: "122601408",
            },
            {
              branchname: "COMPOSTELA, CEBU",
              branchcode: "122601090",
            },
            {
              branchname: "LAS PALMAS",
              branchcode: "122602930",
            },
            {
              branchname: "COTCOT, LILOAN CEBU",
              branchcode: "122601587",
            },
            {
              branchname: "LILOAN 2",
              branchcode: "122601770",
            },
            {
              branchname: "DANAO 2",
              branchcode: "122602093",
            },
          ],
        },
      ],
    },
    {
      region: "CEBU CENTRAL B REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CENTRUM OSMENA",
              branchcode: "122701546",
            },
            {
              branchname: "CITY SOHO MALL",
              branchcode: "122701306",
            },
            {
              branchname: "FUENTE 2",
              branchcode: "122701616",
            },
            {
              branchname: "FUENTE 3",
              branchcode: "122701046",
            },
            {
              branchname: "FUENTE CIRCLE",
              branchcode: "122701848",
            },
            {
              branchname: "MANGO 2",
              branchcode: "122701052",
            },
            {
              branchname: "OSMENA BLVD",
              branchcode: "122701045",
            },
            {
              branchname: "P DEL ROSARIO",
              branchcode: "122701106",
            },
            {
              branchname: "RAMOS 1",
              branchcode: "122701054",
            },
            {
              branchname: "RAMOS 2",
              branchcode: "122701055",
            },
            {
              branchname: "CAPITOL SITE",
              branchcode: "122702312",
            },
            {
              branchname: "OPPRA",
              branchcode: "122703536",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "AYALA 2",
              branchcode: "122702633",
            },
            {
              branchname: "AYALA CEBU SHOWROOM",
              branchcode: "122702833",
            },
            {
              branchname: "AYALA MT CEBU",
              branchcode: "122702508",
            },
            {
              branchname: "BANAWA",
              branchcode: "122702042",
            },
            {
              branchname: "CAMPUTHAW",
              branchcode: "122702814",
            },
            {
              branchname: "CAPITOL CEBU",
              branchcode: "122702325",
            },
            {
              branchname: "CABANTAN",
              branchcode: "122704043",
            },
            {
              branchname: "GORORDO",
              branchcode: "122702047",
            },
            {
              branchname: "GUADALUPE CEBU",
              branchcode: "122702048",
            },
            {
              branchname: "GUADALUPE V RAMA",
              branchcode: "122702394",
            },
            {
              branchname: "KAMAGONG",
              branchcode: "122702866",
            },
            {
              branchname: "ONE PAVILION MALL",
              branchcode: "122702491",
            },
            {
              branchname: "R DUTERTE",
              branchcode: "122702792",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "AYALA IT PARK",
              branchcode: "122703661",
            },
            {
              branchname: "BABAG CEBU",
              branchcode: "122703533",
            },
            {
              branchname: "HIPODROMO",
              branchcode: "122703722",
            },
            {
              branchname: "KASAMBAGAN",
              branchcode: "122703961",
            },
            {
              branchname: "LAHUG 1",
              branchcode: "122703049",
            },
            {
              branchname: "LAHUG 2",
              branchcode: "122703050",
            },
            {
              branchname: "MABOLO",
              branchcode: "122703051",
            },
            {
              branchname: "NIVEL HILLS",
              branchcode: "122703387",
            },
            {
              branchname: "NIVEL HILLS APAS",
              branchcode: "122703683",
            },
            {
              branchname: "BARRIO LUZ",
              branchcode: "122704313",
            },
            {
              branchname: "PERSIMMON",
              branchcode: "122703490",
            },
            {
              branchname: "SALINAS DRIVE",
              branchcode: "122703398",
            },
            {
              branchname: "WATERFRONT SHOWROOM",
              branchcode: "122703562",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "APAS",
              branchcode: "122704064",
            },
            {
              branchname: "BANI TC",
              branchcode: "122704977",
            },
            {
              branchname: "BARRIO LUZ",
              branchcode: "122704313",
            },
            {
              branchname: "BUDLAAN CEBU",
              branchcode: "122704822",
            },
            {
              branchname: "FCT TINTAY TALAMBAN",
              branchcode: "122704667",
            },
            {
              branchname: "LEYSON TALAMBAN",
              branchcode: "122704688",
            },
            {
              branchname: "PIT OS",
              branchcode: "122704072",
            },
            {
              branchname: "SAN JOSE CEBU",
              branchcode: "122704589",
            },
            {
              branchname: "TALAMBAN 1",
              branchcode: "122704070",
            },
            {
              branchname: "TALAMBAN 2 PROPER",
              branchcode: "122704071",
            },
            {
              branchname: "TALAMBAN 3",
              branchcode: "122704511",
            },
            {
              branchname: "UC BANILAD",
              branchcode: "122704073",
            },
            {
              branchname: "VILLA LEYSON",
              branchcode: "122704240",
            },
            {
              branchname: "GUBA CEBU",
              branchcode: "122704862",
            },
          ],
        },
      ],
    },
    {
      region: "LEYTE B REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ABUCAY TACLOBAN",
              branchcode: "120602311",
            },
            {
              branchname: "CALANIPAWAN V AND G",
              branchcode: "120602205",
            },
            {
              branchname: "GAISANO REAL TACLOBAN",
              branchcode: "120602615",
            },
            {
              branchname: "PHHC TACLOBAN",
              branchcode: "120602625",
            },
            {
              branchname: "RIZAL TACLOBAN",
              branchcode: "120602687",
            },
            {
              branchname: "TACLOBAN 1",
              branchcode: "120602198",
            },
            {
              branchname: "TACLOBAN 2",
              branchcode: "120602199",
            },
            {
              branchname: "TACLOBAN 3",
              branchcode: "120602201",
            },
            {
              branchname: "TACLOBAN 4",
              branchcode: "120602202",
            },
            {
              branchname: "MARASBARAS",
              branchcode: "120602196",
            },
            {
              branchname: "TABOAN MARASBARAS",
              branchcode: "120602470",
            },
            {
              branchname: "SAN JOSE TACLOBAN",
              branchcode: "120602014",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ABUYOG",
              branchcode: "120607206",
            },
            {
              branchname: "ABUYOG BALOCAWEHAY",
              branchcode: "120607493",
            },
            {
              branchname: "DULAG 2",
              branchcode: "120607996",
            },
            {
              branchname: "JULITA",
              branchcode: "120607333",
            },
            {
              branchname: "MAHARLIKA PAWING PALO",
              branchcode: "120607803",
            },
            {
              branchname: "MC ARTHUR, LEYTE",
              branchcode: "120607993",
            },
            {
              branchname: "PALO",
              branchcode: "120607197",
            },
            {
              branchname: "PALO NATIONAL HIGHWAY",
              branchcode: "120607475",
            },
            {
              branchname: "SAN AGUSTIN BURAUEN",
              branchcode: "120607432",
            },
            {
              branchname: "TANAUAN",
              branchcode: "120607204",
            },
            {
              branchname: "BURAUEN",
              branchcode: "120607193",
            },
            {
              branchname: "DAGAMI",
              branchcode: "120607874",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "NAVAL LEYTE",
              branchcode: "120605210",
            },
            {
              branchname: "CASTIN NAVAL",
              branchcode: "120605476",
            },
            {
              branchname: "BILIRAN",
              branchcode: "120605674",
            },
            {
              branchname: "LEYTE",
              branchcode: "120605651",
            },
            {
              branchname: "SAN ISIDRO",
              branchcode: "120608216",
            },
            {
              branchname: "TABANGO",
              branchcode: "120608217",
            },
            {
              branchname: "VILLABA",
              branchcode: "120608218",
            },
            {
              branchname: "CALUBIAN",
              branchcode: "120608675",
            },
             {
              branchname: "BUNGA CABUCGAYAN",
              branchcode: "122803903",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ALANG ALANG",
              branchcode: "120605191",
            },
            {
              branchname: "BARUGO",
              branchcode: "120605797",
            },
            {
              branchname: "CAPOOCAN",
              branchcode: "120605796",
            },
            {
              branchname: "CARIGARA",
              branchcode: "120605207",
            },
            {
              branchname: "TUNGA LEYTE",
              branchcode: "120605457",
            },
            {
              branchname: "JARO LEYTE",
              branchcode: "120605195",
            },
            {
              branchname: "STA FE",
              branchcode: "120605878",
            },
            {
              branchname: "KANANGA",
              branchcode: "120608209",
            },
             {
              branchname: "DEL CARMEN CARIGARA",
              branchcode: "122804889",
            },
          ],
        },
      ],
    },
    {
      region: "NEGROS OCCIDENTAL B REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BINALBAGAN",
              branchcode: "120805165",
            },
            {
              branchname: "HIMAMAYLAN",
              branchcode: "120805167",
            },
            {
              branchname: "HINIGARAN",
              branchcode: "120805168",
            },
            {
              branchname: "ISABELA",
              branchcode: "120805686",
            },
            {
              branchname: "KABANKALAN 3",
              branchcode: "120805999",
            },
            {
              branchname: "LA CASTELLANA",
              branchcode: "120805504",
            },
            {
              branchname: "MOISES PADILLA",
              branchcode: "120805736",
            },
            {
              branchname: "PONTEVEDRA NEGROS OCC",
              branchcode: "120805374",
            },
            {
              branchname: "PROGRESO",
              branchcode: "120805553",
            },
            {
              branchname: "SAN ENRIQUE NEG OCC",
              branchcode: "120805707",
            },
            {
              branchname: "ML FERIA",
              branchcode: "122901896",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "CANDONI",
              branchcode: "120807706",
            },
            {
              branchname: "CAUAYAN",
              branchcode: "120807166",
            },
            {
              branchname: "DANCALAN",
              branchcode: "120807635",
            },
            {
              branchname: "HINOBAAN",
              branchcode: "120807337",
            },
            {
              branchname: "INAYAWAN NEG OCC",
              branchcode: "120807213",
            },
            {
              branchname: "KABANKALAN 1",
              branchcode: "120807169",
            },
            {
              branchname: "KABANKALAN 2",
              branchcode: "120807170",
            },
            {
              branchname: "KABANKALAN JY PEREZ",
              branchcode: "120807748",
            },
            {
              branchname: "POBLACION HINOBAAN",
              branchcode: "120807440",
            },
            {
              branchname: "SIPALAY",
              branchcode: "120807505",
            },
            {
              branchname: "ML CULIPAPA",
              branchcode: "122902890",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BAGO 1",
              branchcode: "120804164",
            },
            {
              branchname: "BAGO 2",
              branchcode: "120804318",
            },
            {
              branchname: "GENERAL LUNA BAGO",
              branchcode: "120804375",
            },
            {
              branchname: "LA CARLOTA",
              branchcode: "120804171",
            },
            {
              branchname: "LA CARLOTA 2",
              branchcode: "120804603",
            },
            {
              branchname: "MA AO",
              branchcode: "120804737",
            },
            {
              branchname: "PULUPANDAN",
              branchcode: "120804685",
            },
            {
              branchname: "VALLADOLID",
              branchcode: "120804669",
            },
          ],
        },
      ],
    },
  ],
  MINDANAO: [
    {
      region: "CARAGA NORTE REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BOULEVARD",
              branchcode: "131201583",
            },
            {
              branchname: "BUENAVISTA",
              branchcode: "131201407",
            },
            {
              branchname: "BUTUAN 1",
              branchcode: "131201408",
            },
            {
              branchname: "BUTUAN 6",
              branchcode: "131201618",
            },
            {
              branchname: "CARMEN",
              branchcode: "131201043",
            },
            {
              branchname: "J.C. AQUINO",
              branchcode: "131201512",
            },
            {
              branchname: "LANGIHAN CARAGA",
              branchcode: "131201845",
            },
            {
              branchname: "LIBERTAD",
              branchcode: "131201415",
            },
            {
              branchname: "MONTILLA BOULEVARD",
              branchcode: "131201294",
            },
            {
              branchname: "NASIPIT",
              branchcode: "131201416",
            },
            {
              branchname: "VILLA KANANGA",
              branchcode: "131201511",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "AMPAYON",
              branchcode: "131202405",
            },
            {
              branchname: "BAAN",
              branchcode: "131202150",
            },
            {
              branchname: "BUTUAN 2",
              branchcode: "131202410",
            },
            {
              branchname: "BUTUAN 5",
              branchcode: "131202413",
            },
            {
              branchname: "CABADBARAN",
              branchcode: "131202414",
            },
            {
              branchname: "CABADBARAN 2",
              branchcode: "131202108",
            },
            {
              branchname: "CABADBARAN 3",
              branchcode: "131202898",
            },
            {
              branchname: "CABADBARAN MARKET",
              branchcode: "131202095",
            },
            {
              branchname: "MAGALLANES",
              branchcode: "131202748",
            },
            {
              branchname: "ROBINSONS PLACE BUTUAN",
              branchcode: "131202862",
            },
            {
              branchname: "RTR",
              branchcode: "131202867",
            },
            {
              branchname: "SANTIAGO",
              branchcode: "131202926",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALEGRIA",
              branchcode: "131203016",
            },
            {
              branchname: "BACUAG",
              branchcode: "131203718",
            },
            {
              branchname: "CLAVER",
              branchcode: "131203432",
            },
            {
              branchname: "KITCHARAO",
              branchcode: "131203620",
            },
            {
              branchname: "MAGPAYANG",
              branchcode: "131203435",
            },
            {
              branchname: "PLACER 2",
              branchcode: "131203800",
            },
            {
              branchname: "PLACER BAD AS",
              branchcode: "131203436",
            },
            {
              branchname: "SISON",
              branchcode: "131203050",
            },
            {
              branchname: "TAGANITO",
              branchcode: "131203777",
            },
            {
              branchname: "TUBOD SDN",
              branchcode: "131203835",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "CAPITOL SURIGAO",
              branchcode: "131204018",
            },
            {
              branchname: "DAPA",
              branchcode: "131204433",
            },
            {
              branchname: "DEL CARMEN",
              branchcode: "131204719",
            },
            {
              branchname: "DINAGAT",
              branchcode: "131204077",
            },
            {
              branchname: "GAISANO SURIGAO SHOWROOM",
              branchcode: "131204909",
            },
            {
              branchname: "GARAME",
              branchcode: "131204221",
            },
            {
              branchname: "GENERAL LUNA SDN",
              branchcode: "131204138",
            },
            {
              branchname: "LIBJO",
              branchcode: "131204185",
            },
            {
              branchname: "SAN JOSE CARAGA",
              branchcode: "131204437",
            },
            {
              branchname: "SURIGAO 1",
              branchcode: "131204439",
            },
            {
              branchname: "SURIGAO 2",
              branchcode: "131204440",
            },
            {
              branchname: "SURIGAO 3",
              branchcode: "131204441",
            },
          ],
        },
      ],
    },
    {
      region: "CARAGA SUR REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BUNAWAN, CARAGA",
              branchcode: "131301855",
            },
            {
              branchname: "GAISANO GRAND SAN FRANCISCO",
              branchcode: "131301247",
            },
            {
              branchname: "ROSARIO ADS",
              branchcode: "131301096",
            },
            {
              branchname: "SAMPAGUITA",
              branchcode: "131301068",
            },
            {
              branchname: "SAN FRANCISCO 2",
              branchcode: "131301857",
            },
            {
              branchname: "SAN FRANCISCO CARAGA",
              branchcode: "131301418",
            },
            {
              branchname: "STA. JOSEFA CARAGA",
              branchcode: "131301878",
            },
            {
              branchname: "TRENTO",
              branchcode: "131301430",
            },
            {
              branchname: "TRENTO POBLACION",
              branchcode: "131301253",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BISLIG",
              branchcode: "131302954",
            },
            {
              branchname: "HINATUAN",
              branchcode: "131302421",
            },
            {
              branchname: "LINGIG",
              branchcode: "131302057",
            },
            {
              branchname: "MANGAGOY 1",
              branchcode: "131302423",
            },
            {
              branchname: "MANGAGOY 2",
              branchcode: "131302424",
            },
            {
              branchname: "MANGAGOY 3",
              branchcode: "131302425",
            },
            {
              branchname: "SAN ROQUE BISLIG",
              branchcode: "131302504",
            },
            {
              branchname: "SORIANO AVENUE",
              branchcode: "131302518",
            },
            {
              branchname: "UNION SITE",
              branchcode: "131302192",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ARAS ARASAN",
              branchcode: "131303419",
            },
            {
              branchname: "BAROBO",
              branchcode: "131303420",
            },
            {
              branchname: "BAROBO POBLACION",
              branchcode: "131303206",
            },
            {
              branchname: "LIANGA",
              branchcode: "131303616",
            },
            {
              branchname: "MARAVILLE",
              branchcode: "131303279",
            },
            {
              branchname: "MARIHATAG",
              branchcode: "131303868",
            },
            {
              branchname: "QUIRINO MADRID",
              branchcode: "131303275",
            },
            {
              branchname: "SAN MIGUEL SURIGAO DEL SUR",
              branchcode: "131303073",
            },
            {
              branchname: "STO NINO",
              branchcode: "131303722",
            },
            {
              branchname: "TAGBINA",
              branchcode: "131303246",
            },
            {
              branchname: "TAGO",
              branchcode: "131303009",
            },
            {
              branchname: "PUROK 1A POBLACION",
              branchcode: "131303575",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "CANTILAN",
              branchcode: "131304431",
            },
            {
              branchname: "CARMEN SDS",
              branchcode: "131304033",
            },
            {
              branchname: "CARRASCAL",
              branchcode: "131304807",
            },
            {
              branchname: "GAISANO CAPITAL TANDAG",
              branchcode: "131304730",
            },
            {
              branchname: "LININTIAN CANTILAN",
              branchcode: "131304190",
            },
            {
              branchname: "MADRID",
              branchcode: "131304434",
            },
            {
              branchname: "TANDAG 1 (TELAJE)",
              branchcode: "131304427",
            },
            {
              branchname: "TANDAG 2",
              branchcode: "131304428",
            },
            {
              branchname: "TANDAG 3",
              branchcode: "131304429",
            },
            {
              branchname: "TANDAG 4",
              branchcode: "131304409",
            },
            {
              branchname: "MOONGLOW",
              branchcode: "131304573",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BAYUGAN",
              branchcode: "131305406",
            },
            {
              branchname: "BAYUGAN 2",
              branchcode: "131305619",
            },
            {
              branchname: "ESPERANZA ADS",
              branchcode: "131305296",
            },
            {
              branchname: "PATIN AY",
              branchcode: "131305152",
            },
            {
              branchname: "PROSPERIDAD",
              branchcode: "131305417",
            },
            {
              branchname: "SIBAGAT ADS",
              branchcode: "131305225",
            },
            {
              branchname: "TAGLATAWAN BAYUGAN ADS",
              branchcode: "131305274",
            },
            {
              branchname: "TALACOGON",
              branchcode: "131305056",
            },
          ],
        },
      ],
    },
    {
      region: "DAVAO REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "ABREEZA MALL",
              branchcode: "131401805",
            },
            {
              branchname: "BAJADA",
              branchcode: "131401602",
            },
            {
              branchname: "BUHANGIN",
              branchcode: "131401301",
            },
            {
              branchname: "BUHANGIN 2",
              branchcode: "131401723",
            },
            {
              branchname: "BUHANGIN 3",
              branchcode: "131401981",
            },
            {
              branchname: "CABAGUIO",
              branchcode: "131401471",
            },
            {
              branchname: "CABANTIAN",
              branchcode: "131401791",
            },
            {
              branchname: "GARCIA HEIGHTS",
              branchcode: "131401028",
            },
            {
              branchname: "ILUSTRE",
              branchcode: "131401302",
            },
            {
              branchname: "MANDUG",
              branchcode: "131401741",
            },
            {
              branchname: "OBRERO",
              branchcode: "131401120",
            },
            {
              branchname: "SAN PEDRO, DAVAO",
              branchcode: "131401306",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BOLTON 1",
              branchcode: "131402326",
            },
            {
              branchname: "CM RECTO",
              branchcode: "131402329",
            },
            {
              branchname: "MA A",
              branchcode: "131402894",
            },
            {
              branchname: "MATINA",
              branchcode: "131402333",
            },
            {
              branchname: "MATINA CROSSING",
              branchcode: "131402717",
            },
            {
              branchname: "SANDAWA SIR",
              branchcode: "131402127",
            },
            {
              branchname: "UM MATINA",
              branchcode: "131402696",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "AGDAO 1",
              branchcode: "131403298",
            },
            {
              branchname: "AGDAO 2",
              branchcode: "131403527",
            },
            {
              branchname: "AGDAO 3",
              branchcode: "131403967",
            },
            {
              branchname: "BABAK",
              branchcode: "131403299",
            },
            {
              branchname: "BOULEVARD",
              branchcode: "131403300",
            },
            {
              branchname: "BUNAWAN",
              branchcode: "131403739",
            },
            {
              branchname: "DAMOSA",
              branchcode: "131403515",
            },
            {
              branchname: "PANACAN 1",
              branchcode: "131403303",
            },
            {
              branchname: "PENAPLATA",
              branchcode: "131403024",
            },
            {
              branchname: "SASA",
              branchcode: "131403624",
            },
            {
              branchname: "TIBUNGCO",
              branchcode: "131403308",
            },
            {
              branchname: "TRADING",
              branchcode: "131403821",
            },
            {
              branchname: "UYANGUREN",
              branchcode: "131403309",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "1ST CRUMB",
              branchcode: "131404637",
            },
            {
              branchname: "AGTON",
              branchcode: "131404345",
            },
            {
              branchname: "DIGOS 1",
              branchcode: "131404330",
            },
            {
              branchname: "DIGOS 2",
              branchcode: "131404860",
            },
            {
              branchname: "GMALL DIGOS SHOWROOM",
              branchcode: "131404017",
            },
            {
              branchname: "LUNA",
              branchcode: "131404023",
            },
            {
              branchname: "PRK SANTAN STA CRUZ",
              branchcode: "131404208",
            },
            {
              branchname: "STA CRUZ",
              branchcode: "131404771",
            },
            {
              branchname: "TALOMO DAVAO",
              branchcode: "131404193",
            },
            {
              branchname: "TORIL 2",
              branchcode: "131404334",
            },
            {
              branchname: "TORIL 3",
              branchcode: "131404792",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BANSALAN",
              branchcode: "131405324",
            },
            {
              branchname: "GUIHING HAGONOY",
              branchcode: "131405514",
            },
            {
              branchname: "HAGONOY",
              branchcode: "131405202",
            },
            {
              branchname: "KAPATAGAN RIZAL",
              branchcode: "131405677",
            },
            {
              branchname: "KIBLAWAN",
              branchcode: "131405962",
            },
            {
              branchname: "MALALAG",
              branchcode: "131405182",
            },
            {
              branchname: "MALITA",
              branchcode: "131405332",
            },
            {
              branchname: "MATANAO",
              branchcode: "131405911",
            },
            {
              branchname: "PADADA",
              branchcode: "131405271",
            },
            {
              branchname: "QUIRINO MAGSAYSAY",
              branchcode: "131405284",
            },
            {
              branchname: "STA MARIA",
              branchcode: "131405935",
            },
            {
              branchname: "SULOP",
              branchcode: "131405760",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "BAGO GALLERA",
              branchcode: "131406679",
            },
            {
              branchname: "BUDA",
              branchcode: "131406235",
            },
            {
              branchname: "CALINAN",
              branchcode: "131406328",
            },
            {
              branchname: "CATALUNAN GRANDE",
              branchcode: "131406035",
            },
            {
              branchname: "LUMONDAO",
              branchcode: "131406293",
            },
            {
              branchname: "MATINA APLAYA",
              branchcode: "131406015",
            },
            {
              branchname: "MINTAL",
              branchcode: "131406541",
            },
            {
              branchname: "ULAS",
              branchcode: "131406540",
            },
          ],
        },
      ],
    },
    {
      region: "DACODA REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "GANTE ROAD",
              branchcode: "131501288",
            },
            {
              branchname: "GMALL TAGUM",
              branchcode: "131501088",
            },
            {
              branchname: "OSMEÃ‘A TAGUM",
              branchcode: "131501752",
            },
            {
              branchname: "ROBINSONS TAGUM SHOWROOM",
              branchcode: "131501114",
            },
            {
              branchname: "SAN MIGUEL TAGUM",
              branchcode: "131501236",
            },
            {
              branchname: "TAGUM 1",
              branchcode: "131501319",
            },
            {
              branchname: "TAGUM 2",
              branchcode: "131501320",
            },
            {
              branchname: "TAGUM 3",
              branchcode: "131501321",
            },
            {
              branchname: "TAGUM 4",
              branchcode: "131501322",
            },
            {
              branchname: "TAGUM 5",
              branchcode: "131501323",
            },
            {
              branchname: "NCCC MALL TAGUM SHOWROOM",
              branchcode: "131501892",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ASUNCION",
              branchcode: "131502049",
            },
            {
              branchname: "CARMEN DAVAO",
              branchcode: "131502661",
            },
            {
              branchname: "FDR 2",
              branchcode: "131502252",
            },
            {
              branchname: "KAPALONG",
              branchcode: "131502312",
            },
            {
              branchname: "LAAK",
              branchcode: "131502254",
            },
            {
              branchname: "PANABO 1",
              branchcode: "131502316",
            },
            {
              branchname: "PANABO 2",
              branchcode: "131502286",
            },
            {
              branchname: "QUIRINO PANABO",
              branchcode: "131502061",
            },
            {
              branchname: "RMCI PANABO",
              branchcode: "131502113",
            },
            {
              branchname: "SAWATA",
              branchcode: "131502180",
            },
            {
              branchname: "STO. TOMAS, DAVAO",
              branchcode: "131502307",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "COMPOSTELA DAVAO",
              branchcode: "131503311",
            },
            {
              branchname: "CROSSING GABI",
              branchcode: "131503012",
            },
            {
              branchname: "MAGSAYSAY MONKAYO",
              branchcode: "131503272",
            },
            {
              branchname: "MARAGUSAN",
              branchcode: "131503517",
            },
            {
              branchname: "MAWAB",
              branchcode: "131503780",
            },
            {
              branchname: "MONKAYO",
              branchcode: "131503426",
            },
            {
              branchname: "MONTEVISTA",
              branchcode: "131503701",
            },
            {
              branchname: "NABUNTURAN",
              branchcode: "131503315",
            },
            {
              branchname: "NABUNTURAN GRAND MALL",
              branchcode: "131503058",
            },
            {
              branchname: "NEW BATAAN",
              branchcode: "131503977",
            },
            {
              branchname: "NEW CORELLA",
              branchcode: "131503715",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "APOKON",
              branchcode: "131504802",
            },
            {
              branchname: "APOKON ROAD",
              branchcode: "131504266",
            },
            {
              branchname: "BANAY BANAY DAVAO",
              branchcode: "131504310",
            },
            {
              branchname: "LUPON",
              branchcode: "131504313",
            },
            {
              branchname: "MABINI",
              branchcode: "131504709",
            },
            {
              branchname: "MACO",
              branchcode: "131504590",
            },
            {
              branchname: "MANGGA TAGUM",
              branchcode: "131504086",
            },
            {
              branchname: "PANTUKAN",
              branchcode: "131504317",
            },
            {
              branchname: "SAN ISIDRO DAVAO",
              branchcode: "131504123",
            },
            {
              branchname: "TIBANBAN",
              branchcode: "131504671",
            },
             {
              branchname: "ML TOWNSITE PANTUKAN",
              branchcode: "131504594",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BAGANGA",
              branchcode: "131505148",
            },
            {
              branchname: "BOSTON",
              branchcode: "131505072",
            },
            {
              branchname: "CARAGA",
              branchcode: "131505582",
            },
            {
              branchname: "CATEEL",
              branchcode: "131505891",
            },
            {
              branchname: "DAHICAN",
              branchcode: "131505237",
            },
            {
              branchname: "LAMBAJON",
              branchcode: "131505951",
            },
            {
              branchname: "MANAY",
              branchcode: "131505959",
            },
            {
              branchname: "MATI 1",
              branchcode: "131505314",
            },
            {
              branchname: "MATI 2",
              branchcode: "131505890",
            },
            {
              branchname: "MATIAO",
              branchcode: "131505141",
            },
          ],
        },
      ],
    },
    {
      region: "SARGEN REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BAGSAKAN",
              branchcode: "131601195",
            },
            {
              branchname: "GENSAN 1",
              branchcode: "131601376",
            },
            {
              branchname: "GENSAN 3",
              branchcode: "131601375",
            },
            {
              branchname: "GENSAN 4",
              branchcode: "131601377",
            },
            {
              branchname: "GENSAN 5",
              branchcode: "131601378",
            },
            {
              branchname: "GENSAN 6 PENDATUN",
              branchcode: "131601955",
            },
            {
              branchname: "GENSAN 7",
              branchcode: "131601422",
            },
            {
              branchname: "NATIONAL HIGHWAY GENSAN",
              branchcode: "131601769",
            },
            {
              branchname: "PAPAYA",
              branchcode: "131601381",
            },
            {
              branchname: "SOUTH OSMENA",
              branchcode: "131601080",
            },
            {
              branchname: "TRI STAR",
              branchcode: "131601917",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ACHARON",
              branchcode: "131602372",
            },
            {
              branchname: "APOPONG",
              branchcode: "131602010",
            },
            {
              branchname: "DONA SOLEDAD",
              branchcode: "131602029",
            },
            {
              branchname: "DREAMLAND",
              branchcode: "131602804",
            },
            {
              branchname: "LABANGAL",
              branchcode: "131602859",
            },
            {
              branchname: "MABUHAY GENSAN",
              branchcode: "131602140",
            },
            {
              branchname: "MAKAR",
              branchcode: "131602264",
            },
            {
              branchname: "MALAKAS",
              branchcode: "131602200",
            },
            {
              branchname: "NEW SOCIETY",
              branchcode: "131602103",
            },
            {
              branchname: "SAN ISIDRO MALAKAS",
              branchcode: "131602037",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALABEL",
              branchcode: "131603605",
            },
            {
              branchname: "BANATE",
              branchcode: "131603111",
            },
            {
              branchname: "BULA GENSAN",
              branchcode: "131603045",
            },
            {
              branchname: "GLAN",
              branchcode: "131603379",
            },
            {
              branchname: "HICBAN",
              branchcode: "131603217",
            },
            {
              branchname: "KCC 3RD FLOOR",
              branchcode: "131603295",
            },
            {
              branchname: "KCC MALL SHOWROOM (GENSAN)",
              branchcode: "131603939",
            },
            {
              branchname: "LAGAO",
              branchcode: "131603013",
            },
            {
              branchname: "LUN PADIDU",
              branchcode: "131603544",
            },
            {
              branchname: "MALANDAG",
              branchcode: "131603703",
            },
            {
              branchname: "MALAPATAN",
              branchcode: "131603194",
            },
            {
              branchname: "MALUNGON",
              branchcode: "131603832",
            },
            {
              branchname: "NLSA LAGAO",
              branchcode: "131603226",
            },
            {
              branchname: "PANGYAN",
              branchcode: "131603144",
            },
            {
              branchname: "ML SAPU MASLA",
              branchcode: "131603603",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BADIANGON",
              branchcode: "131604196",
            },
            {
              branchname: "CALUMPANG",
              branchcode: "131604641",
            },
            {
              branchname: "CALUMPANG 2",
              branchcode: "131604849",
            },
            {
              branchname: "CALUMPANG HIGHWAY",
              branchcode: "131604227",
            },
            {
              branchname: "FATIMA",
              branchcode: "131604767",
            },
            {
              branchname: "FISH PORT",
              branchcode: "131604203",
            },
            {
              branchname: "KIAMBA",
              branchcode: "131604380",
            },
            {
              branchname: "MAASIM",
              branchcode: "131604803",
            },
            {
              branchname: "MAITUM",
              branchcode: "131604213",
            },
            {
              branchname: "MAITUM 2",
              branchcode: "131604914",
            },
            {
              branchname: "PALIMBANG",
              branchcode: "131604297",
            },
            {
              branchname: "SAN ROQUE PALIMBANG",
              branchcode: "131604112",
            },
            {
              branchname: "TAMBLER",
              branchcode: "131604628",
            },
            {
              branchname: "ZONE 2 FATIMA",
              branchcode: "131604038",
            },
          ],
        },
      ],
    },
    {
      region: "COTAMAGUIN REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BULALO SK",
              branchcode: "131701121",
            },
            {
              branchname: "COTABATO",
              branchcode: "131701384",
            },
            {
              branchname: "COTABATO 2",
              branchcode: "131701507",
            },
            {
              branchname: "COTABATO 3",
              branchcode: "131701569",
            },
            {
              branchname: "COTABATO 4",
              branchcode: "131701772",
            },
            {
              branchname: "COTABATO 5",
              branchcode: "131701773",
            },
            {
              branchname: "COTABATO 6",
              branchcode: "131701968",
            },
            {
              branchname: "MABINI COTABATO",
              branchcode: "131701094",
            },
            {
              branchname: "MATANOG",
              branchcode: "131701007",
            },
            {
              branchname: "PARANG",
              branchcode: "131701889",
            },
            {
              branchname: "RIZAL AVENUE",
              branchcode: "131701008",
            },
            {
              branchname: "SARMIENTO PARANG",
              branchcode: "131701085",
            },
            {
              branchname: "SINSUAT AVENUE",
              branchcode: "131701276",
            },
            {
              branchname: "LIMBO SK",
              branchcode: "131701592",
            },
            {
              branchname: "ML JULIANO AVENUE",
              branchcode: "131701598",
            },
            {
              branchname: "ML ROSARY HEIGHTS",
              branchcode: "131701646",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "CARMEN, COTABATO",
              branchcode: "131702383",
            },
            {
              branchname: "DATU PIANG PIKIT",
              branchcode: "131702537",
            },
            {
              branchname: "KABACAN 1",
              branchcode: "131702385",
            },
            {
              branchname: "KABACAN 2",
              branchcode: "131702386",
            },
            {
              branchname: "MATALAM",
              branchcode: "131702820",
            },
            {
              branchname: "ORCHID CARMEN",
              branchcode: "131702117",
            },
            {
              branchname: "OSMENA PIKIT",
              branchcode: "131702234",
            },
            {
              branchname: "PIKIT",
              branchcode: "131702841",
            },
            {
              branchname: "USM AVENUE",
              branchcode: "131702014",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ANTIPAS",
              branchcode: "131703538",
            },
            {
              branchname: "ARAKAN",
              branchcode: "131703169",
            },
            {
              branchname: "BAGONTAPAY",
              branchcode: "131703011",
            },
            {
              branchname: "DATU INGKAL",
              branchcode: "131703285",
            },
            {
              branchname: "DAYAO",
              branchcode: "131703950",
            },
            {
              branchname: "DORULOMAN",
              branchcode: "131703358",
            },
            {
              branchname: "JOSE ABAD SANTOS",
              branchcode: "131703101",
            },
            {
              branchname: "KIDAPAWAN",
              branchcode: "131703331",
            },
            {
              branchname: "KIDAPAWAN 2",
              branchcode: "131703956",
            },
            {
              branchname: "MAGPET",
              branchcode: "131703995",
            },
            {
              branchname: "MAKILALA",
              branchcode: "131703626",
            },
            {
              branchname: "MLANG",
              branchcode: "131703389",
            },
            {
              branchname: "PRES ROXAS COTABATO",
              branchcode: "131703176",
            },
            {
              branchname: "TULUNAN",
              branchcode: "131703629",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "AWANG",
              branchcode: "131704621",
            },
            {
              branchname: "BASAK LEBAK",
              branchcode: "131704374",
            },
            {
              branchname: "DALICAN",
              branchcode: "131704933",
            },
            {
              branchname: "DALICAN SINSUAT",
              branchcode: "131704543",
            },
            {
              branchname: "DOS DALICAN",
              branchcode: "131704122",
            },
            {
              branchname: "KALAMANSIG",
              branchcode: "131704392",
            },
            {
              branchname: "KALAMANSIG 2",
              branchcode: "131704740",
            },
            {
              branchname: "LEBAK",
              branchcode: "131704394",
            },
            {
              branchname: "LEBAK 2",
              branchcode: "131704572",
            },
            {
              branchname: "POBLACION LEBAK",
              branchcode: "131704642",
            },
            {
              branchname: "UPI",
              branchcode: "131704861",
            },
            {
              branchname: "ML BROCE DOS",
              branchcode: "131704651",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "ALAMADA",
              branchcode: "131705966",
            },
            {
              branchname: "BANISILAN",
              branchcode: "131705224",
            },
            {
              branchname: "LIBUNGAN",
              branchcode: "131705220",
            },
            {
              branchname: "LIBUNGAN HIGHWAY",
              branchcode: "131705118",
            },
            {
              branchname: "MIDSAYAP 1",
              branchcode: "131705388",
            },
            {
              branchname: "MIDSAYAP 2",
              branchcode: "131705883",
            },
            {
              branchname: "MIDSAYAP HIGHWAY",
              branchcode: "131705290",
            },
            {
              branchname: "PIGCAWAYAN",
              branchcode: "131705390",
            },
            {
              branchname: "QUEZON AVENUE MIDSAYAP",
              branchcode: "131705851",
            },
          ],
        },
      ],
    },
    {
      region: "CAGAYAN DE ORO REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CAPISTRANO",
              branchcode: "131801346",
            },
            {
              branchname: "CUGMAN",
              branchcode: "131801920",
            },
            {
              branchname: "DIVISORIA",
              branchcode: "131801574",
            },
            {
              branchname: "GUSA",
              branchcode: "131801519",
            },
            {
              branchname: "LAPASAN",
              branchcode: "131801349",
            },
            {
              branchname: "LIM KET KAI",
              branchcode: "131801373",
            },
            {
              branchname: "LIMKETKAI 2",
              branchcode: "131801533",
            },
            {
              branchname: "LIMKETKAI SHOWROOM",
              branchcode: "131801006",
            },
            {
              branchname: "ORORAMA",
              branchcode: "131801556",
            },
            {
              branchname: "OSMENA",
              branchcode: "131801350",
            },
            {
              branchname: "PABAYO",
              branchcode: "131801351",
            },
            {
              branchname: "VELEZ",
              branchcode: "131801352",
            },
            {
              branchname: "YACAPIN",
              branchcode: "131801353",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ALUBIJID",
              branchcode: "131802354",
            },
            {
              branchname: "APOVEL",
              branchcode: "131802105",
            },
            {
              branchname: "BULUA",
              branchcode: "131802343",
            },
            {
              branchname: "CANITO AN",
              branchcode: "131802525",
            },
            {
              branchname: "EL SALVADOR",
              branchcode: "131802765",
            },
            {
              branchname: "GITAGUM",
              branchcode: "131802257",
            },
            {
              branchname: "KINASANGHAN",
              branchcode: "131802242",
            },
            {
              branchname: "LAGUINDINGAN",
              branchcode: "131802976",
            },
            {
              branchname: "MAX SUNIEL",
              branchcode: "131802638",
            },
            {
              branchname: "MOLUGAN",
              branchcode: "131802866",
            },
            {
              branchname: "OPOL",
              branchcode: "131802879",
            },
            {
              branchname: "PATAG",
              branchcode: "131802110",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "CARMEN 1 CAGAYAN",
              branchcode: "131803347",
            },
            {
              branchname: "CARMEN 2 CAGAYAN",
              branchcode: "131803348",
            },
            {
              branchname: "CORRALES",
              branchcode: "131803078",
            },
            {
              branchname: "KAUSWAGAN",
              branchcode: "131803654",
            },
            {
              branchname: "LUMBIA CDO",
              branchcode: "131803249",
            },
            {
              branchname: "MACABALAN",
              branchcode: "131803238",
            },
            {
              branchname: "MACASANDIG",
              branchcode: "131803896",
            },
            {
              branchname: "NHA",
              branchcode: "131803153",
            },
            {
              branchname: "TALAKAG",
              branchcode: "131803093",
            },
            {
              branchname: "SM CAGAYAN SHOWROOM",
              branchcode: "131803005",
            },
            {
              branchname: "LUYONG BONBON",
              branchcode: "131803657",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "AGUSAN",
              branchcode: "131804256",
            },
            {
              branchname: "BALINGASAG",
              branchcode: "131804335",
            },
            {
              branchname: "BALINGASAG HIGHWAY",
              branchcode: "131804291",
            },
            {
              branchname: "BUGO",
              branchcode: "131804640",
            },
            {
              branchname: "CLAVERIA",
              branchcode: "131804689",
            },
            {
              branchname: "GAISANO PUERTO",
              branchcode: "131804102",
            },
            {
              branchname: "JASAAN",
              branchcode: "131804811",
            },
            {
              branchname: "OSMENA BALINGASAG",
              branchcode: "131804255",
            },
            {
              branchname: "PUERTO CAGAYAN",
              branchcode: "131804340",
            },
            {
              branchname: "SALAY",
              branchcode: "131804687",
            },
            {
              branchname: "STA. ANA TAGOLOAN",
              branchcode: "131804341",
            },
            {
              branchname: "VILLANUEVA",
              branchcode: "131804688",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BALINGOAN",
              branchcode: "131805934",
            },
            {
              branchname: "BENONI CAMIGUIN",
              branchcode: "131805277",
            },
            {
              branchname: "CAMIGUIN",
              branchcode: "131805344",
            },
            {
              branchname: "CAMIGUIN 2",
              branchcode: "131805558",
            },
            {
              branchname: "CATARMAN, CAMIGUIN",
              branchcode: "131805712",
            },
            {
              branchname: "GINGOOG 1",
              branchcode: "131805336",
            },
            {
              branchname: "GINGOOG 2",
              branchcode: "131805172",
            },
            {
              branchname: "MAGSAYSAY, CDO",
              branchcode: "131805054",
            },
            {
              branchname: "MEDINA",
              branchcode: "131805795",
            },
            {
              branchname: "SUGBONGCOGON",
              branchcode: "131805042",
            },
            {
              branchname: "TALISAYAN CDO",
              branchcode: "131805149",
            },
          ],
        },
      ],
    },
    {
      region: "LANAO REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CONSUNJI",
              branchcode: "131901292",
            },
            {
              branchname: "ILIGAN 2",
              branchcode: "131901356",
            },
            {
              branchname: "ILIGAN 4",
              branchcode: "131901360",
            },
            {
              branchname: "ILIGAN 6",
              branchcode: "131901362",
            },
            {
              branchname: "ILIGAN 7",
              branchcode: "131901970",
            },
            {
              branchname: "INITAO",
              branchcode: "131901131",
            },
            {
              branchname: "KIWALAN",
              branchcode: "131901087",
            },
            {
              branchname: "LUGAIT",
              branchcode: "131901932",
            },
            {
              branchname: "MANTICAO",
              branchcode: "131901364",
            },
            {
              branchname: "NAAWAN",
              branchcode: "131901022",
            },
            {
              branchname: "QUEZON ABALLE",
              branchcode: "131901988",
            },
            {
              branchname: "QUEZON AVENUE EXTENSION",
              branchcode: "131901260",
            },
            {
              branchname: "TAMBO",
              branchcode: "131901659",
            },
            {
              branchname: "TIBANGA",
              branchcode: "131901365",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BACOLOD, LANAO",
              branchcode: "131902905",
            },
            {
              branchname: "ILIGAN 1",
              branchcode: "131902355",
            },
            {
              branchname: "ILIGAN 3",
              branchcode: "131902359",
            },
            {
              branchname: "ILIGAN 5",
              branchcode: "131902361",
            },
            {
              branchname: "KAUSWAGAN LANAO",
              branchcode: "131902021",
            },
            {
              branchname: "LINAMON",
              branchcode: "131902363",
            },
            {
              branchname: "MAHAYAHAY ILIGAN",
              branchcode: "131902186",
            },
            {
              branchname: "MAIGO",
              branchcode: "131902948",
            },
            {
              branchname: "ROBINSONS ILIGAN SHOWROOM",
              branchcode: "131902099",
            },
            {
              branchname: "SUAREZ",
              branchcode: "131902074",
            },
            {
              branchname: "TAMBACAN",
              branchcode: "131902785",
            },
            {
              branchname: "TOMINOBO",
              branchcode: "131902503",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BAROY",
              branchcode: "131903366",
            },
            {
              branchname: "KOLAMBUGAN",
              branchcode: "131903368",
            },
            {
              branchname: "LALA",
              branchcode: "131903694",
            },
            {
              branchname: "MAGSAYSAY LANAO",
              branchcode: "131903210",
            },
            {
              branchname: "MALINGAO",
              branchcode: "131903782",
            },
            {
              branchname: "MARANDING 1",
              branchcode: "131903370",
            },
            {
              branchname: "MARANDING 2",
              branchcode: "131903985",
            },
            {
              branchname: "MARANDING IPIL IPIL",
              branchcode: "131903613",
            },
            {
              branchname: "MARANDING SANTOL",
              branchcode: "131903092",
            },
            {
              branchname: "SALVADOR, LANAO",
              branchcode: "131903552",
            },
            {
              branchname: "TUBOD 1",
              branchcode: "131903371",
            },
            {
              branchname: "TUBOD 2",
              branchcode: "131903649",
            },
            {
              branchname: "SAN ANTONIO TUBOD",
              branchcode: "131903585",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "ARANAYDO KAPATAGAN",
              branchcode: "131904090",
            },
            {
              branchname: "BALABAGAN",
              branchcode: "131904551",
            },
            {
              branchname: "DAGUAN",
              branchcode: "131904818",
            },
            {
              branchname: "KAPATAGAN",
              branchcode: "131904367",
            },
            {
              branchname: "KAPATAGAN 2",
              branchcode: "131904695",
            },
            {
              branchname: "MALABANG",
              branchcode: "131904877",
            },
            {
              branchname: "MALABANG 2",
              branchcode: "131904581",
            },
            {
              branchname: "MALABANG 3",
              branchcode: "131904733",
            },
            {
              branchname: "MALABANG 4",
              branchcode: "131904904",
            },
            {
              branchname: "MANANAYO",
              branchcode: "131904137",
            },
            {
              branchname: "SAPAD",
              branchcode: "131904270",
            },
            {
              branchname: "SND 1",
              branchcode: "131904986",
            },
            {
              branchname: "SND 2",
              branchcode: "131904746",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "BALO I",
              branchcode: "131905145",
            },
            {
              branchname: "CAMAGUE",
              branchcode: "131905847",
            },
            {
              branchname: "MALUTLUT",
              branchcode: "131905091",
            },
            {
              branchname: "MARAWI",
              branchcode: "131905971",
            },
            {
              branchname: "MATAMPAY MARAWI",
              branchcode: "131905539",
            },
            {
              branchname: "MSU MARAWI",
              branchcode: "131905251",
            },
            {
              branchname: "SAGUIARAN",
              branchcode: "131905557",
            },
            {
              branchname: "WEST POBLACION BALO I",
              branchcode: "131905522",
            },
            {
              branchname: "PANTAR LANAO",
              branchcode: "131905588",
            },
            {
              branchname: "ML SAPADAN MARAWI",
              branchcode: "131905636",
            },
            {
              branchname: "ML SADUC MARAWI",
              branchcode: "131905655",
            },
             {
              branchname: "ML MARANTAO",
              branchcode: "131905635",
            },
          ],
        },
      ],
    },
    {
      region: "ZASURMIS REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CLARIN",
              branchcode: "132001882",
            },
            {
              branchname: "DABA",
              branchcode: "132001214",
            },
            {
              branchname: "JIMENEZ",
              branchcode: "132001465",
            },
            {
              branchname: "JIMENEZ 2",
              branchcode: "132001819",
            },
            {
              branchname: "LAM AN",
              branchcode: "132001130",
            },
            {
              branchname: "MANABAY",
              branchcode: "132001151",
            },
            {
              branchname: "MANINGCOL",
              branchcode: "132001682",
            },
            {
              branchname: "OZAMIS 1",
              branchcode: "132001469",
            },
            {
              branchname: "OZAMIS 3",
              branchcode: "132001472",
            },
            {
              branchname: "OZAMIS 4",
              branchcode: "132001497",
            },
            {
              branchname: "OZAMIS 5",
              branchcode: "132001665",
            },
            {
              branchname: "OZAMIZ 2",
              branchcode: "132001470",
            },
            {
              branchname: "OZAMIZ 6",
              branchcode: "132001913",
            },
            {
              branchname: "PANAON",
              branchcode: "132001259",
            },
            {
              branchname: "SINACABAN",
              branchcode: "132001826",
            },
            {
              branchname: "TUDELA",
              branchcode: "132001474",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "B. AQUINO",
              branchcode: "132002690",
            },
            {
              branchname: "DANLUGAN",
              branchcode: "132002526",
            },
            {
              branchname: "DAO PAGADIAN",
              branchcode: "132002215",
            },
            {
              branchname: "GAISANO MALL PAGADIAN",
              branchcode: "132002568",
            },
            {
              branchname: "LUMBIA PAGADIAN",
              branchcode: "132002219",
            },
            {
              branchname: "PAGADIAN 1",
              branchcode: "132002481",
            },
            {
              branchname: "PAGADIAN 3",
              branchcode: "132002484",
            },
            {
              branchname: "PAGADIAN 4",
              branchcode: "132002485",
            },
            {
              branchname: "PAGADIAN 6",
              branchcode: "132002684",
            },
            {
              branchname: "PAGADIAN 7",
              branchcode: "132002759",
            },
            {
              branchname: "RIZAL PAGADIAN",
              branchcode: "132002734",
            },
            {
              branchname: "STO NINO TUKURAN",
              branchcode: "132002212",
            },
            {
              branchname: "TIGUMA PAGADIAN",
              branchcode: "132002241",
            },
            {
              branchname: "TUKURAN",
              branchcode: "132002840",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "DUMINGAG",
              branchcode: "132003984",
            },
            {
              branchname: "JOSEFINA",
              branchcode: "132003750",
            },
            {
              branchname: "MAHAYAG",
              branchcode: "132003691",
            },
            {
              branchname: "MIDSALIP",
              branchcode: "132003482",
            },
            {
              branchname: "MOLAVE 1",
              branchcode: "132003477",
            },
            {
              branchname: "MOLAVE 2",
              branchcode: "132003478",
            },
            {
              branchname: "MOLAVE 3",
              branchcode: "132003763",
            },
            {
              branchname: "MOLAVE RIZAL",
              branchcode: "132003115",
            },
            {
              branchname: "QUEZON MOLAVE",
              branchcode: "132003222",
            },
            {
              branchname: "RAMON MAGSAYSAY",
              branchcode: "132003846",
            },
            {
              branchname: "SOMINOT",
              branchcode: "132003850",
            },
            {
              branchname: "ML SERGIO OSMEÑA",
              branchcode: "132003597",
            },
            {
              branchname: "ML BLANCIA MOLAVE",
              branchcode: "132003676",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BALANGASAN",
              branchcode: "132004075",
            },
            {
              branchname: "DIMATALING",
              branchcode: "132004579",
            },
            {
              branchname: "DINAS",
              branchcode: "132004692",
            },
            {
              branchname: "DON JOSE DINAS",
              branchcode: "132004305",
            },
            {
              branchname: "DUMALINAO",
              branchcode: "132004476",
            },
            {
              branchname: "GUIPOS",
              branchcode: "132004973",
            },
            {
              branchname: "MARGOSATUBIG",
              branchcode: "132004480",
            },
            {
              branchname: "PITOGO OZAMIS/PAGADIAN",
              branchcode: "132004486",
            },
            {
              branchname: "PORT ROAD MARGOSATUBIG",
              branchcode: "132004128",
            },
            {
              branchname: "SAN MIGUEL ZASURMIS",
              branchcode: "132004135",
            },
            {
              branchname: "SAN PABLO",
              branchcode: "132004810",
            },
            {
              branchname: "TABINA",
              branchcode: "132004906",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "AURORA",
              branchcode: "132005475",
            },
            {
              branchname: "AURORA 2",
              branchcode: "132005789",
            },
            {
              branchname: "BONIFACIO",
              branchcode: "132005983",
            },
            {
              branchname: "LABANGAN",
              branchcode: "132005596",
            },
            {
              branchname: "PULACAN",
              branchcode: "132005907",
            },
            {
              branchname: "TAMBULIG",
              branchcode: "132005732",
            },
            {
              branchname: "TANGUB",
              branchcode: "132005473",
            },
            {
              branchname: "TANGUB 2",
              branchcode: "132005546",
            },
            {
              branchname: "TANGUB OSMENA",
              branchcode: "132005106",
            },
          ],
        },
      ],
    },
    {
      region: "ZANORTE REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "BONIFACIO DIPOLOG",
              branchcode: "132101230",
            },
            {
              branchname: "CITY CENTRAL MALL DIPOLOG 5",
              branchcode: "132101565",
            },
            {
              branchname: "DIPOLOG 1",
              branchcode: "132101445",
            },
            {
              branchname: "DIPOLOG 2",
              branchcode: "132101447",
            },
            {
              branchname: "DIPOLOG 3",
              branchcode: "132101448",
            },
            {
              branchname: "DIPOLOG 6",
              branchcode: "132101622",
            },
            {
              branchname: "DIPOLOG 7",
              branchcode: "132101960",
            },
            {
              branchname: "HERRERA",
              branchcode: "132101188",
            },
            {
              branchname: "KATIPUNAN",
              branchcode: "132101438",
            },
            {
              branchname: "MABINI DIPOLOG",
              branchcode: "132101382",
            },
            {
              branchname: "OLINGAN",
              branchcode: "132101726",
            },
            {
              branchname: "ML OBAY POLANCO",
              branchcode: "132101396",
            },
            {
              branchname: "PRES. M. ROXAS",
              branchcode: "132101895",
            },
            {
              branchname: "STA FILOMENA",
              branchcode: "132101240",
            },
            {
              branchname: "ML QUEZON DIPOLOG",
              branchcode: "132101580",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "JOSE DALMAN",
              branchcode: "132102672",
            },
            {
              branchname: "LEON B POSTIGO",
              branchcode: "132102025",
            },
            {
              branchname: "MANUKAN",
              branchcode: "132102449",
            },
            {
              branchname: "POBLACION MANUKAN",
              branchcode: "132102280",
            },
            {
              branchname: "POBLACION SALUG",
              branchcode: "132102209",
            },
            {
              branchname: "POBLACION SINDANGAN",
              branchcode: "132102133",
            },
            {
              branchname: "SALUG",
              branchcode: "132102451",
            },
            {
              branchname: "SIAYAN",
              branchcode: "132102081",
            },
            {
              branchname: "SINDANGAN",
              branchcode: "132102452",
            },
            {
              branchname: "SINDANGAN 2",
              branchcode: "132102612",
            },
            {
              branchname: "MAGSAYSAY DIPOLOG",
              branchcode: "132104593",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "DAPITAN",
              branchcode: "132103443",
            },
            {
              branchname: "DAPITAN 2",
              branchcode: "132103545",
            },
            {
              branchname: "DIPOLOG 4",
              branchcode: "132103553",
            },
            {
              branchname: "GLORIA DE DAPITAN",
              branchcode: "132103570",
            },
            {
              branchname: "LAWAAN, ZANORTE",
              branchcode: "132103673",
            },
            {
              branchname: "MINAOG",
              branchcode: "132103052",
            },
            {
              branchname: "MUTIA",
              branchcode: "132103281",
            },
            {
              branchname: "PINAN",
              branchcode: "132103991",
            },
            {
              branchname: "POLO",
              branchcode: "132103513",
            },
            {
              branchname: "SAN PEDRO PULAUAN",
              branchcode: "132103132",
            },
            {
              branchname: "SICAYAB",
              branchcode: "132103250",
            },
            {
              branchname: "TABUK TULAY",
              branchcode: "132103143",
            },
            {
              branchname: "TURNO",
              branchcode: "132103724",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BALIANGAO",
              branchcode: "132104204",
            },
            {
              branchname: "Northern Poblacion Calamba",
              branchcode: "132104854",
            },
            {
              branchname: "D BAN CALAMBA",
              branchcode: "132104442",
            },
            {
              branchname: "LA LIBERTAD, ZANORTE",
              branchcode: "132104535",
            },
            {
              branchname: "MAPANG",
              branchcode: "132104608",
            },
            {
              branchname: "N. PASCUA",
              branchcode: "132104248",
            },
            {
              branchname: "SAPANG DALAGA",
              branchcode: "132104532",
            },
            {
              branchname: "SIBUTAD",
              branchcode: "132104063",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "ALORAN",
              branchcode: "132105982",
            },
            {
              branchname: "ALORAN MIS OCC",
              branchcode: "132105273",
            },
            {
              branchname: "ENERO OROQUIETA",
              branchcode: "132105387",
            },
            {
              branchname: "LANGCANGAN OROQUIETA",
              branchcode: "132105201",
            },
            {
              branchname: "LOPEZ JAENA",
              branchcode: "132105664",
            },
            {
              branchname: "MOBOD OROQUIETA",
              branchcode: "132105509",
            },
            {
              branchname: "OROQUIETA 1",
              branchcode: "132105466",
            },
            {
              branchname: "OROQUIETA 2",
              branchcode: "132105467",
            },
            {
              branchname: "OROQUIETA 3",
              branchcode: "132105536",
            },
            {
              branchname: "PLARIDEL",
              branchcode: "132105450",
            },
            {
              branchname: "POBLACION OROQUIETA",
              branchcode: "132105191",
            },
            {
              branchname: "SOUTHERN PLARIDEL",
              branchcode: "132105066",
            },
            {
              branchname: "TALIC OROQUIETA",
              branchcode: "132105244",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "ML CAPITOL OROQUIETA",
              branchcode: "132106643",
            },
            {
              branchname: "ML TALIC OROQUIETA",
              branchcode: "132106244",
            },
          ],
        },
      ],
    },
    {
      region: "ZAMSIBUGAY REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "DON ANDRES IPIL",
              branchcode: "132201053",
            },
            {
              branchname: "DON PERFECTO",
              branchcode: "132201547",
            },
            {
              branchname: "IPIL 3",
              branchcode: "132201564",
            },
            {
              branchname: "IPIL PUBLIC MARKET",
              branchcode: "132201170",
            },
            {
              branchname: "LOWER TUNGAWAN",
              branchcode: "132201070",
            },
            {
              branchname: "SAN ANTONIO TITAY",
              branchcode: "132201516",
            },
            {
              branchname: "SANITO",
              branchcode: "132201134",
            },
            {
              branchname: "TIRSO BABIERA",
              branchcode: "132201668",
            },
            {
              branchname: "TITAY",
              branchcode: "132201884",
            },
            {
              branchname: "TUNGAWAN",
              branchcode: "132201822",
            },
            {
              branchname: "YOHO",
              branchcode: "132201116",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "ALICIA, ZAMSIBUGAY",
              branchcode: "132202887",
            },
            {
              branchname: "CROSSING STA CLARA",
              branchcode: "132202027",
            },
            {
              branchname: "IPIL 1",
              branchcode: "132202457",
            },
            {
              branchname: "IPIL 2",
              branchcode: "132202464",
            },
            {
              branchname: "KABASALAN 1",
              branchcode: "132202459",
            },
            {
              branchname: "KABASALAN 2",
              branchcode: "132202460",
            },
            {
              branchname: "MABUHAY, ZAMSIBUGAY",
              branchcode: "132202233",
            },
            {
              branchname: "MONCHING",
              branchcode: "132202663",
            },
            {
              branchname: "OLUTANGA",
              branchcode: "132202886",
            },
            {
              branchname: "PAYAO",
              branchcode: "132202034",
            },
            {
              branchname: "RT LIM",
              branchcode: "132202463",
            },
            {
              branchname: "SAGASA",
              branchcode: "132202048",
            },
            {
              branchname: "SIAY DIPOLOG",
              branchcode: "132202888",
            },
            {
              branchname: "SOLAR OLUTANGA",
              branchcode: "132202199",
            },
            {
              branchname: "TALUSAN",
              branchcode: "132202885",
            },
            {
              branchname: "STA CLARA",
              branchcode: "132202591",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BAYOG",
              branchcode: "132203454",
            },
            {
              branchname: "BUUG",
              branchcode: "132203453",
            },
            {
              branchname: "BUUG 2",
              branchcode: "132203524",
            },
            {
              branchname: "BUUG RIZAL",
              branchcode: "132203036",
            },
            {
              branchname: "DIPLAHAN",
              branchcode: "132203610",
            },
            {
              branchname: "DIPLO",
              branchcode: "132203031",
            },
            {
              branchname: "IMELDA",
              branchcode: "132203458",
            },
            {
              branchname: "IMELDA 2",
              branchcode: "132203548",
            },
            {
              branchname: "IMELDA COMPLEX",
              branchcode: "132203218",
            },
            {
              branchname: "KUMALARANG",
              branchcode: "132203611",
            },
            {
              branchname: "LA DICHA",
              branchcode: "132203239",
            },
            {
              branchname: "LAKEWOOD",
              branchcode: "132203683",
            },
            {
              branchname: "MALANGAS",
              branchcode: "132203479",
            },
            {
              branchname: "SAMPOLI B",
              branchcode: "132203044",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BALIGUIAN",
              branchcode: "132204071",
            },
            {
              branchname: "GATAS KALAWIT",
              branchcode: "132204369",
            },
            {
              branchname: "GUTALAC",
              branchcode: "132204455",
            },
            {
              branchname: "IMELDA LABASON",
              branchcode: "132204026",
            },
            {
              branchname: "KALAWIT",
              branchcode: "132204761",
            },
            {
              branchname: "LABASON",
              branchcode: "132204461",
            },
            {
              branchname: "LILOY",
              branchcode: "132204462",
            },
            {
              branchname: "LILOY 2",
              branchcode: "132204606",
            },
            {
              branchname: "SIOCON",
              branchcode: "132204500",
            },
            {
              branchname: "SIOCON 2",
              branchcode: "132204756",
            },
            {
              branchname: "SIRAWAI",
              branchcode: "132204757",
            },
            {
              branchname: "SIRAWAI PROPER",
              branchcode: "132204229",
            },
            {
              branchname: "TAMPILISAN",
              branchcode: "132204630",
            },
            {
              branchname: "ML BAYOG PUBLIC MARKET",
              branchcode: "132204567",
            },
          ],
        },
      ],
    },
    {
      region: "ZAMBASULTA REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CALIXTO",
              branchcode: "132301902",
            },
            {
              branchname: "CAMPANER URDANETA, ZAMBOANGA",
              branchcode: "132301487",
            },
            {
              branchname: "JALDON",
              branchcode: "132301489",
            },
            {
              branchname: "LA PURISIMA",
              branchcode: "132301490",
            },
            {
              branchname: "MERCADO",
              branchcode: "132301055",
            },
            {
              branchname: "P. LORENZO",
              branchcode: "132301491",
            },
            {
              branchname: "PILAR, ZAMBOANGA",
              branchcode: "132301586",
            },
            {
              branchname: "RADJA SOLAIMAN",
              branchcode: "132301521",
            },
            {
              branchname: "SAN JOSE PANIGAYAN",
              branchcode: "132301184",
            },
            {
              branchname: "TOMAS CLAUDIO",
              branchcode: "132301957",
            },
            {
              branchname: "VALDEROSA",
              branchcode: "132301815",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "MAMPANG",
              branchcode: "132302411",
            },
            {
              branchname: "MORNING BREEZE",
              branchcode: "132302060",
            },
            {
              branchname: "PASONANCA",
              branchcode: "132302183",
            },
            {
              branchname: "STA. CATALINA, ZAMBOANGA",
              branchcode: "132302921",
            },
            {
              branchname: "STA. MARIA ROAD",
              branchcode: "132302065",
            },
            {
              branchname: "STA. MARIA, ZAMBOANGA",
              branchcode: "132302495",
            },
            {
              branchname: "TALON TALON",
              branchcode: "132302079",
            },
            {
              branchname: "TUGBUNGAN",
              branchcode: "132302587",
            },
            {
              branchname: "TUMAGA",
              branchcode: "132302506",
            },
            {
              branchname: "SAN MIGUEL AYALA",
              branchcode: "132302615",
            },
            {
              branchname: "YUBENCO TETUAN",
              branchcode: "132302287",
            },
            {
              branchname: "STA. BARBARA, ZAMBOANGA",
              branchcode: "132301589",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ML DATU BAGUINDA PUTIH",
              branchcode: "132303831",
            },
            {
              branchname: "LABUAN",
              branchcode: "132303940",
            },
            {
              branchname: "RECODO",
              branchcode: "132303493",
            },
            {
              branchname: "SAN JOSE GUSU",
              branchcode: "132303992",
            },
            {
              branchname: "SIBUCO",
              branchcode: "132303084",
            },
            {
              branchname: "SINUNUC",
              branchcode: "132303980",
            },
            {
              branchname: "SOUTHERN CITY COLLEGES",
              branchcode: "132303681",
            },
            {
              branchname: "UPPER CALARIAN",
              branchcode: "132303713",
            },
            {
              branchname: "SAN ROQUE, ZAMBOANGA",
              branchcode: "132302830",
            },
            {
              branchname: "GOV RAMOS",
              branchcode: "132302041",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "BOUGAINVILLA",
              branchcode: "132304283",
            },
            {
              branchname: "CULIANAN",
              branchcode: "132304146",
            },
            {
              branchname: "CURUAN",
              branchcode: "132304942",
            },
            {
              branchname: "DIVISORIA ZAMBOANGA",
              branchcode: "132304104",
            },
            {
              branchname: "GUIWAN, ZAMBOANGA",
              branchcode: "132304488",
            },
            {
              branchname: "GUIWAN 2",
              branchcode: "132304979",
            },
            {
              branchname: "MERCEDES, ZAMBOANGA",
              branchcode: "132304282",
            },
            {
              branchname: "PUTIK 2",
              branchcode: "132304776",
            },
            {
              branchname: "SANGALI",
              branchcode: "132304494",
            },
            {
              branchname: "SANGALI HI WAY",
              branchcode: "132304325",
            },
            {
              branchname: "VITALI",
              branchcode: "132304496",
            },
            {
              branchname: "YUBENCO",
              branchcode: "132304554",
            },
            {
              branchname: "MIALIM",
              branchcode: "132303147",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "AGUADA",
              branchcode: "132305639",
            },
            {
              branchname: "BASILAN",
              branchcode: "132305498",
            },
            {
              branchname: "BASILAN 3",
              branchcode: "132305910",
            },
            {
              branchname: "EASTSIDE",
              branchcode: "132305100",
            },
            {
              branchname: "ISABELA PROPER",
              branchcode: "132305119",
            },
            {
              branchname: "MALUSO",
              branchcode: "132305076",
            },
            {
              branchname: "N.VALDEROSA",
              branchcode: "132305623",
            },
            {
              branchname: "ROXAS, ZAMBOANGA",
              branchcode: "132305531",
            },
            {
              branchname: "STA. BARBARA MALAMAWI",
              branchcode: "132305067",
            },
            {
              branchname: "TOWNSITE BASILAN",
              branchcode: "132305534",
            },
             {
              branchname: "ML Sumagdang",
              branchcode: "132305601",
            },
          ],
        },
        {
          area: "AREA F",
          BRANCHES: [
            {
              branchname: "SANGA SANGA",
              branchcode: "132306162",
            },
             {
              branchname: "LAMITAN",
              branchcode: "132305499",
            },
            {
              branchname: "LAMITAN 2",
              branchcode: "132305735",
            },
            {
              branchname: "QUEZON BOULEVARD",
              branchcode: "132305571",
            },
             {
              branchname: "LIMO OK",
              branchcode: "132305952",
            },
            {
              branchname: "ML MALIGAYA",
              branchcode: "132306614",
            },
            {
              branchname: "ML OVAL SITE",
              branchcode: "132306631",
            },
          ],
        },
        {
          area: "AREA G",
          BRANCHES: [
            {
              branchname: "STO. NINO",
              branchcode: "132307337",
            },
            {
              branchname: "CANELAR",
              branchcode: "132307599",
            },
             {
              branchname: "CAWA CAWA",
              branchcode: "132307542",
            },
            {
              branchname: "MARINA",
              branchcode: "132307040",
            },
            {
              branchname: "SCOT JOLO",
              branchcode: "132307082",
            },
            {
              branchname: "BUSBUS",
              branchcode: "132307922",
            },
             {
              branchname: "SANCHEZ",
              branchcode: "132307923",
            },
            {
              branchname: "GOVERNOR CAMINS",
              branchcode: "132307576",
            },
          ],
        },
        {
          area: "AREA H",
          BRANCHES: [
            {
              branchname: "SITANGKAI",
              branchcode: "132308109",
            },
            {
              branchname: "SANGA SANGA",
              branchcode: "132308162",
            },
             {
              branchname: "BATU BATU",
              branchcode: "132308211",
            },
            {
              branchname: "TAWI TAWI 1",
              branchcode: "132308501",
            },
            {
              branchname: "TAWI TAWI 2",
              branchcode: "132308502",
            },
            {
              branchname: "TAWI TAWI 3",
              branchcode: "132308658",
            },
             {
              branchname: "TAWI TAWI 4",
              branchcode: "132308814",
            },
          ],
        },
      ],
    },
    {
      region: "SOCSK REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "CANNERY",
              branchcode: "132401600",
            },
            {
              branchname: "KCC MARBEL JEWELLERS",
              branchcode: "132401032",
            },
            {
              branchname: "MARBEL 2",
              branchcode: "132401397",
            },
            {
              branchname: "MARBEL 3",
              branchcode: "132401398",
            },
            {
              branchname: "MARBEL 4",
              branchcode: "132401444",
            },
            {
              branchname: "MEGALAND",
              branchcode: "132401261",
            },
            {
              branchname: "MORROW",
              branchcode: "132401030",
            },
            {
              branchname: "POBLACION POLOMOLOK",
              branchcode: "132401125",
            },
            {
              branchname: "POBLACION TUPI",
              branchcode: "132401768",
            },
            {
              branchname: "POLOMOLOK 2",
              branchcode: "132401863",
            },
            {
              branchname: "POLOMOLOK HIGHWAY",
              branchcode: "132401725",
            },
            {
              branchname: "TAMPAKAN",
              branchcode: "132401625",
            },
            {
              branchname: "TUPI",
              branchcode: "132401404",
            },
            {
              branchname: "ML BALMORES",
              branchcode: "132401660",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "BANGA",
              branchcode: "132402175",
            },
            {
              branchname: "BANGA 2 POBLACION",
              branchcode: "132402126",
            },
            {
              branchname: "LAKE SEBU",
              branchcode: "132402742",
            },
            {
              branchname: "NORALA",
              branchcode: "132402560",
            },
            {
              branchname: "NORALA HIGHWAY",
              branchcode: "132402139",
            },
            {
              branchname: "STO NINO NATIONAL HWAY",
              branchcode: "132402318",
            },
            {
              branchname: "STO NINO SOCSKSARGEN",
              branchcode: "132402399",
            },
            {
              branchname: "STO. NINO PUBLIC MARKET",
              branchcode: "132402714",
            },
            {
              branchname: "SURALLAH",
              branchcode: "132402400",
            },
            {
              branchname: "SURALLAH 2",
              branchcode: "132402401",
            },
            {
              branchname: "TBOLI",
              branchcode: "132402667",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "BULUAN POBLACION",
              branchcode: "132403505",
            },
            {
              branchname: "COLUMBIO",
              branchcode: "132403727",
            },
            {
              branchname: "GENSAN DRIVE MARBEL",
              branchcode: "132403697",
            },
            {
              branchname: "LAMBAYONG",
              branchcode: "132403393",
            },
            {
              branchname: "LUTAYAN",
              branchcode: "132403265",
            },
            {
              branchname: "LUTAYAN FOR REMOVAL",
              branchcode: "132403265",
            },
            {
              branchname: "POBLACION LAMBAYONG",
              branchcode: "132403198",
            },
            {
              branchname: "PRES. QUIRINO",
              branchcode: "132403903",
            },
            {
              branchname: "SAN JOSE KORONADAL",
              branchcode: "132403529",
            },
            {
              branchname: "TACURONG 1",
              branchcode: "132403402",
            },
            {
              branchname: "TACURONG 2",
              branchcode: "132403403",
            },
            {
              branchname: "TACURONG 3",
              branchcode: "132403561",
            },
            {
              branchname: "TACURONG HIGHWAY",
              branchcode: "132403047",
            },
            {
              branchname: "TANTANGAN",
              branchcode: "132403064",
            },
            {
              branchname: "ZONE 2 MARBEL",
              branchcode: "132403142",
            },
            {
              branchname: "ML TACURONG NEW ISABELA",
              branchcode: "132403632",
            },
            {
              branchname: "ML CENTRALA SURALLAH",
              branchcode: "132403644",
            },
          ],
        },
        {
          area: "AREA D",
          BRANCHES: [
            {
              branchname: "AMPATUAN",
              branchcode: "132404205",
            },
            {
              branchname: "BAGUMBAYAN",
              branchcode: "132404749",
            },
            {
              branchname: "BARRIO MALINIS SHARIFF AGUAK",
              branchcode: "132404520",
            },
            {
              branchname: "ESPERANZA",
              branchcode: "132404187",
            },
            {
              branchname: "ISULAN",
              branchcode: "132404391",
            },
            {
              branchname: "ISULAN 2",
              branchcode: "132404958",
            },
            {
              branchname: "ISULAN HIGHWAY",
              branchcode: "132404017",
            },
            {
              branchname: "ISULAN KALAWAG",
              branchcode: "132404680",
            },
            {
              branchname: "KAURAN AMPATUAN",
              branchcode: "132404508",
            },
            {
              branchname: "LABU LABU",
              branchcode: "132404267",
            },
            {
              branchname: "MOLAVE ESPERANZA",
              branchcode: "132404456",
            },
            {
              branchname: "POBLACION SHARIFF AGUAK",
              branchcode: "132404189",
            },
            {
              branchname: "SHARIFF AGUAK",
              branchcode: "132404020",
            },
            {
              branchname: "SHARIFF AGUAK MARKET",
              branchcode: "132404107",
            },
            {
              branchname: "ML SHARIFF AGUAK HIGHWAY",
              branchcode: "132404653",
            },
          ],
        },
        {
          area: "AREA E",
          BRANCHES: [
            {
              branchname: "ML BULUAN",
              branchcode: "132405446",
            },
          ],
        },
      ],
    },
    {
      region: "BUKIDNON REGION",
      areaSet: [
        {
          area: "AREA A",
          BRANCHES: [
            {
              branchname: "DAMULOG",
              branchcode: "131806262",
            },
            {
              branchname: "DANGCAGAN",
              branchcode: "131808633",
            },
            {
              branchname: "VALENCIA",
              branchcode: "131808342",
            },
            {
              branchname: "MARAMAG",
              branchcode: "131808339",
            },
            {
              branchname: "DON CARLOS",
              branchcode: "131808528",
            },
            {
              branchname: "KADINGILAN",
              branchcode: "131808278",
            },
            {
              branchname: "KALILANGAN",
              branchcode: "131808881",
            },
            {
              branchname: "KIBAWE",
              branchcode: "131808978",
            },
            {
              branchname: "PANGANTUCAN",
              branchcode: "131808263",
            },
            {
              branchname: "QUEZON BUKIDNON",
              branchcode: "131808880",
            },
            {
              branchname: "VALENCIA SOUTH HIWAY",
              branchcode: "131808097",
            },
            {
              branchname: "WAO",
              branchcode: "131808627",
            },
          ],
        },
        {
          area: "AREA B",
          BRANCHES: [
            {
              branchname: "VALENCIA QUEZON",
              branchcode: "131807083",
            },
            {
              branchname: "SAN JOSE BUKIDNON",
              branchcode: "133002563",
            },
            {
              branchname: "SAN FERNANDO BUKIDNON",
              branchcode: "131807523",
            },
            {
              branchname: "CABANGLASAN",
              branchcode: "131807530",
            },
            {
              branchname: "LANTAPAN",
              branchcode: "131806268",
            },
            {
              branchname: "AGLAYAN",
              branchcode: "131806790",
            },
            {
              branchname: "BAGONTAAS",
              branchcode: "131808549",
            },
            {
              branchname: "MALAYBALAY",
              branchcode: "131807338",
            },
            {
              branchname: "VALENCIA 2",
              branchcode: "131808604",
            },
            {
              branchname: "ML BATANGAN VALENCIA",
              branchcode: "133002607",
            },
          ],
        },
        {
          area: "AREA C",
          BRANCHES: [
            {
              branchname: "ALAE",
              branchcode: "131806019",
            },
            {
              branchname: "DAMILAG",
              branchcode: "131804555",
            },
            {
              branchname: "AGUSAN CANYON",
              branchcode: "131806871",
            },
            {
              branchname: "MANOLO FORTICH",
              branchcode: "131806510",
            },
            {
              branchname: "LIBONA",
              branchcode: "133003578",
            },
            {
              branchname: "KISOLON",
              branchcode: "131807243",
            },
            {
              branchname: "MALAYBALAY 2",
              branchcode: "131807550",
            },
            {
              branchname: "MALAYBALAY NORTH HIWAY",
              branchcode: "131807098",
            },
            {
              branchname: "IMPASUGONG",
              branchcode: "131807562",
            },
          ],
        },
      ],
    },
  ],
};

export default ZONES;
